{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0800" },
      "geometry": { "type": "Point", "coordinates": [130.84273, -12.46145] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0810" },
      "geometry": { "type": "Point", "coordinates": [130.87721, -12.36666] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0812" },
      "geometry": { "type": "Point", "coordinates": [130.91096, -12.3826] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0820" },
      "geometry": { "type": "Point", "coordinates": [130.85649, -12.43163] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0822" },
      "geometry": { "type": "Point", "coordinates": [132.35677, -13.09] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0828" },
      "geometry": { "type": "Point", "coordinates": [130.93921, -12.4267] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0829" },
      "geometry": { "type": "Point", "coordinates": [130.99872, -12.45057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0830" },
      "geometry": { "type": "Point", "coordinates": [131.05146, -12.4057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0832" },
      "geometry": { "type": "Point", "coordinates": [130.99753, -12.50837] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0834" },
      "geometry": { "type": "Point", "coordinates": [131.02235, -12.54939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0835" },
      "geometry": { "type": "Point", "coordinates": [131.0517, -12.48323] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0836" },
      "geometry": { "type": "Point", "coordinates": [131.13961, -12.55246] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0837" },
      "geometry": { "type": "Point", "coordinates": [131.14999, -12.742] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0838" },
      "geometry": { "type": "Point", "coordinates": [131.01562, -12.72114] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0839" },
      "geometry": { "type": "Point", "coordinates": [131.03945, -12.51956] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0840" },
      "geometry": { "type": "Point", "coordinates": [130.43832, -12.71211] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0841" },
      "geometry": { "type": "Point", "coordinates": [130.95913, -12.81168] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0845" },
      "geometry": { "type": "Point", "coordinates": [131.047, -13.08804] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0846" },
      "geometry": { "type": "Point", "coordinates": [131.15726, -13.16237] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0847" },
      "geometry": { "type": "Point", "coordinates": [131.79822, -13.82139] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0850" },
      "geometry": { "type": "Point", "coordinates": [132.27005, -14.42946] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0852" },
      "geometry": { "type": "Point", "coordinates": [132.95432, -17.23178] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0853" },
      "geometry": { "type": "Point", "coordinates": [132.38914, -14.5132] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0854" },
      "geometry": { "type": "Point", "coordinates": [136.3084, -16.07404] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0860" },
      "geometry": { "type": "Point", "coordinates": [134.18834, -19.65552] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0862" },
      "geometry": { "type": "Point", "coordinates": [135.94063, -17.87567] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0870" },
      "geometry": { "type": "Point", "coordinates": [133.83437, -23.72181] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0872" },
      "geometry": { "type": "Point", "coordinates": [132.23104, -22.79634] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0873" },
      "geometry": { "type": "Point", "coordinates": [133.82976, -23.77216] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0874" },
      "geometry": { "type": "Point", "coordinates": [133.88299, -23.68955] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0875" },
      "geometry": { "type": "Point", "coordinates": [133.84769, -23.70282] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0880" },
      "geometry": { "type": "Point", "coordinates": [136.31183, -12.36232] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0885" },
      "geometry": { "type": "Point", "coordinates": [136.42045, -13.85145] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "0886" },
      "geometry": { "type": "Point", "coordinates": [132.83777, -12.67279] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2000" },
      "geometry": { "type": "Point", "coordinates": [151.20666, -33.86994] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2007" },
      "geometry": { "type": "Point", "coordinates": [151.19808, -33.87952] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2008" },
      "geometry": { "type": "Point", "coordinates": [151.19727, -33.88859] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2009" },
      "geometry": { "type": "Point", "coordinates": [151.19346, -33.86799] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2010" },
      "geometry": { "type": "Point", "coordinates": [151.21698, -33.88141] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2011" },
      "geometry": { "type": "Point", "coordinates": [151.22575, -33.86979] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2015" },
      "geometry": { "type": "Point", "coordinates": [151.19341, -33.90601] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2016" },
      "geometry": { "type": "Point", "coordinates": [151.20525, -33.89203] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2017" },
      "geometry": { "type": "Point", "coordinates": [151.20858, -33.90243] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2018" },
      "geometry": { "type": "Point", "coordinates": [151.20743, -33.92499] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2019" },
      "geometry": { "type": "Point", "coordinates": [151.20774, -33.95056] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2020" },
      "geometry": { "type": "Point", "coordinates": [151.18216, -33.94258] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2021" },
      "geometry": { "type": "Point", "coordinates": [151.23129, -33.89265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2022" },
      "geometry": { "type": "Point", "coordinates": [151.24938, -33.89465] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2023" },
      "geometry": { "type": "Point", "coordinates": [151.25632, -33.88027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2024" },
      "geometry": { "type": "Point", "coordinates": [151.26095, -33.90367] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2025" },
      "geometry": { "type": "Point", "coordinates": [151.24505, -33.88737] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2026" },
      "geometry": { "type": "Point", "coordinates": [151.2739, -33.89025] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2027" },
      "geometry": { "type": "Point", "coordinates": [151.24267, -33.87162] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2028" },
      "geometry": { "type": "Point", "coordinates": [151.24269, -33.87636] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2029" },
      "geometry": { "type": "Point", "coordinates": [151.26813, -33.87241] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2030" },
      "geometry": { "type": "Point", "coordinates": [151.27801, -33.85977] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2031" },
      "geometry": { "type": "Point", "coordinates": [151.24461, -33.91456] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2032" },
      "geometry": { "type": "Point", "coordinates": [151.22767, -33.92568] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2033" },
      "geometry": { "type": "Point", "coordinates": [151.222, -33.91433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2034" },
      "geometry": { "type": "Point", "coordinates": [151.25603, -33.92408] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2035" },
      "geometry": { "type": "Point", "coordinates": [151.23604, -33.94428] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2036" },
      "geometry": { "type": "Point", "coordinates": [151.23893, -33.97043] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2037" },
      "geometry": { "type": "Point", "coordinates": [151.18537, -33.8776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2038" },
      "geometry": { "type": "Point", "coordinates": [151.17153, -33.87982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2039" },
      "geometry": { "type": "Point", "coordinates": [151.17386, -33.86464] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2040" },
      "geometry": { "type": "Point", "coordinates": [151.15574, -33.8779] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2041" },
      "geometry": { "type": "Point", "coordinates": [151.1828, -33.85766] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2042" },
      "geometry": { "type": "Point", "coordinates": [151.1785, -33.89787] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2043" },
      "geometry": { "type": "Point", "coordinates": [151.18557, -33.90207] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2044" },
      "geometry": { "type": "Point", "coordinates": [151.16841, -33.92211] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2045" },
      "geometry": { "type": "Point", "coordinates": [151.14196, -33.87582] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2046" },
      "geometry": { "type": "Point", "coordinates": [151.13098, -33.86087] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2047" },
      "geometry": { "type": "Point", "coordinates": [151.15187, -33.85224] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2048" },
      "geometry": { "type": "Point", "coordinates": [151.16576, -33.89305] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2049" },
      "geometry": { "type": "Point", "coordinates": [151.15244, -33.89496] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2050" },
      "geometry": { "type": "Point", "coordinates": [151.18165, -33.88805] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2060" },
      "geometry": { "type": "Point", "coordinates": [151.20514, -33.8382] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2061" },
      "geometry": { "type": "Point", "coordinates": [151.21409, -33.84769] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2062" },
      "geometry": { "type": "Point", "coordinates": [151.21475, -33.82291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2063" },
      "geometry": { "type": "Point", "coordinates": [151.21798, -33.81156] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2064" },
      "geometry": { "type": "Point", "coordinates": [151.18672, -33.81036] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2065" },
      "geometry": { "type": "Point", "coordinates": [151.19396, -33.82558] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2066" },
      "geometry": { "type": "Point", "coordinates": [151.1592, -33.8145] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2067" },
      "geometry": { "type": "Point", "coordinates": [151.17985, -33.79564] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2068" },
      "geometry": { "type": "Point", "coordinates": [151.20701, -33.8008] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2069" },
      "geometry": { "type": "Point", "coordinates": [151.20462, -33.78391] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2070" },
      "geometry": { "type": "Point", "coordinates": [151.17152, -33.77461] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2071" },
      "geometry": { "type": "Point", "coordinates": [151.16677, -33.76308] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2072" },
      "geometry": { "type": "Point", "coordinates": [151.15426, -33.7547] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2073" },
      "geometry": { "type": "Point", "coordinates": [151.13734, -33.75284] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2074" },
      "geometry": { "type": "Point", "coordinates": [151.14014, -33.7071] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2075" },
      "geometry": { "type": "Point", "coordinates": [151.16859, -33.72205] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2076" },
      "geometry": { "type": "Point", "coordinates": [151.1179, -33.71543] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2077" },
      "geometry": { "type": "Point", "coordinates": [151.10209, -33.68136] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2079" },
      "geometry": { "type": "Point", "coordinates": [151.12792, -33.66127] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2080" },
      "geometry": { "type": "Point", "coordinates": [151.13484, -33.64793] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2081" },
      "geometry": { "type": "Point", "coordinates": [151.15296, -33.59885] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2082" },
      "geometry": { "type": "Point", "coordinates": [151.13883, -33.57835] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2083" },
      "geometry": { "type": "Point", "coordinates": [151.19436, -33.55649] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2084" },
      "geometry": { "type": "Point", "coordinates": [151.22649, -33.64077] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2085" },
      "geometry": { "type": "Point", "coordinates": [151.20788, -33.73125] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2086" },
      "geometry": { "type": "Point", "coordinates": [151.22328, -33.74851] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2087" },
      "geometry": { "type": "Point", "coordinates": [151.21538, -33.76826] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2088" },
      "geometry": { "type": "Point", "coordinates": [151.24664, -33.83049] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2089" },
      "geometry": { "type": "Point", "coordinates": [151.21853, -33.83658] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2090" },
      "geometry": { "type": "Point", "coordinates": [151.22616, -33.8326] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2092" },
      "geometry": { "type": "Point", "coordinates": [151.24153, -33.7924] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2093" },
      "geometry": { "type": "Point", "coordinates": [151.26327, -33.79339] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2094" },
      "geometry": { "type": "Point", "coordinates": [151.27515, -33.79373] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2095" },
      "geometry": { "type": "Point", "coordinates": [151.28957, -33.80256] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2096" },
      "geometry": { "type": "Point", "coordinates": [151.28574, -33.77467] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2097" },
      "geometry": { "type": "Point", "coordinates": [151.29368, -33.73461] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2099" },
      "geometry": { "type": "Point", "coordinates": [151.26124, -33.73863] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2100" },
      "geometry": { "type": "Point", "coordinates": [151.25207, -33.76321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2101" },
      "geometry": { "type": "Point", "coordinates": [151.26672, -33.69843] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2102" },
      "geometry": { "type": "Point", "coordinates": [151.29386, -33.6866] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2103" },
      "geometry": { "type": "Point", "coordinates": [151.30284, -33.67566] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2104" },
      "geometry": { "type": "Point", "coordinates": [151.28814, -33.66078] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2105" },
      "geometry": { "type": "Point", "coordinates": [151.28451, -33.64198] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2106" },
      "geometry": { "type": "Point", "coordinates": [151.31442, -33.65749] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2107" },
      "geometry": { "type": "Point", "coordinates": [151.32298, -33.63119] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2108" },
      "geometry": { "type": "Point", "coordinates": [151.31843, -33.59812] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2110" },
      "geometry": { "type": "Point", "coordinates": [151.15187, -33.83325] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2111" },
      "geometry": { "type": "Point", "coordinates": [151.1292, -33.83078] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2112" },
      "geometry": { "type": "Point", "coordinates": [151.1065, -33.81194] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2113" },
      "geometry": { "type": "Point", "coordinates": [151.1268, -33.78873] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2114" },
      "geometry": { "type": "Point", "coordinates": [151.08658, -33.80748] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2115" },
      "geometry": { "type": "Point", "coordinates": [151.0619, -33.80787] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2116" },
      "geometry": { "type": "Point", "coordinates": [151.03965, -33.81219] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2117" },
      "geometry": { "type": "Point", "coordinates": [151.04218, -33.79612] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2118" },
      "geometry": { "type": "Point", "coordinates": [151.04453, -33.77799] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2119" },
      "geometry": { "type": "Point", "coordinates": [151.06404, -33.75232] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2120" },
      "geometry": { "type": "Point", "coordinates": [151.07379, -33.72513] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2121" },
      "geometry": { "type": "Point", "coordinates": [151.08302, -33.76669] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2122" },
      "geometry": { "type": "Point", "coordinates": [151.09166, -33.78268] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2125" },
      "geometry": { "type": "Point", "coordinates": [151.03351, -33.74614] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2126" },
      "geometry": { "type": "Point", "coordinates": [151.04731, -33.72199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2127" },
      "geometry": { "type": "Point", "coordinates": [151.06727, -33.8393] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2128" },
      "geometry": { "type": "Point", "coordinates": [151.04758, -33.83251] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2130" },
      "geometry": { "type": "Point", "coordinates": [151.13768, -33.89367] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2131" },
      "geometry": { "type": "Point", "coordinates": [151.1252, -33.88971] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2132" },
      "geometry": { "type": "Point", "coordinates": [151.11551, -33.88078] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2133" },
      "geometry": { "type": "Point", "coordinates": [151.10418, -33.89763] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2134" },
      "geometry": { "type": "Point", "coordinates": [151.10494, -33.87812] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2135" },
      "geometry": { "type": "Point", "coordinates": [151.08275, -33.87905] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2136" },
      "geometry": { "type": "Point", "coordinates": [151.08109, -33.89368] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2137" },
      "geometry": { "type": "Point", "coordinates": [151.1029, -33.85436] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2138" },
      "geometry": { "type": "Point", "coordinates": [151.08979, -33.83842] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2140" },
      "geometry": { "type": "Point", "coordinates": [151.07464, -33.86482] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2141" },
      "geometry": { "type": "Point", "coordinates": [151.04753, -33.86787] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2142" },
      "geometry": { "type": "Point", "coordinates": [151.01996, -33.83451] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2143" },
      "geometry": { "type": "Point", "coordinates": [151.02818, -33.88734] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2144" },
      "geometry": { "type": "Point", "coordinates": [151.02496, -33.85598] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2145" },
      "geometry": { "type": "Point", "coordinates": [150.94915, -33.81688] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2146" },
      "geometry": { "type": "Point", "coordinates": [150.95252, -33.79269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2147" },
      "geometry": { "type": "Point", "coordinates": [150.93513, -33.76499] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2148" },
      "geometry": { "type": "Point", "coordinates": [150.89545, -33.77993] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2150" },
      "geometry": { "type": "Point", "coordinates": [151.00618, -33.8155] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2151" },
      "geometry": { "type": "Point", "coordinates": [151.01399, -33.78597] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2152" },
      "geometry": { "type": "Point", "coordinates": [150.99264, -33.78763] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2153" },
      "geometry": { "type": "Point", "coordinates": [150.97854, -33.75876] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2154" },
      "geometry": { "type": "Point", "coordinates": [150.99896, -33.72525] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2155" },
      "geometry": { "type": "Point", "coordinates": [150.94497, -33.69347] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2156" },
      "geometry": { "type": "Point", "coordinates": [150.96807, -33.64962] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2157" },
      "geometry": { "type": "Point", "coordinates": [151.03589, -33.53783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2158" },
      "geometry": { "type": "Point", "coordinates": [151.04596, -33.67203] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2159" },
      "geometry": { "type": "Point", "coordinates": [151.08283, -33.58967] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2160" },
      "geometry": { "type": "Point", "coordinates": [150.98503, -33.83681] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2161" },
      "geometry": { "type": "Point", "coordinates": [150.97664, -33.8546] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2162" },
      "geometry": { "type": "Point", "coordinates": [151.0021, -33.88445] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2163" },
      "geometry": { "type": "Point", "coordinates": [150.97555, -33.88566] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2164" },
      "geometry": { "type": "Point", "coordinates": [150.91105, -33.84537] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2165" },
      "geometry": { "type": "Point", "coordinates": [150.94698, -33.87206] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2166" },
      "geometry": { "type": "Point", "coordinates": [150.9432, -33.89391] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2167" },
      "geometry": { "type": "Point", "coordinates": [150.8885, -33.97415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2168" },
      "geometry": { "type": "Point", "coordinates": [150.87809, -33.91584] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2170" },
      "geometry": { "type": "Point", "coordinates": [150.92389, -33.93212] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2171" },
      "geometry": { "type": "Point", "coordinates": [150.8354, -33.92076] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2172" },
      "geometry": { "type": "Point", "coordinates": [150.97983, -33.9636] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2173" },
      "geometry": { "type": "Point", "coordinates": [150.92457, -34.05544] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2174" },
      "geometry": { "type": "Point", "coordinates": [150.85696, -33.96149] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2175" },
      "geometry": { "type": "Point", "coordinates": [150.84959, -33.83618] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2176" },
      "geometry": { "type": "Point", "coordinates": [150.88291, -33.87234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2177" },
      "geometry": { "type": "Point", "coordinates": [150.88623, -33.89222] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2178" },
      "geometry": { "type": "Point", "coordinates": [150.80646, -33.86817] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2179" },
      "geometry": { "type": "Point", "coordinates": [150.79627, -33.95495] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2190" },
      "geometry": { "type": "Point", "coordinates": [151.0571, -33.90258] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2191" },
      "geometry": { "type": "Point", "coordinates": [151.08535, -33.90393] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2192" },
      "geometry": { "type": "Point", "coordinates": [151.08996, -33.918] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2193" },
      "geometry": { "type": "Point", "coordinates": [151.11925, -33.90786] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2194" },
      "geometry": { "type": "Point", "coordinates": [151.10395, -33.91265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2195" },
      "geometry": { "type": "Point", "coordinates": [151.07057, -33.92074] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2196" },
      "geometry": { "type": "Point", "coordinates": [151.06006, -33.92952] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2197" },
      "geometry": { "type": "Point", "coordinates": [150.99662, -33.89843] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2198" },
      "geometry": { "type": "Point", "coordinates": [150.9877, -33.90964] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2199" },
      "geometry": { "type": "Point", "coordinates": [151.02227, -33.90494] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2200" },
      "geometry": { "type": "Point", "coordinates": [151.00963, -33.92126] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2203" },
      "geometry": { "type": "Point", "coordinates": [151.13914, -33.90385] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2204" },
      "geometry": { "type": "Point", "coordinates": [151.15225, -33.91132] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2205" },
      "geometry": { "type": "Point", "coordinates": [151.14583, -33.93604] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2206" },
      "geometry": { "type": "Point", "coordinates": [151.12727, -33.92559] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2207" },
      "geometry": { "type": "Point", "coordinates": [151.12398, -33.94908] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2208" },
      "geometry": { "type": "Point", "coordinates": [151.09842, -33.93832] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2209" },
      "geometry": { "type": "Point", "coordinates": [151.07814, -33.94655] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2210" },
      "geometry": { "type": "Point", "coordinates": [151.05254, -33.96148] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2211" },
      "geometry": { "type": "Point", "coordinates": [151.03216, -33.95627] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2212" },
      "geometry": { "type": "Point", "coordinates": [151.01397, -33.94893] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2213" },
      "geometry": { "type": "Point", "coordinates": [150.99958, -33.96366] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2214" },
      "geometry": { "type": "Point", "coordinates": [150.97922, -33.93967] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2216" },
      "geometry": { "type": "Point", "coordinates": [151.14599, -33.95288] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2217" },
      "geometry": { "type": "Point", "coordinates": [151.13267, -33.97599] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2218" },
      "geometry": { "type": "Point", "coordinates": [151.11995, -33.97112] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2219" },
      "geometry": { "type": "Point", "coordinates": [151.13302, -33.99723] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2220" },
      "geometry": { "type": "Point", "coordinates": [151.0977, -33.96522] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2221" },
      "geometry": { "type": "Point", "coordinates": [151.10674, -33.98757] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2222" },
      "geometry": { "type": "Point", "coordinates": [151.08612, -33.96243] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2223" },
      "geometry": { "type": "Point", "coordinates": [151.073, -33.97796] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2224" },
      "geometry": { "type": "Point", "coordinates": [151.10309, -34.01485] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2225" },
      "geometry": { "type": "Point", "coordinates": [151.08009, -34.00297] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2226" },
      "geometry": { "type": "Point", "coordinates": [151.06353, -34.01104] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2227" },
      "geometry": { "type": "Point", "coordinates": [151.08608, -34.04257] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2228" },
      "geometry": { "type": "Point", "coordinates": [151.10471, -34.03566] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2229" },
      "geometry": { "type": "Point", "coordinates": [151.12339, -34.0394] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2230" },
      "geometry": { "type": "Point", "coordinates": [151.14903, -34.06188] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2231" },
      "geometry": { "type": "Point", "coordinates": [151.19226, -34.02517] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2232" },
      "geometry": { "type": "Point", "coordinates": [151.06795, -34.1002] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2233" },
      "geometry": { "type": "Point", "coordinates": [151.00078, -34.06668] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2234" },
      "geometry": { "type": "Point", "coordinates": [151.00259, -34.01767] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2250" },
      "geometry": { "type": "Point", "coordinates": [151.23578, -33.32182] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2251" },
      "geometry": { "type": "Point", "coordinates": [151.38819, -33.46901] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2256" },
      "geometry": { "type": "Point", "coordinates": [151.2668, -33.50321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2257" },
      "geometry": { "type": "Point", "coordinates": [151.372, -33.51782] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2258" },
      "geometry": { "type": "Point", "coordinates": [151.33836, -33.32057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2259" },
      "geometry": { "type": "Point", "coordinates": [151.44765, -33.17572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2260" },
      "geometry": { "type": "Point", "coordinates": [151.42999, -33.43041] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2261" },
      "geometry": { "type": "Point", "coordinates": [151.47583, -33.34405] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2262" },
      "geometry": { "type": "Point", "coordinates": [151.52986, -33.21216] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2263" },
      "geometry": { "type": "Point", "coordinates": [151.51852, -33.24658] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2264" },
      "geometry": { "type": "Point", "coordinates": [151.47048, -33.10347] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2265" },
      "geometry": { "type": "Point", "coordinates": [151.42447, -33.05291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2267" },
      "geometry": { "type": "Point", "coordinates": [151.58736, -33.07185] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2278" },
      "geometry": { "type": "Point", "coordinates": [151.5461, -32.94269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2280" },
      "geometry": { "type": "Point", "coordinates": [151.66025, -33.02775] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2281" },
      "geometry": { "type": "Point", "coordinates": [151.62889, -33.12086] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2282" },
      "geometry": { "type": "Point", "coordinates": [151.64836, -32.98521] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2283" },
      "geometry": { "type": "Point", "coordinates": [151.5699, -33.01517] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2284" },
      "geometry": { "type": "Point", "coordinates": [151.60956, -32.95197] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2285" },
      "geometry": { "type": "Point", "coordinates": [151.63936, -32.92551] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2286" },
      "geometry": { "type": "Point", "coordinates": [151.56212, -32.89995] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2287" },
      "geometry": { "type": "Point", "coordinates": [151.65874, -32.89082] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2289" },
      "geometry": { "type": "Point", "coordinates": [151.70722, -32.94613] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2290" },
      "geometry": { "type": "Point", "coordinates": [151.69876, -32.98846] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2291" },
      "geometry": { "type": "Point", "coordinates": [151.74509, -32.94697] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2292" },
      "geometry": { "type": "Point", "coordinates": [151.73699, -32.92329] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2293" },
      "geometry": { "type": "Point", "coordinates": [151.75592, -32.91513] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2294" },
      "geometry": { "type": "Point", "coordinates": [151.76671, -32.91609] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2295" },
      "geometry": { "type": "Point", "coordinates": [151.797, -32.89413] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2296" },
      "geometry": { "type": "Point", "coordinates": [151.74735, -32.91402] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2297" },
      "geometry": { "type": "Point", "coordinates": [151.75087, -32.90801] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2298" },
      "geometry": { "type": "Point", "coordinates": [151.72071, -32.90407] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2299" },
      "geometry": { "type": "Point", "coordinates": [151.70398, -32.90851] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2300" },
      "geometry": { "type": "Point", "coordinates": [151.77657, -32.93099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2302" },
      "geometry": { "type": "Point", "coordinates": [151.76059, -32.92936] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2303" },
      "geometry": { "type": "Point", "coordinates": [151.75027, -32.92815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2304" },
      "geometry": { "type": "Point", "coordinates": [151.74381, -32.8767] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2305" },
      "geometry": { "type": "Point", "coordinates": [151.70137, -32.92833] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2306" },
      "geometry": { "type": "Point", "coordinates": [151.68052, -32.99294] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2307" },
      "geometry": { "type": "Point", "coordinates": [151.69027, -32.88195] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2308" },
      "geometry": { "type": "Point", "coordinates": [151.70643, -32.89266] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2311" },
      "geometry": { "type": "Point", "coordinates": [151.49717, -32.26001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2312" },
      "geometry": { "type": "Point", "coordinates": [152.39089, -32.12555] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2315" },
      "geometry": { "type": "Point", "coordinates": [152.15278, -32.73967] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2316" },
      "geometry": { "type": "Point", "coordinates": [152.06381, -32.76982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2317" },
      "geometry": { "type": "Point", "coordinates": [152.08263, -32.72012] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2318" },
      "geometry": { "type": "Point", "coordinates": [151.8758, -32.76838] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2319" },
      "geometry": { "type": "Point", "coordinates": [151.99312, -32.74801] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2320" },
      "geometry": { "type": "Point", "coordinates": [151.48901, -32.69898] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2321" },
      "geometry": { "type": "Point", "coordinates": [151.604, -32.65583] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2322" },
      "geometry": { "type": "Point", "coordinates": [151.65496, -32.83097] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2323" },
      "geometry": { "type": "Point", "coordinates": [151.50985, -32.90392] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2324" },
      "geometry": { "type": "Point", "coordinates": [151.98805, -32.65691] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2325" },
      "geometry": { "type": "Point", "coordinates": [151.14799, -32.95223] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2326" },
      "geometry": { "type": "Point", "coordinates": [151.46071, -32.78738] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2327" },
      "geometry": { "type": "Point", "coordinates": [151.48297, -32.82563] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2328" },
      "geometry": { "type": "Point", "coordinates": [150.49289, -32.53823] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2329" },
      "geometry": { "type": "Point", "coordinates": [150.16152, -32.10805] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2330" },
      "geometry": { "type": "Point", "coordinates": [150.76048, -32.73536] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2331" },
      "geometry": { "type": "Point", "coordinates": [151.18128, -32.67889] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2333" },
      "geometry": { "type": "Point", "coordinates": [150.69096, -32.38652] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2334" },
      "geometry": { "type": "Point", "coordinates": [151.38642, -32.69703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2335" },
      "geometry": { "type": "Point", "coordinates": [151.39934, -32.58203] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2336" },
      "geometry": { "type": "Point", "coordinates": [150.98308, -32.06714] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2337" },
      "geometry": { "type": "Point", "coordinates": [151.04899, -31.85178] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2338" },
      "geometry": { "type": "Point", "coordinates": [150.94745, -31.70504] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2339" },
      "geometry": { "type": "Point", "coordinates": [150.47322, -31.75024] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2340" },
      "geometry": { "type": "Point", "coordinates": [151.03919, -31.27582] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2341" },
      "geometry": { "type": "Point", "coordinates": [150.6532, -31.34567] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2342" },
      "geometry": { "type": "Point", "coordinates": [150.60783, -31.20697] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2343" },
      "geometry": { "type": "Point", "coordinates": [150.47916, -31.57328] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2344" },
      "geometry": { "type": "Point", "coordinates": [150.75403, -31.12921] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2345" },
      "geometry": { "type": "Point", "coordinates": [150.85423, -30.87881] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2346" },
      "geometry": { "type": "Point", "coordinates": [150.78827, -30.69072] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2347" },
      "geometry": { "type": "Point", "coordinates": [150.571, -30.31932] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2350" },
      "geometry": { "type": "Point", "coordinates": [151.92649, -30.45496] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2352" },
      "geometry": { "type": "Point", "coordinates": [151.14297, -31.07104] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2353" },
      "geometry": { "type": "Point", "coordinates": [151.05588, -30.95425] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2354" },
      "geometry": { "type": "Point", "coordinates": [151.73819, -31.09152] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2355" },
      "geometry": { "type": "Point", "coordinates": [151.10875, -30.72728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2356" },
      "geometry": { "type": "Point", "coordinates": [149.02436, -30.57594] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2357" },
      "geometry": { "type": "Point", "coordinates": [149.41055, -31.26609] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2358" },
      "geometry": { "type": "Point", "coordinates": [151.37359, -30.60115] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2359" },
      "geometry": { "type": "Point", "coordinates": [150.95978, -30.12234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2360" },
      "geometry": { "type": "Point", "coordinates": [151.16594, -29.74898] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2361" },
      "geometry": { "type": "Point", "coordinates": [151.22075, -29.18615] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2365" },
      "geometry": { "type": "Point", "coordinates": [151.74591, -30.08421] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2369" },
      "geometry": { "type": "Point", "coordinates": [151.19625, -29.93084] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2370" },
      "geometry": { "type": "Point", "coordinates": [151.99712, -29.70119] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2371" },
      "geometry": { "type": "Point", "coordinates": [151.64126, -29.36435] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2372" },
      "geometry": { "type": "Point", "coordinates": [151.99793, -28.95689] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2379" },
      "geometry": { "type": "Point", "coordinates": [149.7887, -31.11323] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2380" },
      "geometry": { "type": "Point", "coordinates": [150.21007, -30.84057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2381" },
      "geometry": { "type": "Point", "coordinates": [150.10208, -31.34609] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2382" },
      "geometry": { "type": "Point", "coordinates": [150.07532, -30.68562] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2386" },
      "geometry": { "type": "Point", "coordinates": [149.00174, -30.06303] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2387" },
      "geometry": { "type": "Point", "coordinates": [148.97422, -29.78815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2388" },
      "geometry": { "type": "Point", "coordinates": [149.30204, -30.39146] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2390" },
      "geometry": { "type": "Point", "coordinates": [149.93628, -30.20647] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2395" },
      "geometry": { "type": "Point", "coordinates": [149.48559, -31.60354] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2396" },
      "geometry": { "type": "Point", "coordinates": [148.98356, -30.99459] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2397" },
      "geometry": { "type": "Point", "coordinates": [149.61047, -29.88624] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2398" },
      "geometry": { "type": "Point", "coordinates": [149.83025, -29.74021] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2399" },
      "geometry": { "type": "Point", "coordinates": [150.14978, -29.43001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2400" },
      "geometry": { "type": "Point", "coordinates": [149.80985, -29.41656] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2401" },
      "geometry": { "type": "Point", "coordinates": [150.32479, -29.61435] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2402" },
      "geometry": { "type": "Point", "coordinates": [150.58802, -29.42437] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2403" },
      "geometry": { "type": "Point", "coordinates": [150.80314, -29.61321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2404" },
      "geometry": { "type": "Point", "coordinates": [150.56499, -29.90254] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2405" },
      "geometry": { "type": "Point", "coordinates": [149.62441, -28.83928] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2406" },
      "geometry": { "type": "Point", "coordinates": [148.921, -28.97019] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2408" },
      "geometry": { "type": "Point", "coordinates": [150.52049, -29.02796] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2409" },
      "geometry": { "type": "Point", "coordinates": [150.23096, -28.70117] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2410" },
      "geometry": { "type": "Point", "coordinates": [150.77538, -28.95334] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2411" },
      "geometry": { "type": "Point", "coordinates": [150.30373, -29.10627] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2415" },
      "geometry": { "type": "Point", "coordinates": [151.79675, -32.20923] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2420" },
      "geometry": { "type": "Point", "coordinates": [151.63938, -32.27809] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2421" },
      "geometry": { "type": "Point", "coordinates": [151.5534, -32.53249] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2422" },
      "geometry": { "type": "Point", "coordinates": [151.87348, -32.00566] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2423" },
      "geometry": { "type": "Point", "coordinates": [152.25296, -32.40283] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2424" },
      "geometry": { "type": "Point", "coordinates": [152.04171, -31.69962] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2425" },
      "geometry": { "type": "Point", "coordinates": [152.02205, -32.46513] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2426" },
      "geometry": { "type": "Point", "coordinates": [152.58831, -31.82229] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2427" },
      "geometry": { "type": "Point", "coordinates": [152.67684, -31.85912] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2428" },
      "geometry": { "type": "Point", "coordinates": [152.47799, -32.28906] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2429" },
      "geometry": { "type": "Point", "coordinates": [152.23975, -31.84094] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2430" },
      "geometry": { "type": "Point", "coordinates": [152.44818, -31.86253] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2431" },
      "geometry": { "type": "Point", "coordinates": [153.04873, -30.90785] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2439" },
      "geometry": { "type": "Point", "coordinates": [152.63214, -31.60418] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2440" },
      "geometry": { "type": "Point", "coordinates": [152.51621, -30.87226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2441" },
      "geometry": { "type": "Point", "coordinates": [152.68426, -31.17707] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2443" },
      "geometry": { "type": "Point", "coordinates": [152.70231, -31.72621] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2444" },
      "geometry": { "type": "Point", "coordinates": [152.8866, -31.40323] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2445" },
      "geometry": { "type": "Point", "coordinates": [152.79899, -31.59474] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2446" },
      "geometry": { "type": "Point", "coordinates": [152.3923, -31.37807] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2447" },
      "geometry": { "type": "Point", "coordinates": [152.77868, -30.7173] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2448" },
      "geometry": { "type": "Point", "coordinates": [152.96307, -30.61869] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2449" },
      "geometry": { "type": "Point", "coordinates": [152.7302, -30.61045] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2450" },
      "geometry": { "type": "Point", "coordinates": [152.97594, -30.20428] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2452" },
      "geometry": { "type": "Point", "coordinates": [153.08465, -30.35534] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2453" },
      "geometry": { "type": "Point", "coordinates": [152.53056, -30.24438] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2454" },
      "geometry": { "type": "Point", "coordinates": [152.6812, -30.45727] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2455" },
      "geometry": { "type": "Point", "coordinates": [152.98524, -30.51526] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2456" },
      "geometry": { "type": "Point", "coordinates": [153.16061, -30.04929] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2460" },
      "geometry": { "type": "Point", "coordinates": [152.78047, -29.62258] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2462" },
      "geometry": { "type": "Point", "coordinates": [153.14519, -29.70426] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2463" },
      "geometry": { "type": "Point", "coordinates": [153.21389, -29.45913] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2464" },
      "geometry": { "type": "Point", "coordinates": [153.3291, -29.48856] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2465" },
      "geometry": { "type": "Point", "coordinates": [153.24843, -29.41232] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2466" },
      "geometry": { "type": "Point", "coordinates": [153.35977, -29.40006] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2469" },
      "geometry": { "type": "Point", "coordinates": [152.79094, -28.95874] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2470" },
      "geometry": { "type": "Point", "coordinates": [152.89356, -28.84383] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2471" },
      "geometry": { "type": "Point", "coordinates": [153.18327, -29.04222] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2472" },
      "geometry": { "type": "Point", "coordinates": [153.3142, -29.14326] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2473" },
      "geometry": { "type": "Point", "coordinates": [153.40037, -29.09972] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2474" },
      "geometry": { "type": "Point", "coordinates": [152.9742, -28.50176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2475" },
      "geometry": { "type": "Point", "coordinates": [152.43459, -28.52036] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2476" },
      "geometry": { "type": "Point", "coordinates": [152.49068, -28.42413] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2477" },
      "geometry": { "type": "Point", "coordinates": [153.43982, -28.89551] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2478" },
      "geometry": { "type": "Point", "coordinates": [153.54062, -28.83571] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2479" },
      "geometry": { "type": "Point", "coordinates": [153.52108, -28.70448] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2480" },
      "geometry": { "type": "Point", "coordinates": [153.31157, -28.74228] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2481" },
      "geometry": { "type": "Point", "coordinates": [153.55948, -28.62776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2482" },
      "geometry": { "type": "Point", "coordinates": [153.43649, -28.54526] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2483" },
      "geometry": { "type": "Point", "coordinates": [153.48116, -28.47847] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2484" },
      "geometry": { "type": "Point", "coordinates": [153.27785, -28.36074] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2485" },
      "geometry": { "type": "Point", "coordinates": [153.5188, -28.17986] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2486" },
      "geometry": { "type": "Point", "coordinates": [153.47554, -28.21145] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2487" },
      "geometry": { "type": "Point", "coordinates": [153.54398, -28.26263] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2488" },
      "geometry": { "type": "Point", "coordinates": [153.54982, -28.3331] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2489" },
      "geometry": { "type": "Point", "coordinates": [153.56095, -28.37733] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2490" },
      "geometry": { "type": "Point", "coordinates": [153.47437, -28.26773] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2500" },
      "geometry": { "type": "Point", "coordinates": [150.87596, -34.42931] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2502" },
      "geometry": { "type": "Point", "coordinates": [150.87428, -34.48869] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2505" },
      "geometry": { "type": "Point", "coordinates": [150.89829, -34.47055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2506" },
      "geometry": { "type": "Point", "coordinates": [150.84251, -34.48179] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2508" },
      "geometry": { "type": "Point", "coordinates": [150.94906, -34.21276] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2515" },
      "geometry": { "type": "Point", "coordinates": [150.93544, -34.2919] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2516" },
      "geometry": { "type": "Point", "coordinates": [150.90051, -34.33076] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2517" },
      "geometry": { "type": "Point", "coordinates": [150.8968, -34.34639] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2518" },
      "geometry": { "type": "Point", "coordinates": [150.90032, -34.37464] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2519" },
      "geometry": { "type": "Point", "coordinates": [150.87669, -34.38969] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2525" },
      "geometry": { "type": "Point", "coordinates": [150.85247, -34.43324] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2526" },
      "geometry": { "type": "Point", "coordinates": [150.80373, -34.41009] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2527" },
      "geometry": { "type": "Point", "coordinates": [150.77042, -34.58599] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2528" },
      "geometry": { "type": "Point", "coordinates": [150.86013, -34.55223] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2529" },
      "geometry": { "type": "Point", "coordinates": [150.83269, -34.60817] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2530" },
      "geometry": { "type": "Point", "coordinates": [150.76478, -34.50638] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2533" },
      "geometry": { "type": "Point", "coordinates": [150.78481, -34.65815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2534" },
      "geometry": { "type": "Point", "coordinates": [150.78396, -34.7244] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2535" },
      "geometry": { "type": "Point", "coordinates": [150.66449, -34.78115] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2536" },
      "geometry": { "type": "Point", "coordinates": [150.09608, -35.65243] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2537" },
      "geometry": { "type": "Point", "coordinates": [149.90246, -35.90486] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2538" },
      "geometry": { "type": "Point", "coordinates": [150.31821, -35.39108] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2539" },
      "geometry": { "type": "Point", "coordinates": [150.33743, -35.38551] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2540" },
      "geometry": { "type": "Point", "coordinates": [150.53408, -34.99309] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2541" },
      "geometry": { "type": "Point", "coordinates": [150.59248, -34.87054] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2545" },
      "geometry": { "type": "Point", "coordinates": [149.76667, -36.08199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2546" },
      "geometry": { "type": "Point", "coordinates": [149.85113, -36.29635] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2548" },
      "geometry": { "type": "Point", "coordinates": [149.87618, -36.85282] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2549" },
      "geometry": { "type": "Point", "coordinates": [149.80851, -36.97721] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2550" },
      "geometry": { "type": "Point", "coordinates": [149.68057, -36.69718] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2551" },
      "geometry": { "type": "Point", "coordinates": [149.60934, -37.22779] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2555" },
      "geometry": { "type": "Point", "coordinates": [150.74558, -33.87478] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2556" },
      "geometry": { "type": "Point", "coordinates": [150.73241, -33.93359] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2557" },
      "geometry": { "type": "Point", "coordinates": [150.77277, -33.98572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2558" },
      "geometry": { "type": "Point", "coordinates": [150.80639, -34.03285] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2559" },
      "geometry": { "type": "Point", "coordinates": [150.79987, -34.0492] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2560" },
      "geometry": { "type": "Point", "coordinates": [150.8376, -34.19967] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2563" },
      "geometry": { "type": "Point", "coordinates": [150.75511, -34.09995] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2564" },
      "geometry": { "type": "Point", "coordinates": [150.89638, -34.00264] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2565" },
      "geometry": { "type": "Point", "coordinates": [150.84171, -33.98631] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2566" },
      "geometry": { "type": "Point", "coordinates": [150.83811, -34.0227] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2567" },
      "geometry": { "type": "Point", "coordinates": [150.74928, -34.04574] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2568" },
      "geometry": { "type": "Point", "coordinates": [150.72046, -34.13808] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2569" },
      "geometry": { "type": "Point", "coordinates": [150.71327, -34.19076] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2570" },
      "geometry": { "type": "Point", "coordinates": [150.59405, -34.06453] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2571" },
      "geometry": { "type": "Point", "coordinates": [150.60366, -34.21678] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2572" },
      "geometry": { "type": "Point", "coordinates": [150.50332, -34.19307] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2573" },
      "geometry": { "type": "Point", "coordinates": [150.59227, -34.22665] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2574" },
      "geometry": { "type": "Point", "coordinates": [150.63606, -34.36402] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2575" },
      "geometry": { "type": "Point", "coordinates": [150.37793, -34.3846] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2576" },
      "geometry": { "type": "Point", "coordinates": [150.50901, -34.51187] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2577" },
      "geometry": { "type": "Point", "coordinates": [150.31636, -34.57715] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2578" },
      "geometry": { "type": "Point", "coordinates": [150.28905, -34.6682] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2579" },
      "geometry": { "type": "Point", "coordinates": [150.0923, -34.64267] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2580" },
      "geometry": { "type": "Point", "coordinates": [149.79053, -34.64763] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2581" },
      "geometry": { "type": "Point", "coordinates": [149.29016, -34.78677] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2582" },
      "geometry": { "type": "Point", "coordinates": [148.80838, -34.84237] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2583" },
      "geometry": { "type": "Point", "coordinates": [149.28052, -34.19674] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2584" },
      "geometry": { "type": "Point", "coordinates": [148.66876, -34.69023] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2585" },
      "geometry": { "type": "Point", "coordinates": [148.55891, -34.60762] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2586" },
      "geometry": { "type": "Point", "coordinates": [148.83565, -34.28809] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2587" },
      "geometry": { "type": "Point", "coordinates": [148.341, -34.54263] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2588" },
      "geometry": { "type": "Point", "coordinates": [148.11568, -34.50657] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2590" },
      "geometry": { "type": "Point", "coordinates": [148.00329, -34.70441] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2594" },
      "geometry": { "type": "Point", "coordinates": [148.13188, -34.24677] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2600" },
      "geometry": { "type": "Point", "coordinates": [149.13998, -35.32915] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2601" },
      "geometry": { "type": "Point", "coordinates": [149.1095, -35.2815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2602" },
      "geometry": { "type": "Point", "coordinates": [149.14052, -35.2492] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2603" },
      "geometry": { "type": "Point", "coordinates": [149.12797, -35.32836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2604" },
      "geometry": { "type": "Point", "coordinates": [149.14597, -35.33156] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2605" },
      "geometry": { "type": "Point", "coordinates": [149.08897, -35.32661] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2606" },
      "geometry": { "type": "Point", "coordinates": [149.09428, -35.35069] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2607" },
      "geometry": { "type": "Point", "coordinates": [149.10067, -35.36783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2609" },
      "geometry": { "type": "Point", "coordinates": [149.18976, -35.30001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2611" },
      "geometry": { "type": "Point", "coordinates": [148.76023, -35.38089] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2612" },
      "geometry": { "type": "Point", "coordinates": [149.14621, -35.28144] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2614" },
      "geometry": { "type": "Point", "coordinates": [149.05587, -35.24954] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2615" },
      "geometry": { "type": "Point", "coordinates": [149.01532, -35.21357] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2617" },
      "geometry": { "type": "Point", "coordinates": [149.08892, -35.2171] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2618" },
      "geometry": { "type": "Point", "coordinates": [149.05091, -35.12923] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2619" },
      "geometry": { "type": "Point", "coordinates": [149.20515, -35.38204] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2620" },
      "geometry": { "type": "Point", "coordinates": [149.10174, -35.45234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2621" },
      "geometry": { "type": "Point", "coordinates": [149.42452, -35.34493] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2622" },
      "geometry": { "type": "Point", "coordinates": [149.82834, -35.41873] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2623" },
      "geometry": { "type": "Point", "coordinates": [149.42469, -35.58329] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2624" },
      "geometry": { "type": "Point", "coordinates": [148.40138, -36.34055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2625" },
      "geometry": { "type": "Point", "coordinates": [148.30598, -36.50276] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2626" },
      "geometry": { "type": "Point", "coordinates": [149.16067, -35.89987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2627" },
      "geometry": { "type": "Point", "coordinates": [148.39495, -36.51578] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2628" },
      "geometry": { "type": "Point", "coordinates": [148.65797, -36.38055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2629" },
      "geometry": { "type": "Point", "coordinates": [148.71828, -35.91392] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2630" },
      "geometry": { "type": "Point", "coordinates": [149.20013, -36.18768] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2631" },
      "geometry": { "type": "Point", "coordinates": [149.37726, -36.53057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2632" },
      "geometry": { "type": "Point", "coordinates": [149.24916, -36.92728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2633" },
      "geometry": { "type": "Point", "coordinates": [148.84917, -36.91887] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2640" },
      "geometry": { "type": "Point", "coordinates": [147.32118, -35.97643] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2641" },
      "geometry": { "type": "Point", "coordinates": [146.91958, -36.02245] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2642" },
      "geometry": { "type": "Point", "coordinates": [147.34684, -35.8099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2643" },
      "geometry": { "type": "Point", "coordinates": [146.61849, -35.95373] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2644" },
      "geometry": { "type": "Point", "coordinates": [147.46177, -35.76037] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2645" },
      "geometry": { "type": "Point", "coordinates": [146.17627, -35.28756] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2646" },
      "geometry": { "type": "Point", "coordinates": [146.20491, -35.71498] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2647" },
      "geometry": { "type": "Point", "coordinates": [146.05234, -35.92889] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2648" },
      "geometry": { "type": "Point", "coordinates": [142.39377, -33.42862] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2649" },
      "geometry": { "type": "Point", "coordinates": [148.25532, -35.75722] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2650" },
      "geometry": { "type": "Point", "coordinates": [147.44987, -35.18228] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2651" },
      "geometry": { "type": "Point", "coordinates": [147.46193, -35.14147] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2652" },
      "geometry": { "type": "Point", "coordinates": [146.61025, -34.63238] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2653" },
      "geometry": { "type": "Point", "coordinates": [148.08056, -35.81807] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2655" },
      "geometry": { "type": "Point", "coordinates": [147.09405, -35.27916] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2656" },
      "geometry": { "type": "Point", "coordinates": [146.81125, -35.23653] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2658" },
      "geometry": { "type": "Point", "coordinates": [146.92786, -35.50148] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2659" },
      "geometry": { "type": "Point", "coordinates": [146.85246, -35.71934] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2660" },
      "geometry": { "type": "Point", "coordinates": [147.08061, -35.66076] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2661" },
      "geometry": { "type": "Point", "coordinates": [147.27972, -35.15497] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2663" },
      "geometry": { "type": "Point", "coordinates": [147.66477, -34.81445] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2665" },
      "geometry": { "type": "Point", "coordinates": [146.79594, -34.26634] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2666" },
      "geometry": { "type": "Point", "coordinates": [147.67171, -34.40058] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2668" },
      "geometry": { "type": "Point", "coordinates": [147.3938, -34.12145] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2669" },
      "geometry": { "type": "Point", "coordinates": [146.78805, -33.69749] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2671" },
      "geometry": { "type": "Point", "coordinates": [147.20379, -33.81309] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2672" },
      "geometry": { "type": "Point", "coordinates": [146.33546, -33.30478] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2675" },
      "geometry": { "type": "Point", "coordinates": [145.48311, -33.34096] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2678" },
      "geometry": { "type": "Point", "coordinates": [147.35794, -35.05859] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2680" },
      "geometry": { "type": "Point", "coordinates": [145.9149, -34.3763] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2681" },
      "geometry": { "type": "Point", "coordinates": [146.18853, -34.16684] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2700" },
      "geometry": { "type": "Point", "coordinates": [146.38371, -34.85397] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2701" },
      "geometry": { "type": "Point", "coordinates": [147.18258, -34.68894] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2702" },
      "geometry": { "type": "Point", "coordinates": [147.00612, -34.85843] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2703" },
      "geometry": { "type": "Point", "coordinates": [146.39008, -34.62499] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2705" },
      "geometry": { "type": "Point", "coordinates": [146.29774, -34.50653] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2706" },
      "geometry": { "type": "Point", "coordinates": [145.8397, -34.56312] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2707" },
      "geometry": { "type": "Point", "coordinates": [145.85051, -34.77382] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2710" },
      "geometry": { "type": "Point", "coordinates": [144.93328, -35.39065] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2711" },
      "geometry": { "type": "Point", "coordinates": [144.63104, -34.14841] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2712" },
      "geometry": { "type": "Point", "coordinates": [145.82878, -35.72961] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2713" },
      "geometry": { "type": "Point", "coordinates": [145.49391, -35.56517] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2714" },
      "geometry": { "type": "Point", "coordinates": [145.44847, -35.7639] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2715" },
      "geometry": { "type": "Point", "coordinates": [143.3549, -34.20242] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2716" },
      "geometry": { "type": "Point", "coordinates": [145.65172, -35.10765] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2717" },
      "geometry": { "type": "Point", "coordinates": [142.07467, -34.09872] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2720" },
      "geometry": { "type": "Point", "coordinates": [148.38067, -35.47046] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2721" },
      "geometry": { "type": "Point", "coordinates": [147.69619, -34.00044] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2722" },
      "geometry": { "type": "Point", "coordinates": [148.02136, -35.00035] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2725" },
      "geometry": { "type": "Point", "coordinates": [147.86696, -34.48894] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2726" },
      "geometry": { "type": "Point", "coordinates": [148.31775, -34.78511] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2727" },
      "geometry": { "type": "Point", "coordinates": [148.3626, -34.99035] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2729" },
      "geometry": { "type": "Point", "coordinates": [147.92088, -35.21169] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2730" },
      "geometry": { "type": "Point", "coordinates": [148.10939, -35.5675] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2731" },
      "geometry": { "type": "Point", "coordinates": [144.67217, -35.93898] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2732" },
      "geometry": { "type": "Point", "coordinates": [144.22417, -35.4655] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2733" },
      "geometry": { "type": "Point", "coordinates": [144.09984, -35.07111] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2734" },
      "geometry": { "type": "Point", "coordinates": [143.66952, -35.17192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2735" },
      "geometry": { "type": "Point", "coordinates": [143.492, -35.15454] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2736" },
      "geometry": { "type": "Point", "coordinates": [143.37926, -34.96278] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2737" },
      "geometry": { "type": "Point", "coordinates": [142.75053, -34.50433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2738" },
      "geometry": { "type": "Point", "coordinates": [142.46132, -34.34331] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2739" },
      "geometry": { "type": "Point", "coordinates": [142.13663, -34.15754] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2745" },
      "geometry": { "type": "Point", "coordinates": [150.66561, -33.87054] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2747" },
      "geometry": { "type": "Point", "coordinates": [150.75167, -33.73065] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2748" },
      "geometry": { "type": "Point", "coordinates": [150.71876, -33.80543] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2749" },
      "geometry": { "type": "Point", "coordinates": [150.68657, -33.69298] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2750" },
      "geometry": { "type": "Point", "coordinates": [150.67501, -33.75227] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2752" },
      "geometry": { "type": "Point", "coordinates": [150.58724, -33.93173] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2753" },
      "geometry": { "type": "Point", "coordinates": [150.69995, -33.61191] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2754" },
      "geometry": { "type": "Point", "coordinates": [150.71251, -33.56227] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2756" },
      "geometry": { "type": "Point", "coordinates": [150.7889, -33.34193] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2757" },
      "geometry": { "type": "Point", "coordinates": [150.70243, -33.54975] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2758" },
      "geometry": { "type": "Point", "coordinates": [150.64186, -33.47587] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2759" },
      "geometry": { "type": "Point", "coordinates": [150.79522, -33.80595] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2760" },
      "geometry": { "type": "Point", "coordinates": [150.78682, -33.76161] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2761" },
      "geometry": { "type": "Point", "coordinates": [150.84831, -33.73884] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2762" },
      "geometry": { "type": "Point", "coordinates": [150.87631, -33.6995] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2763" },
      "geometry": { "type": "Point", "coordinates": [150.88826, -33.72452] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2765" },
      "geometry": { "type": "Point", "coordinates": [150.86083, -33.63062] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2766" },
      "geometry": { "type": "Point", "coordinates": [150.85243, -33.79141] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2767" },
      "geometry": { "type": "Point", "coordinates": [150.86968, -33.76334] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2768" },
      "geometry": { "type": "Point", "coordinates": [150.9285, -33.72371] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2769" },
      "geometry": { "type": "Point", "coordinates": [150.90789, -33.70867] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2770" },
      "geometry": { "type": "Point", "coordinates": [150.81949, -33.76775] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2773" },
      "geometry": { "type": "Point", "coordinates": [150.62704, -33.76603] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2774" },
      "geometry": { "type": "Point", "coordinates": [150.61661, -33.73281] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2775" },
      "geometry": { "type": "Point", "coordinates": [150.99405, -33.26615] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2776" },
      "geometry": { "type": "Point", "coordinates": [150.55763, -33.67855] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2777" },
      "geometry": { "type": "Point", "coordinates": [150.60366, -33.69915] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2778" },
      "geometry": { "type": "Point", "coordinates": [150.49122, -33.71863] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2779" },
      "geometry": { "type": "Point", "coordinates": [150.45681, -33.73288] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2780" },
      "geometry": { "type": "Point", "coordinates": [150.31093, -33.70459] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2782" },
      "geometry": { "type": "Point", "coordinates": [150.37916, -33.71768] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2783" },
      "geometry": { "type": "Point", "coordinates": [150.43443, -33.71417] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2784" },
      "geometry": { "type": "Point", "coordinates": [150.41832, -33.72982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2785" },
      "geometry": { "type": "Point", "coordinates": [150.23647, -33.69832] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2786" },
      "geometry": { "type": "Point", "coordinates": [150.31602, -33.52095] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2787" },
      "geometry": { "type": "Point", "coordinates": [150.07369, -33.8606] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2790" },
      "geometry": { "type": "Point", "coordinates": [150.17361, -33.46208] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2791" },
      "geometry": { "type": "Point", "coordinates": [149.11946, -33.59871] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2792" },
      "geometry": { "type": "Point", "coordinates": [148.9551, -33.6455] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2793" },
      "geometry": { "type": "Point", "coordinates": [148.96606, -33.82783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2794" },
      "geometry": { "type": "Point", "coordinates": [148.67004, -33.92395] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2795" },
      "geometry": { "type": "Point", "coordinates": [149.56581, -33.59109] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2797" },
      "geometry": { "type": "Point", "coordinates": [148.99584, -33.72649] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2798" },
      "geometry": { "type": "Point", "coordinates": [149.14481, -33.44593] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2799" },
      "geometry": { "type": "Point", "coordinates": [149.23221, -33.63155] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2800" },
      "geometry": { "type": "Point", "coordinates": [149.00716, -33.31046] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2803" },
      "geometry": { "type": "Point", "coordinates": [148.53346, -34.12565] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2804" },
      "geometry": { "type": "Point", "coordinates": [148.62127, -33.56027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2805" },
      "geometry": { "type": "Point", "coordinates": [148.44059, -33.6553] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2806" },
      "geometry": { "type": "Point", "coordinates": [148.34944, -33.4072] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2807" },
      "geometry": { "type": "Point", "coordinates": [148.57251, -34.02341] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2808" },
      "geometry": { "type": "Point", "coordinates": [148.94288, -33.98628] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2809" },
      "geometry": { "type": "Point", "coordinates": [148.40527, -34.01965] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2810" },
      "geometry": { "type": "Point", "coordinates": [148.11877, -33.78732] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2817" },
      "geometry": { "type": "Point", "coordinates": [148.9133, -31.42808] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2818" },
      "geometry": { "type": "Point", "coordinates": [148.71871, -32.47639] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2820" },
      "geometry": { "type": "Point", "coordinates": [149.01821, -32.60158] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2821" },
      "geometry": { "type": "Point", "coordinates": [148.12281, -32.26083] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2822" },
      "geometry": { "type": "Point", "coordinates": [148.62241, -31.98438] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2823" },
      "geometry": { "type": "Point", "coordinates": [148.02656, -31.94798] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2824" },
      "geometry": { "type": "Point", "coordinates": [147.77439, -31.30564] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2825" },
      "geometry": { "type": "Point", "coordinates": [147.19959, -31.54312] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2826" },
      "geometry": { "type": "Point", "coordinates": [147.60877, -31.90051] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2827" },
      "geometry": { "type": "Point", "coordinates": [148.50773, -31.62191] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2828" },
      "geometry": { "type": "Point", "coordinates": [148.61143, -31.29781] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2829" },
      "geometry": { "type": "Point", "coordinates": [148.37847, -30.86366] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2830" },
      "geometry": { "type": "Point", "coordinates": [148.61094, -32.2012] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2831" },
      "geometry": { "type": "Point", "coordinates": [147.22873, -31.39557] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2832" },
      "geometry": { "type": "Point", "coordinates": [147.87564, -29.84982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2833" },
      "geometry": { "type": "Point", "coordinates": [148.58902, -29.34847] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2834" },
      "geometry": { "type": "Point", "coordinates": [148.11646, -29.20013] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2835" },
      "geometry": { "type": "Point", "coordinates": [145.41852, -31.68377] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2836" },
      "geometry": { "type": "Point", "coordinates": [143.38163, -31.23183] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2838" },
      "geometry": { "type": "Point", "coordinates": [147.48062, -29.27385] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2839" },
      "geometry": { "type": "Point", "coordinates": [146.95665, -29.95439] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2840" },
      "geometry": { "type": "Point", "coordinates": [144.40093, -30.12857] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2842" },
      "geometry": { "type": "Point", "coordinates": [149.13804, -31.70893] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2843" },
      "geometry": { "type": "Point", "coordinates": [149.77719, -31.79173] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2844" },
      "geometry": { "type": "Point", "coordinates": [149.40762, -32.08866] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2845" },
      "geometry": { "type": "Point", "coordinates": [150.04576, -33.42337] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2846" },
      "geometry": { "type": "Point", "coordinates": [150.18615, -33.16401] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2847" },
      "geometry": { "type": "Point", "coordinates": [149.96276, -33.35857] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2848" },
      "geometry": { "type": "Point", "coordinates": [149.97523, -32.91455] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2849" },
      "geometry": { "type": "Point", "coordinates": [150.23629, -32.81271] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2850" },
      "geometry": { "type": "Point", "coordinates": [149.66596, -32.62703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2852" },
      "geometry": { "type": "Point", "coordinates": [149.40856, -32.26371] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2864" },
      "geometry": { "type": "Point", "coordinates": [148.6441, -33.34212] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2865" },
      "geometry": { "type": "Point", "coordinates": [148.62455, -33.15001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2866" },
      "geometry": { "type": "Point", "coordinates": [148.99474, -33.01521] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2867" },
      "geometry": { "type": "Point", "coordinates": [148.6373, -32.90912] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2868" },
      "geometry": { "type": "Point", "coordinates": [148.55941, -32.73899] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2869" },
      "geometry": { "type": "Point", "coordinates": [148.05689, -32.64928] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2870" },
      "geometry": { "type": "Point", "coordinates": [148.1846, -33.10575] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2871" },
      "geometry": { "type": "Point", "coordinates": [147.89796, -33.48125] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2873" },
      "geometry": { "type": "Point", "coordinates": [147.28529, -32.26771] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2874" },
      "geometry": { "type": "Point", "coordinates": [147.6318, -32.58147] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2875" },
      "geometry": { "type": "Point", "coordinates": [147.61731, -32.94708] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2876" },
      "geometry": { "type": "Point", "coordinates": [147.82908, -33.16161] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2877" },
      "geometry": { "type": "Point", "coordinates": [146.80604, -32.85056] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2878" },
      "geometry": { "type": "Point", "coordinates": [144.2953, -32.76148] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2879" },
      "geometry": { "type": "Point", "coordinates": [142.75695, -32.65445] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2880" },
      "geometry": { "type": "Point", "coordinates": [141.92334, -31.16342] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2898" },
      "geometry": { "type": "Point", "coordinates": [159.07238, -31.54755] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2899" },
      "geometry": { "type": "Point", "coordinates": [167.95007, -29.0482] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2900" },
      "geometry": { "type": "Point", "coordinates": [149.10232, -35.47557] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2902" },
      "geometry": { "type": "Point", "coordinates": [149.0533, -35.38539] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2903" },
      "geometry": { "type": "Point", "coordinates": [149.09094, -35.39987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2904" },
      "geometry": { "type": "Point", "coordinates": [149.10746, -35.40972] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2905" },
      "geometry": { "type": "Point", "coordinates": [149.11067, -35.43159] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2906" },
      "geometry": { "type": "Point", "coordinates": [149.09773, -35.46014] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2911" },
      "geometry": { "type": "Point", "coordinates": [149.12884, -35.2149] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2912" },
      "geometry": { "type": "Point", "coordinates": [149.15643, -35.19044] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2913" },
      "geometry": { "type": "Point", "coordinates": [149.11342, -35.17491] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "2914" },
      "geometry": { "type": "Point", "coordinates": [149.14738, -35.178] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3000" },
      "geometry": { "type": "Point", "coordinates": [144.96249, -37.81149] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3002" },
      "geometry": { "type": "Point", "coordinates": [144.98115, -37.81573] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3003" },
      "geometry": { "type": "Point", "coordinates": [144.92333, -37.80916] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3004" },
      "geometry": { "type": "Point", "coordinates": [144.97586, -37.83701] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3006" },
      "geometry": { "type": "Point", "coordinates": [144.96059, -37.82677] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3008" },
      "geometry": { "type": "Point", "coordinates": [144.93972, -37.81853] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3011" },
      "geometry": { "type": "Point", "coordinates": [144.89631, -37.8009] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3012" },
      "geometry": { "type": "Point", "coordinates": [144.85792, -37.8027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3013" },
      "geometry": { "type": "Point", "coordinates": [144.88831, -37.81657] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3015" },
      "geometry": { "type": "Point", "coordinates": [144.88238, -37.84026] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3016" },
      "geometry": { "type": "Point", "coordinates": [144.88854, -37.86013] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3018" },
      "geometry": { "type": "Point", "coordinates": [144.80874, -37.86011] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3019" },
      "geometry": { "type": "Point", "coordinates": [144.85375, -37.784] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3020" },
      "geometry": { "type": "Point", "coordinates": [144.82043, -37.78033] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3021" },
      "geometry": { "type": "Point", "coordinates": [144.80456, -37.74783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3022" },
      "geometry": { "type": "Point", "coordinates": [144.80035, -37.77331] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3023" },
      "geometry": { "type": "Point", "coordinates": [144.75929, -37.76061] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3024" },
      "geometry": { "type": "Point", "coordinates": [144.60925, -37.84781] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3025" },
      "geometry": { "type": "Point", "coordinates": [144.8386, -37.83609] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3026" },
      "geometry": { "type": "Point", "coordinates": [144.7843, -37.82047] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3027" },
      "geometry": { "type": "Point", "coordinates": [144.74347, -37.86184] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3028" },
      "geometry": { "type": "Point", "coordinates": [144.78279, -37.88124] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3029" },
      "geometry": { "type": "Point", "coordinates": [144.67219, -37.82705] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3030" },
      "geometry": { "type": "Point", "coordinates": [144.60792, -37.92993] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3031" },
      "geometry": { "type": "Point", "coordinates": [144.92335, -37.78765] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3032" },
      "geometry": { "type": "Point", "coordinates": [144.8984, -37.77313] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3033" },
      "geometry": { "type": "Point", "coordinates": [144.85876, -37.74029] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3034" },
      "geometry": { "type": "Point", "coordinates": [144.86227, -37.76433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3036" },
      "geometry": { "type": "Point", "coordinates": [144.81442, -37.701] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3037" },
      "geometry": { "type": "Point", "coordinates": [144.75305, -37.69796] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3038" },
      "geometry": { "type": "Point", "coordinates": [144.80722, -37.71228] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3039" },
      "geometry": { "type": "Point", "coordinates": [144.92176, -37.76578] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3040" },
      "geometry": { "type": "Point", "coordinates": [144.90266, -37.75451] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3041" },
      "geometry": { "type": "Point", "coordinates": [144.90825, -37.72773] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3042" },
      "geometry": { "type": "Point", "coordinates": [144.87482, -37.72629] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3043" },
      "geometry": { "type": "Point", "coordinates": [144.8856, -37.6957] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3044" },
      "geometry": { "type": "Point", "coordinates": [144.93647, -37.7268] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3045" },
      "geometry": { "type": "Point", "coordinates": [144.83711, -37.67938] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3046" },
      "geometry": { "type": "Point", "coordinates": [144.92606, -37.70666] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3047" },
      "geometry": { "type": "Point", "coordinates": [144.92386, -37.68176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3048" },
      "geometry": { "type": "Point", "coordinates": [144.92707, -37.65437] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3049" },
      "geometry": { "type": "Point", "coordinates": [144.88894, -37.67202] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3051" },
      "geometry": { "type": "Point", "coordinates": [144.94369, -37.79827] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3052" },
      "geometry": { "type": "Point", "coordinates": [144.95033, -37.78763] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3053" },
      "geometry": { "type": "Point", "coordinates": [144.96626, -37.8002] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3054" },
      "geometry": { "type": "Point", "coordinates": [144.96682, -37.78718] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3055" },
      "geometry": { "type": "Point", "coordinates": [144.9426, -37.76221] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3056" },
      "geometry": { "type": "Point", "coordinates": [144.96103, -37.76455] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3057" },
      "geometry": { "type": "Point", "coordinates": [144.97785, -37.76742] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3058" },
      "geometry": { "type": "Point", "coordinates": [144.96351, -37.74019] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3059" },
      "geometry": { "type": "Point", "coordinates": [144.87366, -37.63543] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3060" },
      "geometry": { "type": "Point", "coordinates": [144.97124, -37.70422] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3061" },
      "geometry": { "type": "Point", "coordinates": [144.96301, -37.66505] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3062" },
      "geometry": { "type": "Point", "coordinates": [144.95594, -37.63479] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3063" },
      "geometry": { "type": "Point", "coordinates": [144.84208, -37.58938] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3064" },
      "geometry": { "type": "Point", "coordinates": [144.91917, -37.5687] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3065" },
      "geometry": { "type": "Point", "coordinates": [144.97848, -37.79927] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3066" },
      "geometry": { "type": "Point", "coordinates": [144.98825, -37.8017] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3067" },
      "geometry": { "type": "Point", "coordinates": [145.00353, -37.80443] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3068" },
      "geometry": { "type": "Point", "coordinates": [144.99515, -37.78581] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3070" },
      "geometry": { "type": "Point", "coordinates": [144.99793, -37.77312] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3071" },
      "geometry": { "type": "Point", "coordinates": [145.00151, -37.75813] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3072" },
      "geometry": { "type": "Point", "coordinates": [145.01231, -37.74141] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3073" },
      "geometry": { "type": "Point", "coordinates": [145.0096, -37.71492] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3074" },
      "geometry": { "type": "Point", "coordinates": [145.01329, -37.6822] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3075" },
      "geometry": { "type": "Point", "coordinates": [145.01321, -37.6682] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3076" },
      "geometry": { "type": "Point", "coordinates": [144.99244, -37.64507] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3078" },
      "geometry": { "type": "Point", "coordinates": [145.02048, -37.7857] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3079" },
      "geometry": { "type": "Point", "coordinates": [145.04808, -37.76934] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3081" },
      "geometry": { "type": "Point", "coordinates": [145.04729, -37.74182] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3082" },
      "geometry": { "type": "Point", "coordinates": [145.05987, -37.66454] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3083" },
      "geometry": { "type": "Point", "coordinates": [145.0689, -37.69904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3084" },
      "geometry": { "type": "Point", "coordinates": [145.08, -37.74902] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3085" },
      "geometry": { "type": "Point", "coordinates": [145.08172, -37.72027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3087" },
      "geometry": { "type": "Point", "coordinates": [145.08479, -37.70132] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3088" },
      "geometry": { "type": "Point", "coordinates": [145.11324, -37.69777] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3089" },
      "geometry": { "type": "Point", "coordinates": [145.16096, -37.66579] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3090" },
      "geometry": { "type": "Point", "coordinates": [145.11133, -37.66697] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3091" },
      "geometry": { "type": "Point", "coordinates": [145.13635, -37.63994] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3093" },
      "geometry": { "type": "Point", "coordinates": [145.11505, -37.74068] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3094" },
      "geometry": { "type": "Point", "coordinates": [145.12283, -37.72007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3095" },
      "geometry": { "type": "Point", "coordinates": [145.16733, -37.71071] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3096" },
      "geometry": { "type": "Point", "coordinates": [145.18776, -37.66889] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3097" },
      "geometry": { "type": "Point", "coordinates": [145.24843, -37.6858] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3099" },
      "geometry": { "type": "Point", "coordinates": [145.21766, -37.57418] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3101" },
      "geometry": { "type": "Point", "coordinates": [145.02225, -37.80007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3102" },
      "geometry": { "type": "Point", "coordinates": [145.05012, -37.78881] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3103" },
      "geometry": { "type": "Point", "coordinates": [145.08862, -37.81043] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3104" },
      "geometry": { "type": "Point", "coordinates": [145.08985, -37.79045] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3105" },
      "geometry": { "type": "Point", "coordinates": [145.08603, -37.76964] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3106" },
      "geometry": { "type": "Point", "coordinates": [145.14843, -37.75265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3107" },
      "geometry": { "type": "Point", "coordinates": [145.10638, -37.76126] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3108" },
      "geometry": { "type": "Point", "coordinates": [145.12031, -37.7853] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3109" },
      "geometry": { "type": "Point", "coordinates": [145.16472, -37.77401] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3111" },
      "geometry": { "type": "Point", "coordinates": [145.18951, -37.78485] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3113" },
      "geometry": { "type": "Point", "coordinates": [145.21189, -37.74142] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3114" },
      "geometry": { "type": "Point", "coordinates": [145.21237, -37.77853] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3115" },
      "geometry": { "type": "Point", "coordinates": [145.27022, -37.73911] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3116" },
      "geometry": { "type": "Point", "coordinates": [145.31309, -37.74314] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3121" },
      "geometry": { "type": "Point", "coordinates": [145.00352, -37.82423] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3122" },
      "geometry": { "type": "Point", "coordinates": [145.03083, -37.82737] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3123" },
      "geometry": { "type": "Point", "coordinates": [145.0489, -37.83399] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3124" },
      "geometry": { "type": "Point", "coordinates": [145.06732, -37.83595] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3125" },
      "geometry": { "type": "Point", "coordinates": [145.1108, -37.8503] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3126" },
      "geometry": { "type": "Point", "coordinates": [145.0733, -37.82386] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3127" },
      "geometry": { "type": "Point", "coordinates": [145.09643, -37.82347] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3128" },
      "geometry": { "type": "Point", "coordinates": [145.12185, -37.83316] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3129" },
      "geometry": { "type": "Point", "coordinates": [145.12454, -37.80124] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3130" },
      "geometry": { "type": "Point", "coordinates": [145.15513, -37.8199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3131" },
      "geometry": { "type": "Point", "coordinates": [145.1717, -37.8307] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3132" },
      "geometry": { "type": "Point", "coordinates": [145.19711, -37.81472] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3133" },
      "geometry": { "type": "Point", "coordinates": [145.19392, -37.8456] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3134" },
      "geometry": { "type": "Point", "coordinates": [145.23522, -37.79588] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3135" },
      "geometry": { "type": "Point", "coordinates": [145.24945, -37.82262] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3136" },
      "geometry": { "type": "Point", "coordinates": [145.28384, -37.79219] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3137" },
      "geometry": { "type": "Point", "coordinates": [145.3168, -37.81822] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3138" },
      "geometry": { "type": "Point", "coordinates": [145.32426, -37.78087] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3139" },
      "geometry": { "type": "Point", "coordinates": [145.534, -37.83394] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3140" },
      "geometry": { "type": "Point", "coordinates": [145.3675, -37.7664] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3141" },
      "geometry": { "type": "Point", "coordinates": [144.9903, -37.83759] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3142" },
      "geometry": { "type": "Point", "coordinates": [145.01802, -37.83761] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3143" },
      "geometry": { "type": "Point", "coordinates": [145.02166, -37.85632] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3144" },
      "geometry": { "type": "Point", "coordinates": [145.03594, -37.85285] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3145" },
      "geometry": { "type": "Point", "coordinates": [145.06323, -37.87564] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3146" },
      "geometry": { "type": "Point", "coordinates": [145.0665, -37.85679] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3147" },
      "geometry": { "type": "Point", "coordinates": [145.08989, -37.86563] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3148" },
      "geometry": { "type": "Point", "coordinates": [145.09804, -37.88291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3149" },
      "geometry": { "type": "Point", "coordinates": [145.12767, -37.88253] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3150" },
      "geometry": { "type": "Point", "coordinates": [145.18317, -37.89555] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3151" },
      "geometry": { "type": "Point", "coordinates": [145.15174, -37.85074] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3152" },
      "geometry": { "type": "Point", "coordinates": [145.2223, -37.86372] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3153" },
      "geometry": { "type": "Point", "coordinates": [145.26495, -37.84285] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3154" },
      "geometry": { "type": "Point", "coordinates": [145.32191, -37.85522] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3155" },
      "geometry": { "type": "Point", "coordinates": [145.28442, -37.85816] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3156" },
      "geometry": { "type": "Point", "coordinates": [145.29319, -37.91226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3158" },
      "geometry": { "type": "Point", "coordinates": [145.32855, -37.90421] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3159" },
      "geometry": { "type": "Point", "coordinates": [145.3882, -37.92294] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3160" },
      "geometry": { "type": "Point", "coordinates": [145.35884, -37.93293] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3161" },
      "geometry": { "type": "Point", "coordinates": [145.02566, -37.87155] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3162" },
      "geometry": { "type": "Point", "coordinates": [145.02872, -37.89123] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3163" },
      "geometry": { "type": "Point", "coordinates": [145.05748, -37.89285] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3165" },
      "geometry": { "type": "Point", "coordinates": [145.06556, -37.91826] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3166" },
      "geometry": { "type": "Point", "coordinates": [145.09702, -37.89887] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3167" },
      "geometry": { "type": "Point", "coordinates": [145.09916, -37.92509] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3168" },
      "geometry": { "type": "Point", "coordinates": [145.1323, -37.91446] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3169" },
      "geometry": { "type": "Point", "coordinates": [145.11808, -37.94116] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3170" },
      "geometry": { "type": "Point", "coordinates": [145.17907, -37.92517] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3171" },
      "geometry": { "type": "Point", "coordinates": [145.16474, -37.94333] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3172" },
      "geometry": { "type": "Point", "coordinates": [145.13916, -37.97562] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3173" },
      "geometry": { "type": "Point", "coordinates": [145.17462, -38.00325] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3174" },
      "geometry": { "type": "Point", "coordinates": [145.18013, -37.9665] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3175" },
      "geometry": { "type": "Point", "coordinates": [145.21007, -37.99978] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3177" },
      "geometry": { "type": "Point", "coordinates": [145.23662, -37.98733] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3178" },
      "geometry": { "type": "Point", "coordinates": [145.23773, -37.92168] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3179" },
      "geometry": { "type": "Point", "coordinates": [145.22118, -37.90567] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3180" },
      "geometry": { "type": "Point", "coordinates": [145.25045, -37.8929] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3181" },
      "geometry": { "type": "Point", "coordinates": [144.99496, -37.85337] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3182" },
      "geometry": { "type": "Point", "coordinates": [144.98053, -37.86117] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3183" },
      "geometry": { "type": "Point", "coordinates": [144.9983, -37.86995] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3184" },
      "geometry": { "type": "Point", "coordinates": [144.98431, -37.88154] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3185" },
      "geometry": { "type": "Point", "coordinates": [145.00402, -37.8857] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3186" },
      "geometry": { "type": "Point", "coordinates": [144.9953, -37.9065] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3187" },
      "geometry": { "type": "Point", "coordinates": [145.01821, -37.92127] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3188" },
      "geometry": { "type": "Point", "coordinates": [145.01513, -37.9387] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3189" },
      "geometry": { "type": "Point", "coordinates": [145.05367, -37.94156] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3190" },
      "geometry": { "type": "Point", "coordinates": [145.03606, -37.95058] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3191" },
      "geometry": { "type": "Point", "coordinates": [145.01311, -37.953] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3192" },
      "geometry": { "type": "Point", "coordinates": [145.05646, -37.9645] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3193" },
      "geometry": { "type": "Point", "coordinates": [145.03129, -37.97608] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3194" },
      "geometry": { "type": "Point", "coordinates": [145.08212, -37.97902] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3195" },
      "geometry": { "type": "Point", "coordinates": [145.11108, -38.00975] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3196" },
      "geometry": { "type": "Point", "coordinates": [145.12647, -38.0485] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3197" },
      "geometry": { "type": "Point", "coordinates": [145.13772, -38.07083] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3198" },
      "geometry": { "type": "Point", "coordinates": [145.138, -38.10155] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3199" },
      "geometry": { "type": "Point", "coordinates": [145.14981, -38.15997] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3200" },
      "geometry": { "type": "Point", "coordinates": [145.16429, -38.12683] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3201" },
      "geometry": { "type": "Point", "coordinates": [145.17463, -38.09595] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3202" },
      "geometry": { "type": "Point", "coordinates": [145.09389, -37.95442] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3204" },
      "geometry": { "type": "Point", "coordinates": [145.0411, -37.91433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3205" },
      "geometry": { "type": "Point", "coordinates": [144.95757, -37.8332] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3206" },
      "geometry": { "type": "Point", "coordinates": [144.96365, -37.84534] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3207" },
      "geometry": { "type": "Point", "coordinates": [144.92139, -37.83363] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3211" },
      "geometry": { "type": "Point", "coordinates": [144.46834, -37.92783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3212" },
      "geometry": { "type": "Point", "coordinates": [144.45403, -38.02708] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3213" },
      "geometry": { "type": "Point", "coordinates": [144.27091, -37.9451] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3214" },
      "geometry": { "type": "Point", "coordinates": [144.37651, -38.0819] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3215" },
      "geometry": { "type": "Point", "coordinates": [144.33566, -38.10439] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3216" },
      "geometry": { "type": "Point", "coordinates": [144.31657, -38.18098] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3217" },
      "geometry": { "type": "Point", "coordinates": [144.32623, -38.23706] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3218" },
      "geometry": { "type": "Point", "coordinates": [144.20998, -38.11453] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3219" },
      "geometry": { "type": "Point", "coordinates": [144.37947, -38.17242] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3220" },
      "geometry": { "type": "Point", "coordinates": [144.34532, -38.15262] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3221" },
      "geometry": { "type": "Point", "coordinates": [144.18534, -38.15714] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3222" },
      "geometry": { "type": "Point", "coordinates": [144.55101, -38.22411] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3223" },
      "geometry": { "type": "Point", "coordinates": [144.67683, -38.15197] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3224" },
      "geometry": { "type": "Point", "coordinates": [144.44357, -38.19124] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3225" },
      "geometry": { "type": "Point", "coordinates": [144.63217, -38.25666] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3226" },
      "geometry": { "type": "Point", "coordinates": [144.53508, -38.25861] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3227" },
      "geometry": { "type": "Point", "coordinates": [144.43716, -38.24315] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3228" },
      "geometry": { "type": "Point", "coordinates": [144.28185, -38.32639] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3230" },
      "geometry": { "type": "Point", "coordinates": [144.15885, -38.37868] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3231" },
      "geometry": { "type": "Point", "coordinates": [144.07122, -38.45833] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3232" },
      "geometry": { "type": "Point", "coordinates": [143.91855, -38.54199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3233" },
      "geometry": { "type": "Point", "coordinates": [143.62174, -38.75448] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3234" },
      "geometry": { "type": "Point", "coordinates": [143.81104, -38.64732] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3235" },
      "geometry": { "type": "Point", "coordinates": [143.91712, -38.42893] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3236" },
      "geometry": { "type": "Point", "coordinates": [143.72139, -38.55036] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3237" },
      "geometry": { "type": "Point", "coordinates": [143.40153, -38.68715] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3238" },
      "geometry": { "type": "Point", "coordinates": [143.44498, -38.72758] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3239" },
      "geometry": { "type": "Point", "coordinates": [143.44884, -38.57993] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3240" },
      "geometry": { "type": "Point", "coordinates": [144.14744, -38.25649] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3241" },
      "geometry": { "type": "Point", "coordinates": [143.94216, -38.28586] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3242" },
      "geometry": { "type": "Point", "coordinates": [143.80974, -38.34885] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3243" },
      "geometry": { "type": "Point", "coordinates": [143.76028, -38.4631] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3249" },
      "geometry": { "type": "Point", "coordinates": [143.52217, -38.45623] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3250" },
      "geometry": { "type": "Point", "coordinates": [143.58836, -38.31901] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3251" },
      "geometry": { "type": "Point", "coordinates": [143.66448, -38.14288] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3254" },
      "geometry": { "type": "Point", "coordinates": [143.53109, -38.29671] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3260" },
      "geometry": { "type": "Point", "coordinates": [143.17839, -38.18332] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3264" },
      "geometry": { "type": "Point", "coordinates": [142.89009, -38.23966] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3265" },
      "geometry": { "type": "Point", "coordinates": [142.83443, -38.22483] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3266" },
      "geometry": { "type": "Point", "coordinates": [143.16449, -38.4306] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3267" },
      "geometry": { "type": "Point", "coordinates": [143.0985, -38.47151] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3268" },
      "geometry": { "type": "Point", "coordinates": [142.92348, -38.5191] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3269" },
      "geometry": { "type": "Point", "coordinates": [143.08853, -38.62953] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3270" },
      "geometry": { "type": "Point", "coordinates": [142.87546, -38.59001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3271" },
      "geometry": { "type": "Point", "coordinates": [143.00425, -37.92304] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3272" },
      "geometry": { "type": "Point", "coordinates": [142.79122, -37.99064] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3273" },
      "geometry": { "type": "Point", "coordinates": [142.66604, -37.99569] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3274" },
      "geometry": { "type": "Point", "coordinates": [142.52452, -37.94321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3275" },
      "geometry": { "type": "Point", "coordinates": [142.45914, -38.28591] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3276" },
      "geometry": { "type": "Point", "coordinates": [142.4664, -38.10597] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3277" },
      "geometry": { "type": "Point", "coordinates": [142.66989, -38.40576] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3278" },
      "geometry": { "type": "Point", "coordinates": [142.61648, -38.27626] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3279" },
      "geometry": { "type": "Point", "coordinates": [142.60136, -38.25967] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3280" },
      "geometry": { "type": "Point", "coordinates": [142.48052, -38.36742] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3281" },
      "geometry": { "type": "Point", "coordinates": [142.5012, -38.2589] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3282" },
      "geometry": { "type": "Point", "coordinates": [142.378, -38.28601] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3283" },
      "geometry": { "type": "Point", "coordinates": [142.29564, -38.24941] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3284" },
      "geometry": { "type": "Point", "coordinates": [142.15946, -38.28189] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3285" },
      "geometry": { "type": "Point", "coordinates": [141.9434, -38.24868] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3286" },
      "geometry": { "type": "Point", "coordinates": [142.01113, -38.04201] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3287" },
      "geometry": { "type": "Point", "coordinates": [142.2845, -38.04951] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3289" },
      "geometry": { "type": "Point", "coordinates": [142.21943, -37.9242] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3292" },
      "geometry": { "type": "Point", "coordinates": [141.10148, -38.05526] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3293" },
      "geometry": { "type": "Point", "coordinates": [142.53538, -37.71302] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3294" },
      "geometry": { "type": "Point", "coordinates": [142.32357, -37.59661] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3300" },
      "geometry": { "type": "Point", "coordinates": [141.98994, -37.79582] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3301" },
      "geometry": { "type": "Point", "coordinates": [142.05234, -37.91403] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3302" },
      "geometry": { "type": "Point", "coordinates": [141.74853, -37.84022] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3303" },
      "geometry": { "type": "Point", "coordinates": [141.69277, -37.97472] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3304" },
      "geometry": { "type": "Point", "coordinates": [141.52942, -38.00048] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3305" },
      "geometry": { "type": "Point", "coordinates": [141.44396, -38.2574] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3309" },
      "geometry": { "type": "Point", "coordinates": [141.52031, -37.8034] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3310" },
      "geometry": { "type": "Point", "coordinates": [141.56055, -37.72277] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3311" },
      "geometry": { "type": "Point", "coordinates": [141.32227, -37.56814] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3312" },
      "geometry": { "type": "Point", "coordinates": [141.28872, -37.44881] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3314" },
      "geometry": { "type": "Point", "coordinates": [142.11392, -37.47816] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3315" },
      "geometry": { "type": "Point", "coordinates": [141.69635, -37.48484] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3317" },
      "geometry": { "type": "Point", "coordinates": [141.60934, -37.14521] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3318" },
      "geometry": { "type": "Point", "coordinates": [141.3714, -37.08033] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3319" },
      "geometry": { "type": "Point", "coordinates": [141.13363, -36.88707] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3321" },
      "geometry": { "type": "Point", "coordinates": [143.97256, -38.09386] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3322" },
      "geometry": { "type": "Point", "coordinates": [143.65537, -38.03046] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3323" },
      "geometry": { "type": "Point", "coordinates": [143.50764, -38.00864] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3324" },
      "geometry": { "type": "Point", "coordinates": [143.38336, -37.93095] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3325" },
      "geometry": { "type": "Point", "coordinates": [143.17757, -37.8783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3328" },
      "geometry": { "type": "Point", "coordinates": [144.05203, -38.02084] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3329" },
      "geometry": { "type": "Point", "coordinates": [143.901, -37.99043] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3330" },
      "geometry": { "type": "Point", "coordinates": [143.73407, -37.92265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3331" },
      "geometry": { "type": "Point", "coordinates": [144.17216, -37.96985] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3332" },
      "geometry": { "type": "Point", "coordinates": [144.09777, -37.9598] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3333" },
      "geometry": { "type": "Point", "coordinates": [144.02375, -37.87464] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3334" },
      "geometry": { "type": "Point", "coordinates": [144.01854, -37.76925] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3335" },
      "geometry": { "type": "Point", "coordinates": [144.6609, -37.69578] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3336" },
      "geometry": { "type": "Point", "coordinates": [144.70716, -37.71224] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3337" },
      "geometry": { "type": "Point", "coordinates": [144.57366, -37.62625] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3338" },
      "geometry": { "type": "Point", "coordinates": [144.57096, -37.74106] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3340" },
      "geometry": { "type": "Point", "coordinates": [144.36441, -37.77211] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3341" },
      "geometry": { "type": "Point", "coordinates": [144.34489, -37.59723] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3342" },
      "geometry": { "type": "Point", "coordinates": [144.21256, -37.6711] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3345" },
      "geometry": { "type": "Point", "coordinates": [144.10346, -37.56227] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3350" },
      "geometry": { "type": "Point", "coordinates": [143.87024, -37.57547] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3351" },
      "geometry": { "type": "Point", "coordinates": [143.36985, -37.72482] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3352" },
      "geometry": { "type": "Point", "coordinates": [143.69272, -37.57167] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3355" },
      "geometry": { "type": "Point", "coordinates": [143.79494, -37.51234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3356" },
      "geometry": { "type": "Point", "coordinates": [143.82994, -37.59366] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3357" },
      "geometry": { "type": "Point", "coordinates": [143.89236, -37.65079] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3358" },
      "geometry": { "type": "Point", "coordinates": [143.79451, -37.58081] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3360" },
      "geometry": { "type": "Point", "coordinates": [143.50622, -37.75129] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3361" },
      "geometry": { "type": "Point", "coordinates": [143.30913, -37.71863] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3363" },
      "geometry": { "type": "Point", "coordinates": [143.84383, -37.37734] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3364" },
      "geometry": { "type": "Point", "coordinates": [143.9501, -37.31825] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3370" },
      "geometry": { "type": "Point", "coordinates": [143.82074, -37.25513] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3371" },
      "geometry": { "type": "Point", "coordinates": [143.64886, -37.2024] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3373" },
      "geometry": { "type": "Point", "coordinates": [143.38255, -37.4084] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3374" },
      "geometry": { "type": "Point", "coordinates": [142.86319, -37.17907] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3375" },
      "geometry": { "type": "Point", "coordinates": [143.14471, -37.37119] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3377" },
      "geometry": { "type": "Point", "coordinates": [142.91096, -37.25181] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3378" },
      "geometry": { "type": "Point", "coordinates": [143.04849, -37.51255] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3379" },
      "geometry": { "type": "Point", "coordinates": [142.57362, -37.62701] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3380" },
      "geometry": { "type": "Point", "coordinates": [142.78073, -37.05438] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3381" },
      "geometry": { "type": "Point", "coordinates": [142.59778, -37.16825] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3384" },
      "geometry": { "type": "Point", "coordinates": [143.02648, -36.99127] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3385" },
      "geometry": { "type": "Point", "coordinates": [142.59981, -36.86038] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3387" },
      "geometry": { "type": "Point", "coordinates": [142.88246, -36.77629] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3388" },
      "geometry": { "type": "Point", "coordinates": [142.66493, -36.58904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3390" },
      "geometry": { "type": "Point", "coordinates": [142.47305, -36.57038] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3391" },
      "geometry": { "type": "Point", "coordinates": [142.43657, -36.06129] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3392" },
      "geometry": { "type": "Point", "coordinates": [142.64373, -36.42463] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3393" },
      "geometry": { "type": "Point", "coordinates": [142.50926, -36.18796] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3395" },
      "geometry": { "type": "Point", "coordinates": [142.38599, -35.91032] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3396" },
      "geometry": { "type": "Point", "coordinates": [142.34661, -35.71683] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3400" },
      "geometry": { "type": "Point", "coordinates": [142.20157, -36.71461] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3401" },
      "geometry": { "type": "Point", "coordinates": [142.04716, -36.91621] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3407" },
      "geometry": { "type": "Point", "coordinates": [141.85762, -37.27683] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3409" },
      "geometry": { "type": "Point", "coordinates": [141.77856, -36.88804] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3412" },
      "geometry": { "type": "Point", "coordinates": [141.45822, -36.69917] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3413" },
      "geometry": { "type": "Point", "coordinates": [141.27136, -36.73882] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3414" },
      "geometry": { "type": "Point", "coordinates": [142.01785, -36.32169] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3415" },
      "geometry": { "type": "Point", "coordinates": [141.35552, -36.37165] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3418" },
      "geometry": { "type": "Point", "coordinates": [141.75535, -36.37543] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3419" },
      "geometry": { "type": "Point", "coordinates": [141.29686, -36.39758] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3420" },
      "geometry": { "type": "Point", "coordinates": [141.14258, -36.31743] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3423" },
      "geometry": { "type": "Point", "coordinates": [141.94317, -36.11077] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3424" },
      "geometry": { "type": "Point", "coordinates": [141.94875, -35.89033] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3427" },
      "geometry": { "type": "Point", "coordinates": [144.69329, -37.62531] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3428" },
      "geometry": { "type": "Point", "coordinates": [144.78296, -37.63707] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3429" },
      "geometry": { "type": "Point", "coordinates": [144.74174, -37.5415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3430" },
      "geometry": { "type": "Point", "coordinates": [144.79772, -37.48479] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3431" },
      "geometry": { "type": "Point", "coordinates": [144.67969, -37.45093] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3432" },
      "geometry": { "type": "Point", "coordinates": [144.76868, -37.43124] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3433" },
      "geometry": { "type": "Point", "coordinates": [144.76965, -37.39929] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3434" },
      "geometry": { "type": "Point", "coordinates": [144.7497, -37.36095] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3435" },
      "geometry": { "type": "Point", "coordinates": [144.72538, -37.23] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3437" },
      "geometry": { "type": "Point", "coordinates": [144.50983, -37.47688] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3438" },
      "geometry": { "type": "Point", "coordinates": [144.61224, -37.45015] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3440" },
      "geometry": { "type": "Point", "coordinates": [144.55079, -37.43001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3441" },
      "geometry": { "type": "Point", "coordinates": [144.59058, -37.38959] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3442" },
      "geometry": { "type": "Point", "coordinates": [144.53194, -37.34234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3444" },
      "geometry": { "type": "Point", "coordinates": [144.55591, -37.12505] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3446" },
      "geometry": { "type": "Point", "coordinates": [144.36113, -37.1862] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3447" },
      "geometry": { "type": "Point", "coordinates": [144.35254, -37.14292] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3448" },
      "geometry": { "type": "Point", "coordinates": [144.38582, -37.05882] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3450" },
      "geometry": { "type": "Point", "coordinates": [144.22651, -37.06265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3451" },
      "geometry": { "type": "Point", "coordinates": [144.20816, -37.11815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3453" },
      "geometry": { "type": "Point", "coordinates": [144.24641, -36.92918] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3458" },
      "geometry": { "type": "Point", "coordinates": [144.35716, -37.45608] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3460" },
      "geometry": { "type": "Point", "coordinates": [144.13836, -37.33204] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3461" },
      "geometry": { "type": "Point", "coordinates": [144.16753, -37.33834] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3462" },
      "geometry": { "type": "Point", "coordinates": [144.05589, -37.12412] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3463" },
      "geometry": { "type": "Point", "coordinates": [144.03572, -36.9176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3464" },
      "geometry": { "type": "Point", "coordinates": [143.81581, -37.04889] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3465" },
      "geometry": { "type": "Point", "coordinates": [143.72554, -37.02666] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3467" },
      "geometry": { "type": "Point", "coordinates": [143.47039, -37.08941] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3468" },
      "geometry": { "type": "Point", "coordinates": [143.42257, -37.20142] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3469" },
      "geometry": { "type": "Point", "coordinates": [143.27591, -37.1748] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3472" },
      "geometry": { "type": "Point", "coordinates": [143.69818, -36.82642] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3475" },
      "geometry": { "type": "Point", "coordinates": [143.52174, -36.70656] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3477" },
      "geometry": { "type": "Point", "coordinates": [143.16998, -36.62765] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3478" },
      "geometry": { "type": "Point", "coordinates": [143.26629, -36.67365] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3480" },
      "geometry": { "type": "Point", "coordinates": [143.0152, -36.27383] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3482" },
      "geometry": { "type": "Point", "coordinates": [142.84728, -36.13006] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3483" },
      "geometry": { "type": "Point", "coordinates": [142.86251, -35.92697] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3485" },
      "geometry": { "type": "Point", "coordinates": [142.72193, -35.71427] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3487" },
      "geometry": { "type": "Point", "coordinates": [142.59252, -35.56309] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3488" },
      "geometry": { "type": "Point", "coordinates": [142.45093, -35.44616] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3489" },
      "geometry": { "type": "Point", "coordinates": [142.44349, -35.2847] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3490" },
      "geometry": { "type": "Point", "coordinates": [141.47106, -35.22381] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3491" },
      "geometry": { "type": "Point", "coordinates": [142.22451, -35.42395] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3494" },
      "geometry": { "type": "Point", "coordinates": [142.21648, -34.51457] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3496" },
      "geometry": { "type": "Point", "coordinates": [141.8091, -34.35577] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3498" },
      "geometry": { "type": "Point", "coordinates": [142.16746, -34.25985] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3500" },
      "geometry": { "type": "Point", "coordinates": [142.11176, -34.2114] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3501" },
      "geometry": { "type": "Point", "coordinates": [142.23995, -34.50849] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3505" },
      "geometry": { "type": "Point", "coordinates": [141.92849, -34.16079] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3506" },
      "geometry": { "type": "Point", "coordinates": [141.36817, -35.19122] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3507" },
      "geometry": { "type": "Point", "coordinates": [142.04735, -35.08292] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3509" },
      "geometry": { "type": "Point", "coordinates": [141.76164, -35.14266] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3512" },
      "geometry": { "type": "Point", "coordinates": [141.16792, -35.11794] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3515" },
      "geometry": { "type": "Point", "coordinates": [144.08743, -36.77722] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3516" },
      "geometry": { "type": "Point", "coordinates": [144.02385, -36.62365] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3517" },
      "geometry": { "type": "Point", "coordinates": [143.81597, -36.5118] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3518" },
      "geometry": { "type": "Point", "coordinates": [143.69643, -36.42781] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3520" },
      "geometry": { "type": "Point", "coordinates": [143.7584, -36.34779] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3521" },
      "geometry": { "type": "Point", "coordinates": [144.85866, -37.10788] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3522" },
      "geometry": { "type": "Point", "coordinates": [144.77952, -37.06192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3523" },
      "geometry": { "type": "Point", "coordinates": [144.72948, -36.85486] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3525" },
      "geometry": { "type": "Point", "coordinates": [143.42322, -36.26078] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3527" },
      "geometry": { "type": "Point", "coordinates": [143.31315, -36.02767] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3529" },
      "geometry": { "type": "Point", "coordinates": [143.21322, -35.84486] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3530" },
      "geometry": { "type": "Point", "coordinates": [143.23121, -35.74319] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3531" },
      "geometry": { "type": "Point", "coordinates": [142.98962, -35.61836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3533" },
      "geometry": { "type": "Point", "coordinates": [142.73785, -35.34769] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3537" },
      "geometry": { "type": "Point", "coordinates": [143.72718, -36.04445] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3540" },
      "geometry": { "type": "Point", "coordinates": [143.53723, -35.84205] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3542" },
      "geometry": { "type": "Point", "coordinates": [143.44218, -35.6785] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3544" },
      "geometry": { "type": "Point", "coordinates": [143.17667, -35.43561] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3546" },
      "geometry": { "type": "Point", "coordinates": [142.9262, -35.08315] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3549" },
      "geometry": { "type": "Point", "coordinates": [142.79748, -34.78395] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3550" },
      "geometry": { "type": "Point", "coordinates": [144.28195, -36.76396] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3551" },
      "geometry": { "type": "Point", "coordinates": [144.23104, -36.76353] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3555" },
      "geometry": { "type": "Point", "coordinates": [144.24597, -36.80276] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3556" },
      "geometry": { "type": "Point", "coordinates": [144.20241, -36.66627] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3557" },
      "geometry": { "type": "Point", "coordinates": [144.53759, -36.64912] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3558" },
      "geometry": { "type": "Point", "coordinates": [144.60974, -36.50942] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3559" },
      "geometry": { "type": "Point", "coordinates": [144.79362, -36.58795] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3561" },
      "geometry": { "type": "Point", "coordinates": [144.70169, -36.34342] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3562" },
      "geometry": { "type": "Point", "coordinates": [144.51373, -36.02269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3563" },
      "geometry": { "type": "Point", "coordinates": [144.50278, -36.26724] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3564" },
      "geometry": { "type": "Point", "coordinates": [144.60201, -36.06826] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3565" },
      "geometry": { "type": "Point", "coordinates": [144.53379, -36.18788] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3566" },
      "geometry": { "type": "Point", "coordinates": [144.35208, -35.9275] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3567" },
      "geometry": { "type": "Point", "coordinates": [144.2877, -35.90979] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3568" },
      "geometry": { "type": "Point", "coordinates": [144.21696, -35.81406] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3570" },
      "geometry": { "type": "Point", "coordinates": [144.25103, -36.50104] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3571" },
      "geometry": { "type": "Point", "coordinates": [144.2053, -36.41106] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3572" },
      "geometry": { "type": "Point", "coordinates": [144.29201, -36.31736] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3573" },
      "geometry": { "type": "Point", "coordinates": [144.23759, -36.19584] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3575" },
      "geometry": { "type": "Point", "coordinates": [144.13529, -36.07082] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3576" },
      "geometry": { "type": "Point", "coordinates": [143.92729, -36.11755] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3579" },
      "geometry": { "type": "Point", "coordinates": [143.85581, -35.70403] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3580" },
      "geometry": { "type": "Point", "coordinates": [144.12726, -35.65559] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3581" },
      "geometry": { "type": "Point", "coordinates": [143.83056, -35.59771] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3583" },
      "geometry": { "type": "Point", "coordinates": [143.69202, -35.50091] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3584" },
      "geometry": { "type": "Point", "coordinates": [143.64654, -35.45233] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3585" },
      "geometry": { "type": "Point", "coordinates": [143.44206, -35.38703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3586" },
      "geometry": { "type": "Point", "coordinates": [143.6396, -35.34617] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3588" },
      "geometry": { "type": "Point", "coordinates": [143.45925, -35.29472] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3589" },
      "geometry": { "type": "Point", "coordinates": [143.44745, -35.24703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3590" },
      "geometry": { "type": "Point", "coordinates": [143.47218, -35.21836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3591" },
      "geometry": { "type": "Point", "coordinates": [143.39873, -35.20993] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3594" },
      "geometry": { "type": "Point", "coordinates": [143.37128, -35.15431] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3595" },
      "geometry": { "type": "Point", "coordinates": [143.34924, -35.18659] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3596" },
      "geometry": { "type": "Point", "coordinates": [143.27318, -35.13299] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3597" },
      "geometry": { "type": "Point", "coordinates": [143.12663, -34.8478] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3599" },
      "geometry": { "type": "Point", "coordinates": [143.12684, -34.73069] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3607" },
      "geometry": { "type": "Point", "coordinates": [145.14134, -36.85409] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3608" },
      "geometry": { "type": "Point", "coordinates": [145.13848, -36.7553] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3610" },
      "geometry": { "type": "Point", "coordinates": [145.22494, -36.6037] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3612" },
      "geometry": { "type": "Point", "coordinates": [145.04985, -36.64913] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3614" },
      "geometry": { "type": "Point", "coordinates": [145.32197, -36.48526] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3616" },
      "geometry": { "type": "Point", "coordinates": [145.19102, -36.4237] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3617" },
      "geometry": { "type": "Point", "coordinates": [145.15879, -36.408] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3618" },
      "geometry": { "type": "Point", "coordinates": [145.15659, -36.37244] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3620" },
      "geometry": { "type": "Point", "coordinates": [145.09749, -36.2581] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3621" },
      "geometry": { "type": "Point", "coordinates": [144.96844, -36.23366] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3622" },
      "geometry": { "type": "Point", "coordinates": [144.80126, -36.26057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3623" },
      "geometry": { "type": "Point", "coordinates": [144.95019, -36.45998] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3624" },
      "geometry": { "type": "Point", "coordinates": [144.94789, -36.39645] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3629" },
      "geometry": { "type": "Point", "coordinates": [145.27917, -36.32176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3630" },
      "geometry": { "type": "Point", "coordinates": [145.50072, -36.41127] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3631" },
      "geometry": { "type": "Point", "coordinates": [145.44409, -36.47553] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3633" },
      "geometry": { "type": "Point", "coordinates": [145.46201, -36.28842] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3634" },
      "geometry": { "type": "Point", "coordinates": [145.45625, -36.22859] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3635" },
      "geometry": { "type": "Point", "coordinates": [145.31681, -36.13836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3636" },
      "geometry": { "type": "Point", "coordinates": [145.46611, -36.11345] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3637" },
      "geometry": { "type": "Point", "coordinates": [145.28626, -35.9683] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3638" },
      "geometry": { "type": "Point", "coordinates": [145.13679, -36.08734] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3639" },
      "geometry": { "type": "Point", "coordinates": [145.0513, -35.96584] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3640" },
      "geometry": { "type": "Point", "coordinates": [145.48031, -36.00817] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3641" },
      "geometry": { "type": "Point", "coordinates": [145.42622, -35.90757] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3644" },
      "geometry": { "type": "Point", "coordinates": [145.6831, -35.87406] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3646" },
      "geometry": { "type": "Point", "coordinates": [145.74065, -36.26382] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3647" },
      "geometry": { "type": "Point", "coordinates": [145.6975, -36.39537] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3649" },
      "geometry": { "type": "Point", "coordinates": [145.71975, -36.06834] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3658" },
      "geometry": { "type": "Point", "coordinates": [145.12384, -37.23085] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3659" },
      "geometry": { "type": "Point", "coordinates": [145.11281, -37.1143] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3660" },
      "geometry": { "type": "Point", "coordinates": [145.27987, -37.06391] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3662" },
      "geometry": { "type": "Point", "coordinates": [144.92966, -36.93086] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3663" },
      "geometry": { "type": "Point", "coordinates": [145.16018, -36.91184] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3664" },
      "geometry": { "type": "Point", "coordinates": [145.29855, -36.92069] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3665" },
      "geometry": { "type": "Point", "coordinates": [145.35509, -36.81829] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3666" },
      "geometry": { "type": "Point", "coordinates": [145.51377, -36.87505] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3669" },
      "geometry": { "type": "Point", "coordinates": [145.76415, -36.67493] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3670" },
      "geometry": { "type": "Point", "coordinates": [145.89358, -36.68822] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3672" },
      "geometry": { "type": "Point", "coordinates": [146.00519, -36.5801] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3673" },
      "geometry": { "type": "Point", "coordinates": [146.0403, -36.62356] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3675" },
      "geometry": { "type": "Point", "coordinates": [146.21905, -36.51217] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3677" },
      "geometry": { "type": "Point", "coordinates": [146.31599, -36.36303] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3678" },
      "geometry": { "type": "Point", "coordinates": [146.39652, -36.52478] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3682" },
      "geometry": { "type": "Point", "coordinates": [146.39332, -36.15185] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3683" },
      "geometry": { "type": "Point", "coordinates": [146.59687, -36.1556] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3685" },
      "geometry": { "type": "Point", "coordinates": [146.43821, -36.04748] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3687" },
      "geometry": { "type": "Point", "coordinates": [146.41733, -35.99935] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3688" },
      "geometry": { "type": "Point", "coordinates": [146.72921, -36.14046] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3690" },
      "geometry": { "type": "Point", "coordinates": [146.85556, -36.11098] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3691" },
      "geometry": { "type": "Point", "coordinates": [147.08213, -36.16243] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3695" },
      "geometry": { "type": "Point", "coordinates": [147.1173, -36.32493] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3697" },
      "geometry": { "type": "Point", "coordinates": [147.2159, -36.69143] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3698" },
      "geometry": { "type": "Point", "coordinates": [147.13275, -36.76158] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3699" },
      "geometry": { "type": "Point", "coordinates": [147.30231, -36.8165] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3700" },
      "geometry": { "type": "Point", "coordinates": [147.26091, -36.17459] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3701" },
      "geometry": { "type": "Point", "coordinates": [147.3989, -36.54405] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3704" },
      "geometry": { "type": "Point", "coordinates": [147.48333, -36.16342] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3705" },
      "geometry": { "type": "Point", "coordinates": [147.8261, -36.13536] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3707" },
      "geometry": { "type": "Point", "coordinates": [147.98716, -36.46291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3708" },
      "geometry": { "type": "Point", "coordinates": [147.91721, -36.04741] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3709" },
      "geometry": { "type": "Point", "coordinates": [147.68445, -36.03383] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3711" },
      "geometry": { "type": "Point", "coordinates": [145.71619, -37.44362] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3712" },
      "geometry": { "type": "Point", "coordinates": [145.8512, -37.35617] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3713" },
      "geometry": { "type": "Point", "coordinates": [145.96682, -37.24482] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3714" },
      "geometry": { "type": "Point", "coordinates": [145.73502, -37.21659] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3715" },
      "geometry": { "type": "Point", "coordinates": [145.76666, -37.01881] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3717" },
      "geometry": { "type": "Point", "coordinates": [145.40397, -37.30703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3718" },
      "geometry": { "type": "Point", "coordinates": [145.53622, -37.16695] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3719" },
      "geometry": { "type": "Point", "coordinates": [145.60311, -37.05543] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3720" },
      "geometry": { "type": "Point", "coordinates": [145.88129, -37.00938] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3722" },
      "geometry": { "type": "Point", "coordinates": [146.08837, -37.06604] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3723" },
      "geometry": { "type": "Point", "coordinates": [146.18964, -37.12121] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3725" },
      "geometry": { "type": "Point", "coordinates": [145.87755, -36.40787] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3726" },
      "geometry": { "type": "Point", "coordinates": [146.02048, -36.34111] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3727" },
      "geometry": { "type": "Point", "coordinates": [145.94737, -36.24613] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3728" },
      "geometry": { "type": "Point", "coordinates": [145.92341, -36.16105] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3730" },
      "geometry": { "type": "Point", "coordinates": [146.00221, -36.03836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3732" },
      "geometry": { "type": "Point", "coordinates": [146.33346, -36.67645] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3733" },
      "geometry": { "type": "Point", "coordinates": [146.41387, -36.75921] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3735" },
      "geometry": { "type": "Point", "coordinates": [146.59089, -36.52793] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3737" },
      "geometry": { "type": "Point", "coordinates": [146.82095, -36.7302] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3738" },
      "geometry": { "type": "Point", "coordinates": [146.78393, -36.60408] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3739" },
      "geometry": { "type": "Point", "coordinates": [146.85887, -36.64589] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3740" },
      "geometry": { "type": "Point", "coordinates": [146.88023, -36.82766] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3741" },
      "geometry": { "type": "Point", "coordinates": [147.06202, -36.83708] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3744" },
      "geometry": { "type": "Point", "coordinates": [146.98017, -36.79749] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3746" },
      "geometry": { "type": "Point", "coordinates": [146.5651, -36.32548] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3747" },
      "geometry": { "type": "Point", "coordinates": [146.71594, -36.36941] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3749" },
      "geometry": { "type": "Point", "coordinates": [146.85096, -36.33688] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3750" },
      "geometry": { "type": "Point", "coordinates": [145.00799, -37.59155] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3751" },
      "geometry": { "type": "Point", "coordinates": [145.06834, -37.54105] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3752" },
      "geometry": { "type": "Point", "coordinates": [145.09397, -37.63665] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3753" },
      "geometry": { "type": "Point", "coordinates": [144.94365, -37.47424] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3754" },
      "geometry": { "type": "Point", "coordinates": [145.13816, -37.59945] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3755" },
      "geometry": { "type": "Point", "coordinates": [145.13717, -37.54705] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3756" },
      "geometry": { "type": "Point", "coordinates": [144.89774, -37.40811] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3757" },
      "geometry": { "type": "Point", "coordinates": [145.20434, -37.46477] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3758" },
      "geometry": { "type": "Point", "coordinates": [145.02941, -37.35598] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3759" },
      "geometry": { "type": "Point", "coordinates": [145.24879, -37.6444] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3760" },
      "geometry": { "type": "Point", "coordinates": [145.28746, -37.62514] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3761" },
      "geometry": { "type": "Point", "coordinates": [145.28235, -37.59072] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3762" },
      "geometry": { "type": "Point", "coordinates": [144.92398, -37.35085] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3763" },
      "geometry": { "type": "Point", "coordinates": [145.3549, -37.52872] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3764" },
      "geometry": { "type": "Point", "coordinates": [144.93421, -37.21532] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3765" },
      "geometry": { "type": "Point", "coordinates": [145.35444, -37.81123] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3766" },
      "geometry": { "type": "Point", "coordinates": [145.38453, -37.8166] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3767" },
      "geometry": { "type": "Point", "coordinates": [145.35121, -37.83607] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3770" },
      "geometry": { "type": "Point", "coordinates": [145.4194, -37.70926] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3775" },
      "geometry": { "type": "Point", "coordinates": [145.35892, -37.63719] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3777" },
      "geometry": { "type": "Point", "coordinates": [145.51786, -37.62643] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3778" },
      "geometry": { "type": "Point", "coordinates": [145.63035, -37.54532] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3779" },
      "geometry": { "type": "Point", "coordinates": [145.8396, -37.55657] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3781" },
      "geometry": { "type": "Point", "coordinates": [145.51276, -37.93029] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3782" },
      "geometry": { "type": "Point", "coordinates": [145.46546, -37.9097] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3783" },
      "geometry": { "type": "Point", "coordinates": [145.61424, -37.94532] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3785" },
      "geometry": { "type": "Point", "coordinates": [145.31633, -37.87904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3786" },
      "geometry": { "type": "Point", "coordinates": [145.33597, -37.87586] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3787" },
      "geometry": { "type": "Point", "coordinates": [145.35105, -37.86332] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3788" },
      "geometry": { "type": "Point", "coordinates": [145.38018, -37.85397] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3789" },
      "geometry": { "type": "Point", "coordinates": [145.36019, -37.8914] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3791" },
      "geometry": { "type": "Point", "coordinates": [145.4083, -37.90018] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3792" },
      "geometry": { "type": "Point", "coordinates": [145.40243, -37.89277] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3793" },
      "geometry": { "type": "Point", "coordinates": [145.43324, -37.87321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3795" },
      "geometry": { "type": "Point", "coordinates": [145.43918, -37.8412] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3796" },
      "geometry": { "type": "Point", "coordinates": [145.39173, -37.78789] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3797" },
      "geometry": { "type": "Point", "coordinates": [145.73512, -37.84323] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3799" },
      "geometry": { "type": "Point", "coordinates": [145.77283, -37.69976] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3802" },
      "geometry": { "type": "Point", "coordinates": [145.25535, -37.97052] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3803" },
      "geometry": { "type": "Point", "coordinates": [145.27203, -38.00544] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3804" },
      "geometry": { "type": "Point", "coordinates": [145.33244, -37.97825] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3805" },
      "geometry": { "type": "Point", "coordinates": [145.30626, -38.02814] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3806" },
      "geometry": { "type": "Point", "coordinates": [145.34939, -38.02336] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3807" },
      "geometry": { "type": "Point", "coordinates": [145.38399, -38.03295] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3808" },
      "geometry": { "type": "Point", "coordinates": [145.43314, -37.99477] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3809" },
      "geometry": { "type": "Point", "coordinates": [145.42146, -38.06721] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3810" },
      "geometry": { "type": "Point", "coordinates": [145.49504, -38.04776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3812" },
      "geometry": { "type": "Point", "coordinates": [145.57201, -38.06807] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3813" },
      "geometry": { "type": "Point", "coordinates": [145.62801, -38.06016] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3814" },
      "geometry": { "type": "Point", "coordinates": [145.65917, -38.08077] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3815" },
      "geometry": { "type": "Point", "coordinates": [145.70584, -38.06818] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3816" },
      "geometry": { "type": "Point", "coordinates": [145.77097, -38.10503] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3818" },
      "geometry": { "type": "Point", "coordinates": [145.8488, -38.12134] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3820" },
      "geometry": { "type": "Point", "coordinates": [145.94575, -38.17128] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3821" },
      "geometry": { "type": "Point", "coordinates": [145.954, -38.16967] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3822" },
      "geometry": { "type": "Point", "coordinates": [146.00585, -38.20291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3823" },
      "geometry": { "type": "Point", "coordinates": [146.07372, -38.21413] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3824" },
      "geometry": { "type": "Point", "coordinates": [146.16195, -38.24789] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3825" },
      "geometry": { "type": "Point", "coordinates": [146.35134, -37.80513] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3831" },
      "geometry": { "type": "Point", "coordinates": [146.0343, -37.99003] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3832" },
      "geometry": { "type": "Point", "coordinates": [145.99416, -37.92234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3833" },
      "geometry": { "type": "Point", "coordinates": [146.12957, -37.87559] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3835" },
      "geometry": { "type": "Point", "coordinates": [146.17664, -38.29527] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3840" },
      "geometry": { "type": "Point", "coordinates": [146.40648, -38.27986] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3842" },
      "geometry": { "type": "Point", "coordinates": [146.42591, -38.32208] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3844" },
      "geometry": { "type": "Point", "coordinates": [146.64911, -38.31459] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3847" },
      "geometry": { "type": "Point", "coordinates": [146.79741, -38.22401] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3850" },
      "geometry": { "type": "Point", "coordinates": [147.08288, -38.10192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3851" },
      "geometry": { "type": "Point", "coordinates": [147.10725, -38.19207] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3852" },
      "geometry": { "type": "Point", "coordinates": [147.14002, -38.1046] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3854" },
      "geometry": { "type": "Point", "coordinates": [146.60147, -38.12223] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3856" },
      "geometry": { "type": "Point", "coordinates": [146.56799, -38.02572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3857" },
      "geometry": { "type": "Point", "coordinates": [146.66756, -38.00282] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3858" },
      "geometry": { "type": "Point", "coordinates": [146.7535, -37.61115] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3859" },
      "geometry": { "type": "Point", "coordinates": [146.88346, -37.92143] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3860" },
      "geometry": { "type": "Point", "coordinates": [146.97287, -37.73066] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3862" },
      "geometry": { "type": "Point", "coordinates": [147.21971, -37.48817] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3864" },
      "geometry": { "type": "Point", "coordinates": [147.31567, -37.8258] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3865" },
      "geometry": { "type": "Point", "coordinates": [147.4772, -37.80099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3869" },
      "geometry": { "type": "Point", "coordinates": [146.37983, -38.37179] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3870" },
      "geometry": { "type": "Point", "coordinates": [146.34642, -38.4539] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3871" },
      "geometry": { "type": "Point", "coordinates": [146.18102, -38.447] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3873" },
      "geometry": { "type": "Point", "coordinates": [146.69551, -38.30619] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3874" },
      "geometry": { "type": "Point", "coordinates": [146.84969, -38.53466] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3875" },
      "geometry": { "type": "Point", "coordinates": [147.54847, -37.70344] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3878" },
      "geometry": { "type": "Point", "coordinates": [147.69076, -37.90012] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3880" },
      "geometry": { "type": "Point", "coordinates": [147.74561, -37.92406] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3882" },
      "geometry": { "type": "Point", "coordinates": [147.75234, -37.80394] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3885" },
      "geometry": { "type": "Point", "coordinates": [148.16239, -37.35414] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3886" },
      "geometry": { "type": "Point", "coordinates": [148.47176, -37.75077] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3887" },
      "geometry": { "type": "Point", "coordinates": [148.06009, -37.70411] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3888" },
      "geometry": { "type": "Point", "coordinates": [148.60196, -37.44276] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3889" },
      "geometry": { "type": "Point", "coordinates": [148.92429, -37.50734] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3890" },
      "geometry": { "type": "Point", "coordinates": [149.20726, -37.48813] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3891" },
      "geometry": { "type": "Point", "coordinates": [149.51058, -37.63969] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3892" },
      "geometry": { "type": "Point", "coordinates": [149.75645, -37.51972] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3893" },
      "geometry": { "type": "Point", "coordinates": [147.89191, -37.55429] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3895" },
      "geometry": { "type": "Point", "coordinates": [147.83869, -37.35015] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3896" },
      "geometry": { "type": "Point", "coordinates": [147.76259, -37.24872] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3898" },
      "geometry": { "type": "Point", "coordinates": [147.50754, -37.0823] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3900" },
      "geometry": { "type": "Point", "coordinates": [147.7878, -36.87154] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3902" },
      "geometry": { "type": "Point", "coordinates": [147.81407, -37.81971] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3903" },
      "geometry": { "type": "Point", "coordinates": [147.87215, -37.81904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3904" },
      "geometry": { "type": "Point", "coordinates": [147.84644, -37.8719] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3909" },
      "geometry": { "type": "Point", "coordinates": [148.01077, -37.80991] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3910" },
      "geometry": { "type": "Point", "coordinates": [145.1903, -38.1505] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3911" },
      "geometry": { "type": "Point", "coordinates": [145.16681, -38.19822] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3912" },
      "geometry": { "type": "Point", "coordinates": [145.21906, -38.21944] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3913" },
      "geometry": { "type": "Point", "coordinates": [145.19944, -38.2642] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3915" },
      "geometry": { "type": "Point", "coordinates": [145.15555, -38.29584] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3916" },
      "geometry": { "type": "Point", "coordinates": [145.04958, -38.41571] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3918" },
      "geometry": { "type": "Point", "coordinates": [145.1796, -38.33165] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3919" },
      "geometry": { "type": "Point", "coordinates": [145.20588, -38.35557] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3920" },
      "geometry": { "type": "Point", "coordinates": [145.20279, -38.38406] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3921" },
      "geometry": { "type": "Point", "coordinates": [145.37609, -38.35099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3922" },
      "geometry": { "type": "Point", "coordinates": [145.20812, -38.48159] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3923" },
      "geometry": { "type": "Point", "coordinates": [145.28674, -38.4809] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3925" },
      "geometry": { "type": "Point", "coordinates": [145.38171, -38.53122] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3926" },
      "geometry": { "type": "Point", "coordinates": [145.09928, -38.36055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3927" },
      "geometry": { "type": "Point", "coordinates": [145.15378, -38.3752] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3928" },
      "geometry": { "type": "Point", "coordinates": [144.96694, -38.40469] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3929" },
      "geometry": { "type": "Point", "coordinates": [144.96621, -38.45426] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3930" },
      "geometry": { "type": "Point", "coordinates": [145.08524, -38.18969] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3931" },
      "geometry": { "type": "Point", "coordinates": [145.0565, -38.22542] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3933" },
      "geometry": { "type": "Point", "coordinates": [145.10938, -38.24892] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3934" },
      "geometry": { "type": "Point", "coordinates": [145.0251, -38.28094] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3936" },
      "geometry": { "type": "Point", "coordinates": [145.00269, -38.33708] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3937" },
      "geometry": { "type": "Point", "coordinates": [145.03219, -38.37475] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3938" },
      "geometry": { "type": "Point", "coordinates": [144.93215, -38.35453] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3939" },
      "geometry": { "type": "Point", "coordinates": [144.89457, -38.42799] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3940" },
      "geometry": { "type": "Point", "coordinates": [144.87321, -38.37279] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3941" },
      "geometry": { "type": "Point", "coordinates": [144.82205, -38.40332] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3942" },
      "geometry": { "type": "Point", "coordinates": [144.77272, -38.37101] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3943" },
      "geometry": { "type": "Point", "coordinates": [144.74016, -38.34255] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3944" },
      "geometry": { "type": "Point", "coordinates": [144.69785, -38.32212] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3945" },
      "geometry": { "type": "Point", "coordinates": [145.70036, -38.39407] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3946" },
      "geometry": { "type": "Point", "coordinates": [145.73516, -38.44647] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3950" },
      "geometry": { "type": "Point", "coordinates": [145.85022, -38.40877] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3951" },
      "geometry": { "type": "Point", "coordinates": [145.80798, -38.46213] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3953" },
      "geometry": { "type": "Point", "coordinates": [145.99029, -38.45776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3954" },
      "geometry": { "type": "Point", "coordinates": [145.9508, -38.56253] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3956" },
      "geometry": { "type": "Point", "coordinates": [146.03654, -38.67016] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3957" },
      "geometry": { "type": "Point", "coordinates": [146.09188, -38.59015] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3958" },
      "geometry": { "type": "Point", "coordinates": [146.0189, -38.66699] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3959" },
      "geometry": { "type": "Point", "coordinates": [146.09108, -38.72495] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3960" },
      "geometry": { "type": "Point", "coordinates": [146.33299, -38.81497] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3962" },
      "geometry": { "type": "Point", "coordinates": [146.35264, -38.61958] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3964" },
      "geometry": { "type": "Point", "coordinates": [146.26902, -38.68502] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3965" },
      "geometry": { "type": "Point", "coordinates": [146.47218, -38.69147] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3966" },
      "geometry": { "type": "Point", "coordinates": [146.42848, -38.62253] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3967" },
      "geometry": { "type": "Point", "coordinates": [146.53224, -38.65081] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3971" },
      "geometry": { "type": "Point", "coordinates": [146.64537, -38.58388] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3975" },
      "geometry": { "type": "Point", "coordinates": [145.23938, -38.06215] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3976" },
      "geometry": { "type": "Point", "coordinates": [145.26387, -38.03582] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3977" },
      "geometry": { "type": "Point", "coordinates": [145.26826, -38.15154] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3978" },
      "geometry": { "type": "Point", "coordinates": [145.37681, -38.13537] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3979" },
      "geometry": { "type": "Point", "coordinates": [145.61389, -38.47386] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3980" },
      "geometry": { "type": "Point", "coordinates": [145.36801, -38.21152] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3981" },
      "geometry": { "type": "Point", "coordinates": [145.58329, -38.21198] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3984" },
      "geometry": { "type": "Point", "coordinates": [145.54163, -38.3187] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3987" },
      "geometry": { "type": "Point", "coordinates": [145.69762, -38.2982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3988" },
      "geometry": { "type": "Point", "coordinates": [145.79902, -38.32812] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3990" },
      "geometry": { "type": "Point", "coordinates": [145.52529, -38.45416] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3991" },
      "geometry": { "type": "Point", "coordinates": [145.46421, -38.4712] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3992" },
      "geometry": { "type": "Point", "coordinates": [145.58341, -38.53192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3995" },
      "geometry": { "type": "Point", "coordinates": [145.58985, -38.58007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "3996" },
      "geometry": { "type": "Point", "coordinates": [145.77018, -38.61747] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4000" },
      "geometry": { "type": "Point", "coordinates": [153.02403, -27.46621] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4005" },
      "geometry": { "type": "Point", "coordinates": [153.04616, -27.46503] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4006" },
      "geometry": { "type": "Point", "coordinates": [153.03215, -27.44822] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4007" },
      "geometry": { "type": "Point", "coordinates": [153.06869, -27.43311] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4008" },
      "geometry": { "type": "Point", "coordinates": [153.11155, -27.39761] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4009" },
      "geometry": { "type": "Point", "coordinates": [153.09187, -27.43063] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4010" },
      "geometry": { "type": "Point", "coordinates": [153.04411, -27.43372] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4011" },
      "geometry": { "type": "Point", "coordinates": [153.05989, -27.41991] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4012" },
      "geometry": { "type": "Point", "coordinates": [153.05049, -27.39925] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4013" },
      "geometry": { "type": "Point", "coordinates": [153.07303, -27.38964] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4014" },
      "geometry": { "type": "Point", "coordinates": [153.08604, -27.36979] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4017" },
      "geometry": { "type": "Point", "coordinates": [153.05205, -27.31846] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4018" },
      "geometry": { "type": "Point", "coordinates": [153.03774, -27.33878] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4019" },
      "geometry": { "type": "Point", "coordinates": [153.08621, -27.25133] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4020" },
      "geometry": { "type": "Point", "coordinates": [153.10205, -27.20971] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4021" },
      "geometry": { "type": "Point", "coordinates": [153.08149, -27.2234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4022" },
      "geometry": { "type": "Point", "coordinates": [153.05451, -27.20939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4025" },
      "geometry": { "type": "Point", "coordinates": [153.40512, -27.17622] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4030" },
      "geometry": { "type": "Point", "coordinates": [153.03462, -27.42847] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4031" },
      "geometry": { "type": "Point", "coordinates": [153.03045, -27.40811] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4032" },
      "geometry": { "type": "Point", "coordinates": [153.0242, -27.38651] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4034" },
      "geometry": { "type": "Point", "coordinates": [153.05075, -27.34848] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4035" },
      "geometry": { "type": "Point", "coordinates": [152.98368, -27.34969] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4036" },
      "geometry": { "type": "Point", "coordinates": [153.02226, -27.30728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4037" },
      "geometry": { "type": "Point", "coordinates": [152.93596, -27.34067] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4051" },
      "geometry": { "type": "Point", "coordinates": [152.98544, -27.42797] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4053" },
      "geometry": { "type": "Point", "coordinates": [152.99111, -27.39547] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4054" },
      "geometry": { "type": "Point", "coordinates": [152.95145, -27.40521] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4055" },
      "geometry": { "type": "Point", "coordinates": [152.9319, -27.38997] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4059" },
      "geometry": { "type": "Point", "coordinates": [153.00665, -27.45201] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4060" },
      "geometry": { "type": "Point", "coordinates": [152.9861, -27.44203] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4061" },
      "geometry": { "type": "Point", "coordinates": [152.94281, -27.44842] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4064" },
      "geometry": { "type": "Point", "coordinates": [152.99827, -27.46156] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4065" },
      "geometry": { "type": "Point", "coordinates": [152.97713, -27.4605] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4066" },
      "geometry": { "type": "Point", "coordinates": [152.95204, -27.4737] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4067" },
      "geometry": { "type": "Point", "coordinates": [153.00493, -27.49944] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4068" },
      "geometry": { "type": "Point", "coordinates": [152.98191, -27.50456] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4069" },
      "geometry": { "type": "Point", "coordinates": [152.88709, -27.49837] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4070" },
      "geometry": { "type": "Point", "coordinates": [152.8766, -27.56451] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4073" },
      "geometry": { "type": "Point", "coordinates": [152.95297, -27.54601] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4074" },
      "geometry": { "type": "Point", "coordinates": [152.92969, -27.54845] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4075" },
      "geometry": { "type": "Point", "coordinates": [152.98, -27.54315] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4076" },
      "geometry": { "type": "Point", "coordinates": [152.92341, -27.57972] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4077" },
      "geometry": { "type": "Point", "coordinates": [152.97239, -27.59731] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4078" },
      "geometry": { "type": "Point", "coordinates": [152.95974, -27.6214] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4101" },
      "geometry": { "type": "Point", "coordinates": [153.01432, -27.48224] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4102" },
      "geometry": { "type": "Point", "coordinates": [153.03343, -27.49347] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4103" },
      "geometry": { "type": "Point", "coordinates": [153.02894, -27.51276] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4104" },
      "geometry": { "type": "Point", "coordinates": [153.01325, -27.51396] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4105" },
      "geometry": { "type": "Point", "coordinates": [153.01731, -27.53093] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4106" },
      "geometry": { "type": "Point", "coordinates": [152.99969, -27.54786] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4107" },
      "geometry": { "type": "Point", "coordinates": [153.03216, -27.54883] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4108" },
      "geometry": { "type": "Point", "coordinates": [153.02201, -27.56806] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4109" },
      "geometry": { "type": "Point", "coordinates": [153.05293, -27.58943] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4110" },
      "geometry": { "type": "Point", "coordinates": [153.00604, -27.61932] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4111" },
      "geometry": { "type": "Point", "coordinates": [153.04965, -27.54573] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4112" },
      "geometry": { "type": "Point", "coordinates": [153.09299, -27.60565] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4113" },
      "geometry": { "type": "Point", "coordinates": [153.08805, -27.58144] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4114" },
      "geometry": { "type": "Point", "coordinates": [153.10992, -27.64357] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4115" },
      "geometry": { "type": "Point", "coordinates": [153.03314, -27.63331] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4116" },
      "geometry": { "type": "Point", "coordinates": [153.05895, -27.62834] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4117" },
      "geometry": { "type": "Point", "coordinates": [153.08368, -27.64505] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4118" },
      "geometry": { "type": "Point", "coordinates": [153.0361, -27.67356] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4119" },
      "geometry": { "type": "Point", "coordinates": [153.11397, -27.60975] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4120" },
      "geometry": { "type": "Point", "coordinates": [153.04774, -27.50704] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4121" },
      "geometry": { "type": "Point", "coordinates": [153.054, -27.52555] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4122" },
      "geometry": { "type": "Point", "coordinates": [153.09221, -27.54327] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4123" },
      "geometry": { "type": "Point", "coordinates": [153.13089, -27.5726] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4124" },
      "geometry": { "type": "Point", "coordinates": [152.92881, -27.72248] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4125" },
      "geometry": { "type": "Point", "coordinates": [153.0439, -27.73421] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4127" },
      "geometry": { "type": "Point", "coordinates": [153.15106, -27.6233] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4128" },
      "geometry": { "type": "Point", "coordinates": [153.17156, -27.65586] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4129" },
      "geometry": { "type": "Point", "coordinates": [153.18776, -27.68272] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4130" },
      "geometry": { "type": "Point", "coordinates": [153.24911, -27.6757] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4131" },
      "geometry": { "type": "Point", "coordinates": [153.14304, -27.66966] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4132" },
      "geometry": { "type": "Point", "coordinates": [153.09235, -27.6776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4133" },
      "geometry": { "type": "Point", "coordinates": [153.1122, -27.71807] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4151" },
      "geometry": { "type": "Point", "coordinates": [153.06061, -27.49766] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4152" },
      "geometry": { "type": "Point", "coordinates": [153.10191, -27.50336] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4153" },
      "geometry": { "type": "Point", "coordinates": [153.13539, -27.50189] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4154" },
      "geometry": { "type": "Point", "coordinates": [153.16927, -27.48927] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4155" },
      "geometry": { "type": "Point", "coordinates": [153.17049, -27.51403] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4156" },
      "geometry": { "type": "Point", "coordinates": [153.15811, -27.5579] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4157" },
      "geometry": { "type": "Point", "coordinates": [153.20308, -27.55661] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4158" },
      "geometry": { "type": "Point", "coordinates": [153.20108, -27.48312] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4159" },
      "geometry": { "type": "Point", "coordinates": [153.21182, -27.50033] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4160" },
      "geometry": { "type": "Point", "coordinates": [153.24788, -27.49745] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4161" },
      "geometry": { "type": "Point", "coordinates": [153.22917, -27.52881] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4163" },
      "geometry": { "type": "Point", "coordinates": [153.27094, -27.53042] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4164" },
      "geometry": { "type": "Point", "coordinates": [153.2702, -27.56649] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4165" },
      "geometry": { "type": "Point", "coordinates": [153.27697, -27.63026] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4169" },
      "geometry": { "type": "Point", "coordinates": [153.04333, -27.48178] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4170" },
      "geometry": { "type": "Point", "coordinates": [153.08552, -27.47091] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4171" },
      "geometry": { "type": "Point", "coordinates": [153.06127, -27.4544] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4172" },
      "geometry": { "type": "Point", "coordinates": [153.10881, -27.45593] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4173" },
      "geometry": { "type": "Point", "coordinates": [153.12372, -27.47545] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4174" },
      "geometry": { "type": "Point", "coordinates": [153.13295, -27.44284] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4178" },
      "geometry": { "type": "Point", "coordinates": [153.25846, -27.48206] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4179" },
      "geometry": { "type": "Point", "coordinates": [153.17627, -27.46345] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4183" },
      "geometry": { "type": "Point", "coordinates": [153.44618, -27.58342] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4184" },
      "geometry": { "type": "Point", "coordinates": [153.37088, -27.61916] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4205" },
      "geometry": { "type": "Point", "coordinates": [153.15429, -27.6881] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4207" },
      "geometry": { "type": "Point", "coordinates": [153.23117, -27.75935] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4208" },
      "geometry": { "type": "Point", "coordinates": [153.3196, -27.78069] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4209" },
      "geometry": { "type": "Point", "coordinates": [153.30746, -27.84192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4210" },
      "geometry": { "type": "Point", "coordinates": [153.23571, -27.89543] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4211" },
      "geometry": { "type": "Point", "coordinates": [153.19888, -28.14869] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4212" },
      "geometry": { "type": "Point", "coordinates": [153.34933, -27.88945] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4213" },
      "geometry": { "type": "Point", "coordinates": [153.33239, -28.12631] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4214" },
      "geometry": { "type": "Point", "coordinates": [153.36701, -27.96621] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4215" },
      "geometry": { "type": "Point", "coordinates": [153.39937, -27.96815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4216" },
      "geometry": { "type": "Point", "coordinates": [153.40277, -27.87168] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4217" },
      "geometry": { "type": "Point", "coordinates": [153.40202, -27.9901] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4218" },
      "geometry": { "type": "Point", "coordinates": [153.41653, -28.03402] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4220" },
      "geometry": { "type": "Point", "coordinates": [153.43184, -28.09682] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4221" },
      "geometry": { "type": "Point", "coordinates": [153.45206, -28.13566] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4223" },
      "geometry": { "type": "Point", "coordinates": [153.4001, -28.20848] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4224" },
      "geometry": { "type": "Point", "coordinates": [153.48833, -28.14898] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4225" },
      "geometry": { "type": "Point", "coordinates": [153.51589, -28.15939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4226" },
      "geometry": { "type": "Point", "coordinates": [153.38283, -28.0565] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4227" },
      "geometry": { "type": "Point", "coordinates": [153.40451, -28.10078] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4228" },
      "geometry": { "type": "Point", "coordinates": [153.36739, -28.17779] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4270" },
      "geometry": { "type": "Point", "coordinates": [153.13447, -27.86778] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4272" },
      "geometry": { "type": "Point", "coordinates": [153.1944, -27.93444] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4275" },
      "geometry": { "type": "Point", "coordinates": [153.13568, -28.0921] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4280" },
      "geometry": { "type": "Point", "coordinates": [153.01521, -27.81275] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4285" },
      "geometry": { "type": "Point", "coordinates": [153.0098, -28.13453] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4287" },
      "geometry": { "type": "Point", "coordinates": [152.78447, -28.27871] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4300" },
      "geometry": { "type": "Point", "coordinates": [152.89749, -27.65371] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4301" },
      "geometry": { "type": "Point", "coordinates": [152.85592, -27.62708] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4303" },
      "geometry": { "type": "Point", "coordinates": [152.83533, -27.59819] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4304" },
      "geometry": { "type": "Point", "coordinates": [152.80415, -27.60541] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4305" },
      "geometry": { "type": "Point", "coordinates": [152.74828, -27.6713] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4306" },
      "geometry": { "type": "Point", "coordinates": [152.75957, -27.53185] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4307" },
      "geometry": { "type": "Point", "coordinates": [152.61324, -27.81373] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4309" },
      "geometry": { "type": "Point", "coordinates": [152.50097, -28.04191] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4310" },
      "geometry": { "type": "Point", "coordinates": [152.67357, -28.07053] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4311" },
      "geometry": { "type": "Point", "coordinates": [152.41971, -27.3578] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4312" },
      "geometry": { "type": "Point", "coordinates": [152.47181, -27.21562] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4313" },
      "geometry": { "type": "Point", "coordinates": [152.36684, -27.12127] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4314" },
      "geometry": { "type": "Point", "coordinates": [152.16938, -26.74731] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4340" },
      "geometry": { "type": "Point", "coordinates": [152.504, -27.76314] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4341" },
      "geometry": { "type": "Point", "coordinates": [152.37826, -27.76151] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4342" },
      "geometry": { "type": "Point", "coordinates": [152.40156, -27.53908] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4343" },
      "geometry": { "type": "Point", "coordinates": [152.24628, -27.72533] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4344" },
      "geometry": { "type": "Point", "coordinates": [152.11176, -27.55728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4346" },
      "geometry": { "type": "Point", "coordinates": [152.58712, -27.5617] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4347" },
      "geometry": { "type": "Point", "coordinates": [152.17098, -27.63314] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4350" },
      "geometry": { "type": "Point", "coordinates": [151.86758, -27.57987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4352" },
      "geometry": { "type": "Point", "coordinates": [151.65672, -27.82184] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4353" },
      "geometry": { "type": "Point", "coordinates": [151.87773, -27.15753] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4354" },
      "geometry": { "type": "Point", "coordinates": [151.86221, -27.2831] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4355" },
      "geometry": { "type": "Point", "coordinates": [152.09279, -27.12429] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4356" },
      "geometry": { "type": "Point", "coordinates": [151.58127, -27.71421] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4357" },
      "geometry": { "type": "Point", "coordinates": [151.18139, -28.01269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4358" },
      "geometry": { "type": "Point", "coordinates": [151.81991, -27.77414] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4359" },
      "geometry": { "type": "Point", "coordinates": [152.0242, -27.79663] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4360" },
      "geometry": { "type": "Point", "coordinates": [151.89519, -27.84689] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4361" },
      "geometry": { "type": "Point", "coordinates": [151.87458, -27.91222] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4362" },
      "geometry": { "type": "Point", "coordinates": [152.14782, -28.00717] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4363" },
      "geometry": { "type": "Point", "coordinates": [151.73806, -27.68687] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4364" },
      "geometry": { "type": "Point", "coordinates": [151.43222, -27.73184] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4365" },
      "geometry": { "type": "Point", "coordinates": [151.65673, -28.02343] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4370" },
      "geometry": { "type": "Point", "coordinates": [152.08037, -28.23419] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4371" },
      "geometry": { "type": "Point", "coordinates": [152.32824, -28.19415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4372" },
      "geometry": { "type": "Point", "coordinates": [152.23617, -28.30353] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4373" },
      "geometry": { "type": "Point", "coordinates": [152.37036, -28.30957] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4374" },
      "geometry": { "type": "Point", "coordinates": [151.86078, -28.40418] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4375" },
      "geometry": { "type": "Point", "coordinates": [151.94279, -28.52389] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4376" },
      "geometry": { "type": "Point", "coordinates": [151.93258, -28.55166] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4377" },
      "geometry": { "type": "Point", "coordinates": [152.03263, -28.54264] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4378" },
      "geometry": { "type": "Point", "coordinates": [151.92358, -28.61669] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4380" },
      "geometry": { "type": "Point", "coordinates": [151.65928, -28.815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4381" },
      "geometry": { "type": "Point", "coordinates": [151.8774, -28.75629] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4382" },
      "geometry": { "type": "Point", "coordinates": [151.82669, -28.84933] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4383" },
      "geometry": { "type": "Point", "coordinates": [151.95637, -28.92899] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4384" },
      "geometry": { "type": "Point", "coordinates": [151.16519, -28.7359] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4385" },
      "geometry": { "type": "Point", "coordinates": [151.15145, -28.85962] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4387" },
      "geometry": { "type": "Point", "coordinates": [151.16913, -28.48592] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4388" },
      "geometry": { "type": "Point", "coordinates": [150.60056, -28.5724] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4390" },
      "geometry": { "type": "Point", "coordinates": [150.4863, -28.23902] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4400" },
      "geometry": { "type": "Point", "coordinates": [151.80196, -27.49594] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4401" },
      "geometry": { "type": "Point", "coordinates": [151.73652, -27.41933] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4402" },
      "geometry": { "type": "Point", "coordinates": [151.81416, -26.96076] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4403" },
      "geometry": { "type": "Point", "coordinates": [151.51078, -27.34912] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4404" },
      "geometry": { "type": "Point", "coordinates": [151.43096, -27.24815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4405" },
      "geometry": { "type": "Point", "coordinates": [151.17692, -27.19944] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4406" },
      "geometry": { "type": "Point", "coordinates": [150.73751, -27.40339] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4407" },
      "geometry": { "type": "Point", "coordinates": [151.00273, -27.57167] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4408" },
      "geometry": { "type": "Point", "coordinates": [151.34911, -26.84136] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4410" },
      "geometry": { "type": "Point", "coordinates": [151.23438, -26.6858] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4411" },
      "geometry": { "type": "Point", "coordinates": [150.95359, -26.8834] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4412" },
      "geometry": { "type": "Point", "coordinates": [150.80875, -26.90216] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4413" },
      "geometry": { "type": "Point", "coordinates": [150.65246, -26.38581] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4415" },
      "geometry": { "type": "Point", "coordinates": [150.17237, -26.52014] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4416" },
      "geometry": { "type": "Point", "coordinates": [149.9995, -26.94562] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4417" },
      "geometry": { "type": "Point", "coordinates": [149.16053, -27.15336] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4418" },
      "geometry": { "type": "Point", "coordinates": [150.10245, -26.27614] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4419" },
      "geometry": { "type": "Point", "coordinates": [149.95201, -25.94121] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4420" },
      "geometry": { "type": "Point", "coordinates": [149.36739, -25.25599] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4421" },
      "geometry": { "type": "Point", "coordinates": [150.47794, -27.24043] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4422" },
      "geometry": { "type": "Point", "coordinates": [149.77239, -27.42623] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4423" },
      "geometry": { "type": "Point", "coordinates": [149.56697, -27.28979] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4424" },
      "geometry": { "type": "Point", "coordinates": [149.98683, -26.71511] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4425" },
      "geometry": { "type": "Point", "coordinates": [149.78174, -26.62539] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4426" },
      "geometry": { "type": "Point", "coordinates": [149.58189, -26.50471] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4427" },
      "geometry": { "type": "Point", "coordinates": [149.39073, -26.47989] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4428" },
      "geometry": { "type": "Point", "coordinates": [149.23893, -26.34633] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4454" },
      "geometry": { "type": "Point", "coordinates": [148.72958, -25.66895] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4455" },
      "geometry": { "type": "Point", "coordinates": [148.57024, -26.97857] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4461" },
      "geometry": { "type": "Point", "coordinates": [148.38348, -26.63096] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4462" },
      "geometry": { "type": "Point", "coordinates": [148.14131, -26.63523] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4465" },
      "geometry": { "type": "Point", "coordinates": [147.90424, -26.26036] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4467" },
      "geometry": { "type": "Point", "coordinates": [147.46716, -26.18301] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4468" },
      "geometry": { "type": "Point", "coordinates": [146.94343, -26.5338] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4470" },
      "geometry": { "type": "Point", "coordinates": [146.25537, -26.36879] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4472" },
      "geometry": { "type": "Point", "coordinates": [145.33627, -24.43385] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4474" },
      "geometry": { "type": "Point", "coordinates": [144.67526, -25.90777] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4477" },
      "geometry": { "type": "Point", "coordinates": [147.23763, -25.2973] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4478" },
      "geometry": { "type": "Point", "coordinates": [146.32081, -25.11068] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4479" },
      "geometry": { "type": "Point", "coordinates": [145.55366, -26.71192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4480" },
      "geometry": { "type": "Point", "coordinates": [143.16707, -26.55159] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4481" },
      "geometry": { "type": "Point", "coordinates": [141.6749, -25.56826] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4482" },
      "geometry": { "type": "Point", "coordinates": [139.73737, -25.4067] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4486" },
      "geometry": { "type": "Point", "coordinates": [147.70811, -28.73248] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4487" },
      "geometry": { "type": "Point", "coordinates": [148.4737, -27.92317] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4488" },
      "geometry": { "type": "Point", "coordinates": [147.30427, -27.80035] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4489" },
      "geometry": { "type": "Point", "coordinates": [146.07067, -27.28696] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4490" },
      "geometry": { "type": "Point", "coordinates": [145.77727, -27.84564] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4491" },
      "geometry": { "type": "Point", "coordinates": [145.01028, -28.20806] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4492" },
      "geometry": { "type": "Point", "coordinates": [142.79268, -27.81517] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4493" },
      "geometry": { "type": "Point", "coordinates": [144.1792, -28.74561] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4494" },
      "geometry": { "type": "Point", "coordinates": [149.64952, -28.33574] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4496" },
      "geometry": { "type": "Point", "coordinates": [149.38256, -28.48783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4497" },
      "geometry": { "type": "Point", "coordinates": [148.88033, -28.5398] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4498" },
      "geometry": { "type": "Point", "coordinates": [149.82167, -28.38226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4500" },
      "geometry": { "type": "Point", "coordinates": [152.93632, -27.30253] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4501" },
      "geometry": { "type": "Point", "coordinates": [152.9861, -27.28223] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4502" },
      "geometry": { "type": "Point", "coordinates": [152.97423, -27.26687] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4503" },
      "geometry": { "type": "Point", "coordinates": [152.95118, -27.23399] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4504" },
      "geometry": { "type": "Point", "coordinates": [152.94476, -27.18849] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4505" },
      "geometry": { "type": "Point", "coordinates": [152.97761, -27.15239] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4506" },
      "geometry": { "type": "Point", "coordinates": [152.91425, -27.13654] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4507" },
      "geometry": { "type": "Point", "coordinates": [153.14126, -26.99328] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4508" },
      "geometry": { "type": "Point", "coordinates": [153.02252, -27.18099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4509" },
      "geometry": { "type": "Point", "coordinates": [153.02835, -27.22836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4510" },
      "geometry": { "type": "Point", "coordinates": [152.97854, -27.06626] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4511" },
      "geometry": { "type": "Point", "coordinates": [153.08966, -27.07302] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4512" },
      "geometry": { "type": "Point", "coordinates": [152.86236, -27.02146] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4514" },
      "geometry": { "type": "Point", "coordinates": [152.72193, -26.94789] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4515" },
      "geometry": { "type": "Point", "coordinates": [152.47911, -26.73904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4516" },
      "geometry": { "type": "Point", "coordinates": [152.96627, -26.9958] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4517" },
      "geometry": { "type": "Point", "coordinates": [152.98288, -26.95023] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4518" },
      "geometry": { "type": "Point", "coordinates": [152.92722, -26.90666] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4519" },
      "geometry": { "type": "Point", "coordinates": [152.94199, -26.8547] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4520" },
      "geometry": { "type": "Point", "coordinates": [152.85743, -27.32523] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4521" },
      "geometry": { "type": "Point", "coordinates": [152.75948, -27.18363] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4550" },
      "geometry": { "type": "Point", "coordinates": [152.97965, -26.80952] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4551" },
      "geometry": { "type": "Point", "coordinates": [153.09053, -26.79539] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4552" },
      "geometry": { "type": "Point", "coordinates": [152.76529, -26.73461] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4553" },
      "geometry": { "type": "Point", "coordinates": [152.99613, -26.75572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4554" },
      "geometry": { "type": "Point", "coordinates": [152.97619, -26.73256] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4555" },
      "geometry": { "type": "Point", "coordinates": [152.93921, -26.68706] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4556" },
      "geometry": { "type": "Point", "coordinates": [153.06892, -26.69509] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4557" },
      "geometry": { "type": "Point", "coordinates": [153.10903, -26.69272] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4558" },
      "geometry": { "type": "Point", "coordinates": [153.08088, -26.64838] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4559" },
      "geometry": { "type": "Point", "coordinates": [152.98088, -26.65528] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4560" },
      "geometry": { "type": "Point", "coordinates": [152.90887, -26.60907] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4561" },
      "geometry": { "type": "Point", "coordinates": [152.99205, -26.53875] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4562" },
      "geometry": { "type": "Point", "coordinates": [152.88003, -26.48943] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4563" },
      "geometry": { "type": "Point", "coordinates": [152.87463, -26.42856] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4564" },
      "geometry": { "type": "Point", "coordinates": [153.08288, -26.60126] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4565" },
      "geometry": { "type": "Point", "coordinates": [152.98765, -26.3154] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4566" },
      "geometry": { "type": "Point", "coordinates": [153.06074, -26.42816] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4567" },
      "geometry": { "type": "Point", "coordinates": [153.09439, -26.40274] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4568" },
      "geometry": { "type": "Point", "coordinates": [152.83747, -26.37205] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4569" },
      "geometry": { "type": "Point", "coordinates": [152.81745, -26.33409] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4570" },
      "geometry": { "type": "Point", "coordinates": [152.59553, -26.14762] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4571" },
      "geometry": { "type": "Point", "coordinates": [152.9447, -26.22369] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4572" },
      "geometry": { "type": "Point", "coordinates": [153.10415, -26.67138] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4573" },
      "geometry": { "type": "Point", "coordinates": [153.07109, -26.5072] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4574" },
      "geometry": { "type": "Point", "coordinates": [152.67504, -26.64305] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4575" },
      "geometry": { "type": "Point", "coordinates": [153.12482, -26.72622] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4580" },
      "geometry": { "type": "Point", "coordinates": [152.98078, -25.95632] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4581" },
      "geometry": { "type": "Point", "coordinates": [153.12999, -25.13748] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4600" },
      "geometry": { "type": "Point", "coordinates": [152.24226, -26.10825] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4601" },
      "geometry": { "type": "Point", "coordinates": [152.08211, -26.08773] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4605" },
      "geometry": { "type": "Point", "coordinates": [151.90361, -26.15761] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4606" },
      "geometry": { "type": "Point", "coordinates": [151.83874, -26.2695] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4608" },
      "geometry": { "type": "Point", "coordinates": [151.84132, -26.37292] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4610" },
      "geometry": { "type": "Point", "coordinates": [151.6257, -26.55328] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4611" },
      "geometry": { "type": "Point", "coordinates": [151.75563, -26.16605] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4612" },
      "geometry": { "type": "Point", "coordinates": [151.61073, -25.99983] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4613" },
      "geometry": { "type": "Point", "coordinates": [151.4548, -26.18369] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4614" },
      "geometry": { "type": "Point", "coordinates": [151.9473, -26.84796] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4615" },
      "geometry": { "type": "Point", "coordinates": [151.95597, -26.65199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4620" },
      "geometry": { "type": "Point", "coordinates": [152.23787, -25.68075] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4621" },
      "geometry": { "type": "Point", "coordinates": [152.02683, -25.4836] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4625" },
      "geometry": { "type": "Point", "coordinates": [151.69091, -25.68266] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4626" },
      "geometry": { "type": "Point", "coordinates": [151.07137, -25.74423] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4627" },
      "geometry": { "type": "Point", "coordinates": [150.91089, -25.33896] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4630" },
      "geometry": { "type": "Point", "coordinates": [151.18209, -24.87559] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4650" },
      "geometry": { "type": "Point", "coordinates": [152.67818, -25.67632] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4655" },
      "geometry": { "type": "Point", "coordinates": [152.82344, -25.40214] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4659" },
      "geometry": { "type": "Point", "coordinates": [152.60837, -25.273] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4660" },
      "geometry": { "type": "Point", "coordinates": [152.29162, -25.21459] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4662" },
      "geometry": { "type": "Point", "coordinates": [152.57737, -25.35418] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4670" },
      "geometry": { "type": "Point", "coordinates": [152.3037, -24.73184] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4671" },
      "geometry": { "type": "Point", "coordinates": [151.6903, -25.11912] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4673" },
      "geometry": { "type": "Point", "coordinates": [152.09006, -24.71846] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4674" },
      "geometry": { "type": "Point", "coordinates": [151.85379, -24.60091] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4676" },
      "geometry": { "type": "Point", "coordinates": [151.60533, -24.5853] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4677" },
      "geometry": { "type": "Point", "coordinates": [151.67276, -24.27057] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4678" },
      "geometry": { "type": "Point", "coordinates": [151.54518, -24.17546] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4680" },
      "geometry": { "type": "Point", "coordinates": [151.2515, -24.10882] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4694" },
      "geometry": { "type": "Point", "coordinates": [151.08146, -23.75619] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4695" },
      "geometry": { "type": "Point", "coordinates": [150.94015, -23.7401] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4697" },
      "geometry": { "type": "Point", "coordinates": [150.75014, -23.8489] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4699" },
      "geometry": { "type": "Point", "coordinates": [150.64524, -23.63378] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4700" },
      "geometry": { "type": "Point", "coordinates": [150.84669, -23.21514] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4701" },
      "geometry": { "type": "Point", "coordinates": [150.61162, -23.37056] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4702" },
      "geometry": { "type": "Point", "coordinates": [149.0732, -23.92799] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4703" },
      "geometry": { "type": "Point", "coordinates": [150.65516, -22.98108] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4704" },
      "geometry": { "type": "Point", "coordinates": [150.42145, -23.1269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4705" },
      "geometry": { "type": "Point", "coordinates": [149.12592, -22.86416] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4706" },
      "geometry": { "type": "Point", "coordinates": [149.741, -22.61304] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4707" },
      "geometry": { "type": "Point", "coordinates": [149.67618, -22.07888] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4709" },
      "geometry": { "type": "Point", "coordinates": [148.34583, -23.03322] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4710" },
      "geometry": { "type": "Point", "coordinates": [150.79861, -23.27089] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4711" },
      "geometry": { "type": "Point", "coordinates": [150.4642, -23.27752] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4712" },
      "geometry": { "type": "Point", "coordinates": [149.66753, -23.62802] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4713" },
      "geometry": { "type": "Point", "coordinates": [149.44746, -24.16555] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4714" },
      "geometry": { "type": "Point", "coordinates": [150.38279, -23.70077] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4715" },
      "geometry": { "type": "Point", "coordinates": [150.49562, -24.51433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4716" },
      "geometry": { "type": "Point", "coordinates": [150.65757, -24.5795] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4717" },
      "geometry": { "type": "Point", "coordinates": [148.73849, -23.46534] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4718" },
      "geometry": { "type": "Point", "coordinates": [149.493, -24.76718] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4719" },
      "geometry": { "type": "Point", "coordinates": [150.19918, -25.11294] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4720" },
      "geometry": { "type": "Point", "coordinates": [147.5308, -23.99176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4721" },
      "geometry": { "type": "Point", "coordinates": [147.1197, -22.4964] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4722" },
      "geometry": { "type": "Point", "coordinates": [147.68382, -24.37013] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4723" },
      "geometry": { "type": "Point", "coordinates": [148.0936, -23.08226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4724" },
      "geometry": { "type": "Point", "coordinates": [146.6512, -23.78226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4725" },
      "geometry": { "type": "Point", "coordinates": [145.30601, -23.64784] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4726" },
      "geometry": { "type": "Point", "coordinates": [145.38186, -22.47546] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4727" },
      "geometry": { "type": "Point", "coordinates": [144.64999, -23.83448] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4728" },
      "geometry": { "type": "Point", "coordinates": [146.11055, -23.14538] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4730" },
      "geometry": { "type": "Point", "coordinates": [143.42341, -23.61214] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4731" },
      "geometry": { "type": "Point", "coordinates": [144.10204, -24.52828] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4732" },
      "geometry": { "type": "Point", "coordinates": [144.50012, -22.70355] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4733" },
      "geometry": { "type": "Point", "coordinates": [143.34744, -22.05076] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4735" },
      "geometry": { "type": "Point", "coordinates": [142.01799, -23.11813] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4736" },
      "geometry": { "type": "Point", "coordinates": [143.42497, -25.14218] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4737" },
      "geometry": { "type": "Point", "coordinates": [149.11592, -21.45171] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4738" },
      "geometry": { "type": "Point", "coordinates": [149.26376, -21.61657] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4739" },
      "geometry": { "type": "Point", "coordinates": [149.35116, -21.82923] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4740" },
      "geometry": { "type": "Point", "coordinates": [149.29934, -21.09214] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4741" },
      "geometry": { "type": "Point", "coordinates": [150.02418, -21.78377] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4742" },
      "geometry": { "type": "Point", "coordinates": [148.49084, -21.8031] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4743" },
      "geometry": { "type": "Point", "coordinates": [148.02301, -21.26695] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4744" },
      "geometry": { "type": "Point", "coordinates": [147.8653, -21.94775] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4745" },
      "geometry": { "type": "Point", "coordinates": [148.37865, -22.54739] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4746" },
      "geometry": { "type": "Point", "coordinates": [148.87077, -22.6398] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4750" },
      "geometry": { "type": "Point", "coordinates": [149.14946, -21.02928] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4751" },
      "geometry": { "type": "Point", "coordinates": [149.05201, -21.2101] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4753" },
      "geometry": { "type": "Point", "coordinates": [148.92051, -21.14004] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4754" },
      "geometry": { "type": "Point", "coordinates": [148.79757, -21.24146] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4756" },
      "geometry": { "type": "Point", "coordinates": [148.58571, -21.12605] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4757" },
      "geometry": { "type": "Point", "coordinates": [148.47682, -21.17885] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4798" },
      "geometry": { "type": "Point", "coordinates": [148.7369, -20.80802] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4799" },
      "geometry": { "type": "Point", "coordinates": [148.58722, -20.6877] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4800" },
      "geometry": { "type": "Point", "coordinates": [148.55318, -20.41321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4802" },
      "geometry": { "type": "Point", "coordinates": [148.88437, -20.25497] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4804" },
      "geometry": { "type": "Point", "coordinates": [147.42131, -20.99368] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4805" },
      "geometry": { "type": "Point", "coordinates": [147.75079, -20.27906] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4806" },
      "geometry": { "type": "Point", "coordinates": [147.38505, -19.79182] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4807" },
      "geometry": { "type": "Point", "coordinates": [147.33369, -19.73547] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4808" },
      "geometry": { "type": "Point", "coordinates": [147.33995, -19.48703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4809" },
      "geometry": { "type": "Point", "coordinates": [144.53703, -18.75429] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4810" },
      "geometry": { "type": "Point", "coordinates": [146.96203, -19.29864] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4811" },
      "geometry": { "type": "Point", "coordinates": [146.801, -19.3555] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4812" },
      "geometry": { "type": "Point", "coordinates": [146.79463, -19.28718] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4814" },
      "geometry": { "type": "Point", "coordinates": [146.76844, -19.30502] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4815" },
      "geometry": { "type": "Point", "coordinates": [146.67698, -19.43287] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4816" },
      "geometry": { "type": "Point", "coordinates": [144.99698, -19.83415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4817" },
      "geometry": { "type": "Point", "coordinates": [146.55372, -19.39317] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4818" },
      "geometry": { "type": "Point", "coordinates": [146.56475, -19.22951] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4819" },
      "geometry": { "type": "Point", "coordinates": [146.83651, -19.13982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4820" },
      "geometry": { "type": "Point", "coordinates": [146.28421, -20.46487] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4821" },
      "geometry": { "type": "Point", "coordinates": [144.29398, -20.74055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4822" },
      "geometry": { "type": "Point", "coordinates": [142.97044, -20.25171] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4823" },
      "geometry": { "type": "Point", "coordinates": [140.86427, -20.02085] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4824" },
      "geometry": { "type": "Point", "coordinates": [140.44737, -20.02192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4825" },
      "geometry": { "type": "Point", "coordinates": [139.10015, -19.12098] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4828" },
      "geometry": { "type": "Point", "coordinates": [138.61598, -19.67361] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4829" },
      "geometry": { "type": "Point", "coordinates": [139.69917, -23.53919] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4830" },
      "geometry": { "type": "Point", "coordinates": [139.02892, -17.89951] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4849" },
      "geometry": { "type": "Point", "coordinates": [146.06156, -18.36736] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4850" },
      "geometry": { "type": "Point", "coordinates": [145.69594, -18.73067] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4852" },
      "geometry": { "type": "Point", "coordinates": [146.10465, -17.89969] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4854" },
      "geometry": { "type": "Point", "coordinates": [145.81716, -17.97236] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4855" },
      "geometry": { "type": "Point", "coordinates": [145.88503, -17.78613] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4856" },
      "geometry": { "type": "Point", "coordinates": [145.97265, -17.73415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4858" },
      "geometry": { "type": "Point", "coordinates": [146.08103, -17.59521] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4859" },
      "geometry": { "type": "Point", "coordinates": [145.96342, -17.59541] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4860" },
      "geometry": { "type": "Point", "coordinates": [145.8264, -17.42572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4861" },
      "geometry": { "type": "Point", "coordinates": [145.94074, -17.32901] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4865" },
      "geometry": { "type": "Point", "coordinates": [145.77827, -17.10194] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4868" },
      "geometry": { "type": "Point", "coordinates": [145.74573, -16.97409] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4869" },
      "geometry": { "type": "Point", "coordinates": [145.75045, -17.02686] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4870" },
      "geometry": { "type": "Point", "coordinates": [145.71189, -16.96909] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4871" },
      "geometry": { "type": "Point", "coordinates": [144.29048, -18.62811] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4872" },
      "geometry": { "type": "Point", "coordinates": [145.26213, -17.88063] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4873" },
      "geometry": { "type": "Point", "coordinates": [145.29041, -16.22454] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4874" },
      "geometry": { "type": "Point", "coordinates": [142.33612, -11.93136] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4875" },
      "geometry": { "type": "Point", "coordinates": [143.02111, -9.76274] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4876" },
      "geometry": { "type": "Point", "coordinates": [142.33995, -10.89789] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4877" },
      "geometry": { "type": "Point", "coordinates": [145.50088, -16.58663] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4878" },
      "geometry": { "type": "Point", "coordinates": [145.70665, -16.83743] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4879" },
      "geometry": { "type": "Point", "coordinates": [145.68355, -16.77778] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4880" },
      "geometry": { "type": "Point", "coordinates": [145.37848, -17.00397] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4881" },
      "geometry": { "type": "Point", "coordinates": [145.59401, -16.84497] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4882" },
      "geometry": { "type": "Point", "coordinates": [145.4649, -17.19897] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4883" },
      "geometry": { "type": "Point", "coordinates": [145.48957, -17.31672] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4884" },
      "geometry": { "type": "Point", "coordinates": [145.67081, -17.27017] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4885" },
      "geometry": { "type": "Point", "coordinates": [145.62803, -17.36942] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4886" },
      "geometry": { "type": "Point", "coordinates": [145.59503, -17.51382] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4887" },
      "geometry": { "type": "Point", "coordinates": [145.25231, -17.39743] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4888" },
      "geometry": { "type": "Point", "coordinates": [145.42635, -17.56634] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4890" },
      "geometry": { "type": "Point", "coordinates": [141.37561, -17.44311] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4891" },
      "geometry": { "type": "Point", "coordinates": [140.85311, -17.50491] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4892" },
      "geometry": { "type": "Point", "coordinates": [141.9866, -15.3585] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "4895" },
      "geometry": { "type": "Point", "coordinates": [145.05216, -15.34862] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5000" },
      "geometry": { "type": "Point", "coordinates": [138.60004, -34.9255] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5006" },
      "geometry": { "type": "Point", "coordinates": [138.59628, -34.90993] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5007" },
      "geometry": { "type": "Point", "coordinates": [138.56807, -34.90474] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5008" },
      "geometry": { "type": "Point", "coordinates": [138.56882, -34.88782] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5009" },
      "geometry": { "type": "Point", "coordinates": [138.55178, -34.88846] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5010" },
      "geometry": { "type": "Point", "coordinates": [138.56505, -34.86221] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5011" },
      "geometry": { "type": "Point", "coordinates": [138.53522, -34.88444] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5012" },
      "geometry": { "type": "Point", "coordinates": [138.54616, -34.86222] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5013" },
      "geometry": { "type": "Point", "coordinates": [138.53836, -34.84291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5014" },
      "geometry": { "type": "Point", "coordinates": [138.51533, -34.86735] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5015" },
      "geometry": { "type": "Point", "coordinates": [138.52309, -34.79909] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5016" },
      "geometry": { "type": "Point", "coordinates": [138.49799, -34.82365] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5017" },
      "geometry": { "type": "Point", "coordinates": [138.50228, -34.80383] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5018" },
      "geometry": { "type": "Point", "coordinates": [138.49906, -34.77728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5019" },
      "geometry": { "type": "Point", "coordinates": [138.48397, -34.84976] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5020" },
      "geometry": { "type": "Point", "coordinates": [138.48394, -34.86687] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5021" },
      "geometry": { "type": "Point", "coordinates": [138.49425, -34.87055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5022" },
      "geometry": { "type": "Point", "coordinates": [138.49587, -34.90879] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5023" },
      "geometry": { "type": "Point", "coordinates": [138.52433, -34.89586] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5024" },
      "geometry": { "type": "Point", "coordinates": [138.51003, -34.93537] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5025" },
      "geometry": { "type": "Point", "coordinates": [138.53843, -34.91254] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5031" },
      "geometry": { "type": "Point", "coordinates": [138.56563, -34.92395] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5032" },
      "geometry": { "type": "Point", "coordinates": [138.537, -34.92534] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5033" },
      "geometry": { "type": "Point", "coordinates": [138.55725, -34.93919] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5034" },
      "geometry": { "type": "Point", "coordinates": [138.59068, -34.95401] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5035" },
      "geometry": { "type": "Point", "coordinates": [138.57818, -34.94771] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5037" },
      "geometry": { "type": "Point", "coordinates": [138.5541, -34.95478] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5038" },
      "geometry": { "type": "Point", "coordinates": [138.55002, -34.96824] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5039" },
      "geometry": { "type": "Point", "coordinates": [138.57209, -34.9805] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5040" },
      "geometry": { "type": "Point", "coordinates": [138.52969, -34.96675] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5041" },
      "geometry": { "type": "Point", "coordinates": [138.59534, -34.98998] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5042" },
      "geometry": { "type": "Point", "coordinates": [138.57528, -35.01593] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5043" },
      "geometry": { "type": "Point", "coordinates": [138.55602, -34.99764] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5044" },
      "geometry": { "type": "Point", "coordinates": [138.52623, -34.99117] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5045" },
      "geometry": { "type": "Point", "coordinates": [138.52317, -34.97363] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5046" },
      "geometry": { "type": "Point", "coordinates": [138.5386, -35.00806] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5047" },
      "geometry": { "type": "Point", "coordinates": [138.55496, -35.02776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5048" },
      "geometry": { "type": "Point", "coordinates": [138.52396, -35.01647] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5049" },
      "geometry": { "type": "Point", "coordinates": [138.52071, -35.04553] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5050" },
      "geometry": { "type": "Point", "coordinates": [138.59196, -35.02609] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5051" },
      "geometry": { "type": "Point", "coordinates": [138.62315, -35.03089] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5052" },
      "geometry": { "type": "Point", "coordinates": [138.63587, -35.00797] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5061" },
      "geometry": { "type": "Point", "coordinates": [138.60416, -34.95196] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5062" },
      "geometry": { "type": "Point", "coordinates": [138.6401, -34.98475] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5063" },
      "geometry": { "type": "Point", "coordinates": [138.62211, -34.95142] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5064" },
      "geometry": { "type": "Point", "coordinates": [138.64594, -34.96233] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5065" },
      "geometry": { "type": "Point", "coordinates": [138.63988, -34.9376] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5066" },
      "geometry": { "type": "Point", "coordinates": [138.66944, -34.94819] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5067" },
      "geometry": { "type": "Point", "coordinates": [138.63144, -34.92446] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5068" },
      "geometry": { "type": "Point", "coordinates": [138.65228, -34.91952] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5069" },
      "geometry": { "type": "Point", "coordinates": [138.62334, -34.90712] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5070" },
      "geometry": { "type": "Point", "coordinates": [138.6398, -34.89606] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5072" },
      "geometry": { "type": "Point", "coordinates": [138.69919, -34.91133] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5073" },
      "geometry": { "type": "Point", "coordinates": [138.6892, -34.89831] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5074" },
      "geometry": { "type": "Point", "coordinates": [138.66585, -34.88055] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5075" },
      "geometry": { "type": "Point", "coordinates": [138.67575, -34.86575] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5076" },
      "geometry": { "type": "Point", "coordinates": [138.73155, -34.87107] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5081" },
      "geometry": { "type": "Point", "coordinates": [138.61574, -34.89454] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5082" },
      "geometry": { "type": "Point", "coordinates": [138.59477, -34.88804] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5083" },
      "geometry": { "type": "Point", "coordinates": [138.61038, -34.87901] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5084" },
      "geometry": { "type": "Point", "coordinates": [138.58505, -34.85675] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5085" },
      "geometry": { "type": "Point", "coordinates": [138.62313, -34.85541] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5086" },
      "geometry": { "type": "Point", "coordinates": [138.6467, -34.85733] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5087" },
      "geometry": { "type": "Point", "coordinates": [138.65049, -34.87275] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5088" },
      "geometry": { "type": "Point", "coordinates": [138.67227, -34.85147] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5089" },
      "geometry": { "type": "Point", "coordinates": [138.70675, -34.85685] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5090" },
      "geometry": { "type": "Point", "coordinates": [138.69835, -34.84428] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5091" },
      "geometry": { "type": "Point", "coordinates": [138.73567, -34.82691] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5092" },
      "geometry": { "type": "Point", "coordinates": [138.68419, -34.8241] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5093" },
      "geometry": { "type": "Point", "coordinates": [138.6615, -34.83499] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5094" },
      "geometry": { "type": "Point", "coordinates": [138.57044, -34.81808] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5095" },
      "geometry": { "type": "Point", "coordinates": [138.61607, -34.81505] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5096" },
      "geometry": { "type": "Point", "coordinates": [138.66161, -34.8027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5097" },
      "geometry": { "type": "Point", "coordinates": [138.70246, -34.82099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5098" },
      "geometry": { "type": "Point", "coordinates": [138.64299, -34.83396] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5106" },
      "geometry": { "type": "Point", "coordinates": [138.6351, -34.79388] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5107" },
      "geometry": { "type": "Point", "coordinates": [138.60811, -34.78563] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5108" },
      "geometry": { "type": "Point", "coordinates": [138.6189, -34.75939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5109" },
      "geometry": { "type": "Point", "coordinates": [138.66916, -34.76983] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5110" },
      "geometry": { "type": "Point", "coordinates": [138.55934, -34.73684] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5111" },
      "geometry": { "type": "Point", "coordinates": [138.63412, -34.72135] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5112" },
      "geometry": { "type": "Point", "coordinates": [138.67397, -34.73643] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5113" },
      "geometry": { "type": "Point", "coordinates": [138.68152, -34.70426] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5114" },
      "geometry": { "type": "Point", "coordinates": [138.76898, -34.70317] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5115" },
      "geometry": { "type": "Point", "coordinates": [138.68974, -34.65345] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5116" },
      "geometry": { "type": "Point", "coordinates": [138.71952, -34.6259] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5117" },
      "geometry": { "type": "Point", "coordinates": [138.65407, -34.63309] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5118" },
      "geometry": { "type": "Point", "coordinates": [138.75109, -34.59736] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5120" },
      "geometry": { "type": "Point", "coordinates": [138.52284, -34.67989] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5121" },
      "geometry": { "type": "Point", "coordinates": [138.62229, -34.66952] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5125" },
      "geometry": { "type": "Point", "coordinates": [138.72504, -34.77683] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5126" },
      "geometry": { "type": "Point", "coordinates": [138.73178, -34.79498] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5127" },
      "geometry": { "type": "Point", "coordinates": [138.68965, -34.79925] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5131" },
      "geometry": { "type": "Point", "coordinates": [138.76359, -34.80088] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5132" },
      "geometry": { "type": "Point", "coordinates": [138.7635, -34.84732] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5133" },
      "geometry": { "type": "Point", "coordinates": [138.78549, -34.80851] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5134" },
      "geometry": { "type": "Point", "coordinates": [138.76341, -34.89269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5136" },
      "geometry": { "type": "Point", "coordinates": [138.73489, -34.91777] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5137" },
      "geometry": { "type": "Point", "coordinates": [138.74227, -34.93809] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5138" },
      "geometry": { "type": "Point", "coordinates": [138.77395, -34.93978] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5139" },
      "geometry": { "type": "Point", "coordinates": [138.8011, -34.92416] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5140" },
      "geometry": { "type": "Point", "coordinates": [138.69032, -34.95014] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5141" },
      "geometry": { "type": "Point", "coordinates": [138.71396, -34.94243] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5142" },
      "geometry": { "type": "Point", "coordinates": [138.74393, -34.96229] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5144" },
      "geometry": { "type": "Point", "coordinates": [138.76867, -34.96541] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5150" },
      "geometry": { "type": "Point", "coordinates": [138.66869, -34.97224] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5151" },
      "geometry": { "type": "Point", "coordinates": [138.73504, -34.9769] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5152" },
      "geometry": { "type": "Point", "coordinates": [138.70247, -34.98688] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5153" },
      "geometry": { "type": "Point", "coordinates": [138.78206, -35.11977] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5154" },
      "geometry": { "type": "Point", "coordinates": [138.73882, -35.0176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5155" },
      "geometry": { "type": "Point", "coordinates": [138.76259, -35.00447] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5156" },
      "geometry": { "type": "Point", "coordinates": [138.68339, -35.02462] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5157" },
      "geometry": { "type": "Point", "coordinates": [138.70177, -35.19656] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5158" },
      "geometry": { "type": "Point", "coordinates": [138.53468, -35.06492] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5159" },
      "geometry": { "type": "Point", "coordinates": [138.59581, -35.06861] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5160" },
      "geometry": { "type": "Point", "coordinates": [138.48946, -35.10709] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5161" },
      "geometry": { "type": "Point", "coordinates": [138.53437, -35.09226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5162" },
      "geometry": { "type": "Point", "coordinates": [138.53745, -35.12019] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5163" },
      "geometry": { "type": "Point", "coordinates": [138.55703, -35.13896] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5164" },
      "geometry": { "type": "Point", "coordinates": [138.49579, -35.12831] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5165" },
      "geometry": { "type": "Point", "coordinates": [138.47519, -35.13475] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5166" },
      "geometry": { "type": "Point", "coordinates": [138.4757, -35.1228] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5167" },
      "geometry": { "type": "Point", "coordinates": [138.47764, -35.15685] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5168" },
      "geometry": { "type": "Point", "coordinates": [138.50202, -35.1716] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5169" },
      "geometry": { "type": "Point", "coordinates": [138.48564, -35.18947] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5170" },
      "geometry": { "type": "Point", "coordinates": [138.48142, -35.23008] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5171" },
      "geometry": { "type": "Point", "coordinates": [138.58076, -35.19277] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5172" },
      "geometry": { "type": "Point", "coordinates": [138.58811, -35.30779] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5173" },
      "geometry": { "type": "Point", "coordinates": [138.47074, -35.27638] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5174" },
      "geometry": { "type": "Point", "coordinates": [138.4781, -35.33997] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5201" },
      "geometry": { "type": "Point", "coordinates": [138.72609, -35.21452] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5202" },
      "geometry": { "type": "Point", "coordinates": [138.46546, -35.41426] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5203" },
      "geometry": { "type": "Point", "coordinates": [138.36373, -35.51112] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5204" },
      "geometry": { "type": "Point", "coordinates": [138.22283, -35.57562] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5210" },
      "geometry": { "type": "Point", "coordinates": [138.64513, -35.34534] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5211" },
      "geometry": { "type": "Point", "coordinates": [138.52539, -35.52246] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5212" },
      "geometry": { "type": "Point", "coordinates": [138.67416, -35.50946] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5213" },
      "geometry": { "type": "Point", "coordinates": [138.71299, -35.47557] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5214" },
      "geometry": { "type": "Point", "coordinates": [138.81496, -35.48021] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5220" },
      "geometry": { "type": "Point", "coordinates": [137.25452, -35.78237] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5221" },
      "geometry": { "type": "Point", "coordinates": [137.75814, -35.7791] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5222" },
      "geometry": { "type": "Point", "coordinates": [137.96815, -35.79914] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5223" },
      "geometry": { "type": "Point", "coordinates": [137.21418, -35.82024] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5231" },
      "geometry": { "type": "Point", "coordinates": [138.83998, -34.77605] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5232" },
      "geometry": { "type": "Point", "coordinates": [138.83258, -34.85984] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5233" },
      "geometry": { "type": "Point", "coordinates": [138.90224, -34.81265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5234" },
      "geometry": { "type": "Point", "coordinates": [138.99076, -34.81922] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5235" },
      "geometry": { "type": "Point", "coordinates": [139.09026, -34.69954] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5236" },
      "geometry": { "type": "Point", "coordinates": [139.06191, -34.86582] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5237" },
      "geometry": { "type": "Point", "coordinates": [139.19368, -34.79248] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5238" },
      "geometry": { "type": "Point", "coordinates": [139.48137, -34.77357] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5240" },
      "geometry": { "type": "Point", "coordinates": [138.82706, -34.92489] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5241" },
      "geometry": { "type": "Point", "coordinates": [138.8731, -34.90196] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5242" },
      "geometry": { "type": "Point", "coordinates": [138.82248, -34.99762] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5243" },
      "geometry": { "type": "Point", "coordinates": [138.85249, -34.98061] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5244" },
      "geometry": { "type": "Point", "coordinates": [138.94197, -34.94585] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5245" },
      "geometry": { "type": "Point", "coordinates": [138.80435, -35.03154] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5250" },
      "geometry": { "type": "Point", "coordinates": [138.86332, -35.04045] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5251" },
      "geometry": { "type": "Point", "coordinates": [138.89896, -35.10013] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5252" },
      "geometry": { "type": "Point", "coordinates": [138.95855, -35.04641] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5253" },
      "geometry": { "type": "Point", "coordinates": [139.36768, -35.09522] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5254" },
      "geometry": { "type": "Point", "coordinates": [139.17333, -35.05338] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5255" },
      "geometry": { "type": "Point", "coordinates": [138.94586, -35.29397] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5256" },
      "geometry": { "type": "Point", "coordinates": [138.96892, -35.44378] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5259" },
      "geometry": { "type": "Point", "coordinates": [139.22854, -35.43089] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5260" },
      "geometry": { "type": "Point", "coordinates": [139.49414, -35.27532] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5261" },
      "geometry": { "type": "Point", "coordinates": [139.7327, -35.55655] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5262" },
      "geometry": { "type": "Point", "coordinates": [140.85428, -36.82964] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5263" },
      "geometry": { "type": "Point", "coordinates": [140.90838, -37.28951] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5264" },
      "geometry": { "type": "Point", "coordinates": [139.38774, -35.87147] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5265" },
      "geometry": { "type": "Point", "coordinates": [139.8637, -35.71349] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5266" },
      "geometry": { "type": "Point", "coordinates": [140.05743, -35.93159] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5267" },
      "geometry": { "type": "Point", "coordinates": [140.46986, -36.11056] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5268" },
      "geometry": { "type": "Point", "coordinates": [140.80419, -36.43961] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5269" },
      "geometry": { "type": "Point", "coordinates": [140.88256, -36.37519] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5270" },
      "geometry": { "type": "Point", "coordinates": [140.5607, -36.4123] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5271" },
      "geometry": { "type": "Point", "coordinates": [140.61977, -36.9314] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5272" },
      "geometry": { "type": "Point", "coordinates": [140.32745, -37.09411] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5273" },
      "geometry": { "type": "Point", "coordinates": [140.19747, -36.95406] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5275" },
      "geometry": { "type": "Point", "coordinates": [139.96762, -36.82742] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5276" },
      "geometry": { "type": "Point", "coordinates": [139.91273, -37.26053] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5277" },
      "geometry": { "type": "Point", "coordinates": [140.84082, -37.51106] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5278" },
      "geometry": { "type": "Point", "coordinates": [140.7101, -37.58193] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5279" },
      "geometry": { "type": "Point", "coordinates": [140.55567, -37.4613] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5280" },
      "geometry": { "type": "Point", "coordinates": [140.27233, -37.49211] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5290" },
      "geometry": { "type": "Point", "coordinates": [140.77749, -37.82983] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5291" },
      "geometry": { "type": "Point", "coordinates": [140.60934, -37.82657] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5301" },
      "geometry": { "type": "Point", "coordinates": [140.05773, -35.41472] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5302" },
      "geometry": { "type": "Point", "coordinates": [140.53347, -35.5253] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5303" },
      "geometry": { "type": "Point", "coordinates": [140.65733, -35.37041] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5304" },
      "geometry": { "type": "Point", "coordinates": [140.82704, -35.18222] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5306" },
      "geometry": { "type": "Point", "coordinates": [139.73743, -35.14704] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5307" },
      "geometry": { "type": "Point", "coordinates": [139.99393, -35.12981] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5308" },
      "geometry": { "type": "Point", "coordinates": [139.97079, -34.74221] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5309" },
      "geometry": { "type": "Point", "coordinates": [140.2131, -34.94042] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5310" },
      "geometry": { "type": "Point", "coordinates": [140.27825, -34.67254] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5311" },
      "geometry": { "type": "Point", "coordinates": [140.45951, -34.68342] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5320" },
      "geometry": { "type": "Point", "coordinates": [139.61358, -34.02428] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5321" },
      "geometry": { "type": "Point", "coordinates": [139.77386, -34.06269] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5322" },
      "geometry": { "type": "Point", "coordinates": [139.91687, -34.12337] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5330" },
      "geometry": { "type": "Point", "coordinates": [140.03768, -34.18052] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5331" },
      "geometry": { "type": "Point", "coordinates": [140.33999, -34.20971] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5332" },
      "geometry": { "type": "Point", "coordinates": [140.31195, -34.3204] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5333" },
      "geometry": { "type": "Point", "coordinates": [140.47282, -34.51866] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5340" },
      "geometry": { "type": "Point", "coordinates": [140.85028, -34.09238] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5341" },
      "geometry": { "type": "Point", "coordinates": [140.84368, -34.04444] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5342" },
      "geometry": { "type": "Point", "coordinates": [140.59168, -34.22158] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5343" },
      "geometry": { "type": "Point", "coordinates": [140.57001, -34.36233] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5344" },
      "geometry": { "type": "Point", "coordinates": [140.54926, -34.28089] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5345" },
      "geometry": { "type": "Point", "coordinates": [140.44533, -34.27233] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5346" },
      "geometry": { "type": "Point", "coordinates": [140.41301, -34.23165] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5350" },
      "geometry": { "type": "Point", "coordinates": [138.83155, -34.5904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5351" },
      "geometry": { "type": "Point", "coordinates": [138.95457, -34.688] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5352" },
      "geometry": { "type": "Point", "coordinates": [138.93263, -34.55212] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5353" },
      "geometry": { "type": "Point", "coordinates": [139.41816, -34.60094] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5354" },
      "geometry": { "type": "Point", "coordinates": [139.69736, -34.61268] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5355" },
      "geometry": { "type": "Point", "coordinates": [138.9843, -34.44996] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5356" },
      "geometry": { "type": "Point", "coordinates": [139.22899, -34.4009] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5357" },
      "geometry": { "type": "Point", "coordinates": [139.69573, -34.30506] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5360" },
      "geometry": { "type": "Point", "coordinates": [138.91079, -34.44682] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5371" },
      "geometry": { "type": "Point", "coordinates": [138.77704, -34.4907] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5372" },
      "geometry": { "type": "Point", "coordinates": [138.82793, -34.45348] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5373" },
      "geometry": { "type": "Point", "coordinates": [138.90271, -34.32075] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5374" },
      "geometry": { "type": "Point", "coordinates": [139.1447, -34.13118] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5381" },
      "geometry": { "type": "Point", "coordinates": [139.07247, -33.94192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5400" },
      "geometry": { "type": "Point", "coordinates": [138.64282, -34.44753] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5401" },
      "geometry": { "type": "Point", "coordinates": [138.64921, -34.24886] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5410" },
      "geometry": { "type": "Point", "coordinates": [138.74502, -34.34176] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5411" },
      "geometry": { "type": "Point", "coordinates": [138.76949, -34.25676] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5412" },
      "geometry": { "type": "Point", "coordinates": [138.70928, -34.15362] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5413" },
      "geometry": { "type": "Point", "coordinates": [138.89645, -34.00965] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5414" },
      "geometry": { "type": "Point", "coordinates": [138.80216, -33.98157] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5415" },
      "geometry": { "type": "Point", "coordinates": [138.75091, -33.90965] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5416" },
      "geometry": { "type": "Point", "coordinates": [138.83659, -33.81778] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5417" },
      "geometry": { "type": "Point", "coordinates": [139.593, -33.60189] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5418" },
      "geometry": { "type": "Point", "coordinates": [139.03308, -33.50035] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5419" },
      "geometry": { "type": "Point", "coordinates": [138.99785, -33.36454] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5420" },
      "geometry": { "type": "Point", "coordinates": [138.87389, -33.23878] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5421" },
      "geometry": { "type": "Point", "coordinates": [138.9446, -33.14447] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5422" },
      "geometry": { "type": "Point", "coordinates": [138.89145, -32.91296] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5431" },
      "geometry": { "type": "Point", "coordinates": [138.53176, -32.71259] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5432" },
      "geometry": { "type": "Point", "coordinates": [139.06001, -31.95175] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5433" },
      "geometry": { "type": "Point", "coordinates": [138.16408, -32.33695] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5434" },
      "geometry": { "type": "Point", "coordinates": [138.61101, -31.5373] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5440" },
      "geometry": { "type": "Point", "coordinates": [139.96199, -31.54265] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5451" },
      "geometry": { "type": "Point", "coordinates": [138.65746, -34.0463] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5452" },
      "geometry": { "type": "Point", "coordinates": [138.64452, -33.98158] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5453" },
      "geometry": { "type": "Point", "coordinates": [138.65612, -33.8109] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5454" },
      "geometry": { "type": "Point", "coordinates": [138.63722, -33.43551] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5455" },
      "geometry": { "type": "Point", "coordinates": [138.65636, -33.69825] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5460" },
      "geometry": { "type": "Point", "coordinates": [138.50963, -34.28321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5461" },
      "geometry": { "type": "Point", "coordinates": [138.41556, -34.07949] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5462" },
      "geometry": { "type": "Point", "coordinates": [138.47027, -33.83151] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5464" },
      "geometry": { "type": "Point", "coordinates": [138.39372, -33.73544] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5470" },
      "geometry": { "type": "Point", "coordinates": [138.50958, -33.55832] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5471" },
      "geometry": { "type": "Point", "coordinates": [138.48027, -33.46647] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5472" },
      "geometry": { "type": "Point", "coordinates": [138.41049, -33.3653] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5473" },
      "geometry": { "type": "Point", "coordinates": [138.37216, -33.26487] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5480" },
      "geometry": { "type": "Point", "coordinates": [138.30931, -33.12007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5481" },
      "geometry": { "type": "Point", "coordinates": [138.24171, -33.00385] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5482" },
      "geometry": { "type": "Point", "coordinates": [138.35007, -32.89494] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5483" },
      "geometry": { "type": "Point", "coordinates": [138.18948, -32.80254] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5485" },
      "geometry": { "type": "Point", "coordinates": [138.09968, -32.69411] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5490" },
      "geometry": { "type": "Point", "coordinates": [138.4631, -33.17525] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5491" },
      "geometry": { "type": "Point", "coordinates": [138.57388, -33.17165] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5493" },
      "geometry": { "type": "Point", "coordinates": [138.74314, -33.02049] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5495" },
      "geometry": { "type": "Point", "coordinates": [138.01212, -32.83898] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5501" },
      "geometry": { "type": "Point", "coordinates": [138.40135, -34.47748] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5502" },
      "geometry": { "type": "Point", "coordinates": [138.52555, -34.47877] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5510" },
      "geometry": { "type": "Point", "coordinates": [138.13666, -33.91437] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5520" },
      "geometry": { "type": "Point", "coordinates": [138.19901, -33.78608] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5521" },
      "geometry": { "type": "Point", "coordinates": [138.19791, -33.54673] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5522" },
      "geometry": { "type": "Point", "coordinates": [137.94972, -33.62987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5523" },
      "geometry": { "type": "Point", "coordinates": [138.03257, -33.39641] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5540" },
      "geometry": { "type": "Point", "coordinates": [137.96441, -33.21376] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5550" },
      "geometry": { "type": "Point", "coordinates": [138.18725, -34.12976] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5552" },
      "geometry": { "type": "Point", "coordinates": [137.94719, -34.10113] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5554" },
      "geometry": { "type": "Point", "coordinates": [137.79127, -33.97753] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5555" },
      "geometry": { "type": "Point", "coordinates": [137.98474, -33.70234] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5556" },
      "geometry": { "type": "Point", "coordinates": [137.66857, -33.87329] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5558" },
      "geometry": { "type": "Point", "coordinates": [137.58645, -34.10877] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5560" },
      "geometry": { "type": "Point", "coordinates": [137.9888, -33.85685] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5570" },
      "geometry": { "type": "Point", "coordinates": [137.9769, -34.30483] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5571" },
      "geometry": { "type": "Point", "coordinates": [137.83518, -34.48699] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5572" },
      "geometry": { "type": "Point", "coordinates": [137.75749, -34.23771] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5573" },
      "geometry": { "type": "Point", "coordinates": [137.57079, -34.40276] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5575" },
      "geometry": { "type": "Point", "coordinates": [137.24927, -34.99804] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5576" },
      "geometry": { "type": "Point", "coordinates": [137.61333, -35.08188] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5577" },
      "geometry": { "type": "Point", "coordinates": [137.14198, -35.10092] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5580" },
      "geometry": { "type": "Point", "coordinates": [137.78077, -34.67423] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5581" },
      "geometry": { "type": "Point", "coordinates": [137.84655, -34.74821] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5582" },
      "geometry": { "type": "Point", "coordinates": [137.76975, -34.89426] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5583" },
      "geometry": { "type": "Point", "coordinates": [137.72338, -35.07633] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5600" },
      "geometry": { "type": "Point", "coordinates": [137.56903, -33.03553] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5601" },
      "geometry": { "type": "Point", "coordinates": [137.55764, -33.01043] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5602" },
      "geometry": { "type": "Point", "coordinates": [137.00314, -33.50908] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5603" },
      "geometry": { "type": "Point", "coordinates": [136.28277, -33.86417] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5604" },
      "geometry": { "type": "Point", "coordinates": [136.34101, -34.07418] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5605" },
      "geometry": { "type": "Point", "coordinates": [136.18, -34.43676] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5606" },
      "geometry": { "type": "Point", "coordinates": [136.23123, -34.98775] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5607" },
      "geometry": { "type": "Point", "coordinates": [135.42612, -34.16086] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5608" },
      "geometry": { "type": "Point", "coordinates": [137.53679, -33.04707] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5609" },
      "geometry": { "type": "Point", "coordinates": [137.50853, -33.02384] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5611" },
      "geometry": { "type": "Point", "coordinates": [137.06118, -32.94932] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5630" },
      "geometry": { "type": "Point", "coordinates": [135.6909, -34.39261] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5631" },
      "geometry": { "type": "Point", "coordinates": [135.68521, -34.27473] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5632" },
      "geometry": { "type": "Point", "coordinates": [135.60989, -34.09072] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5633" },
      "geometry": { "type": "Point", "coordinates": [135.73152, -33.54904] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5640" },
      "geometry": { "type": "Point", "coordinates": [136.42769, -33.56523] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5641" },
      "geometry": { "type": "Point", "coordinates": [136.07273, -33.00168] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5642" },
      "geometry": { "type": "Point", "coordinates": [136.15672, -33.53933] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5650" },
      "geometry": { "type": "Point", "coordinates": [135.64982, -33.20705] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5651" },
      "geometry": { "type": "Point", "coordinates": [135.67032, -33.12872] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5652" },
      "geometry": { "type": "Point", "coordinates": [135.39372, -33.03294] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5653" },
      "geometry": { "type": "Point", "coordinates": [135.26377, -32.96728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5654" },
      "geometry": { "type": "Point", "coordinates": [135.05125, -33.02407] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5655" },
      "geometry": { "type": "Point", "coordinates": [135.12313, -32.62972] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5660" },
      "geometry": { "type": "Point", "coordinates": [134.59263, -32.58746] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5661" },
      "geometry": { "type": "Point", "coordinates": [134.63182, -32.38592] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5670" },
      "geometry": { "type": "Point", "coordinates": [134.9288, -33.53575] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5671" },
      "geometry": { "type": "Point", "coordinates": [134.49622, -33.06281] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5680" },
      "geometry": { "type": "Point", "coordinates": [134.2871, -32.65151] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5690" },
      "geometry": { "type": "Point", "coordinates": [132.90213, -31.07908] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5700" },
      "geometry": { "type": "Point", "coordinates": [137.74391, -32.6274] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5701" },
      "geometry": { "type": "Point", "coordinates": [136.63388, -31.82878] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5710" },
      "geometry": { "type": "Point", "coordinates": [137.87299, -32.50994] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5713" },
      "geometry": { "type": "Point", "coordinates": [137.47913, -31.1059] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5715" },
      "geometry": { "type": "Point", "coordinates": [136.93657, -32.31219] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5717" },
      "geometry": { "type": "Point", "coordinates": [135.96146, -32.03932] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5719" },
      "geometry": { "type": "Point", "coordinates": [136.00836, -30.74359] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5720" },
      "geometry": { "type": "Point", "coordinates": [136.76082, -30.54821] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5722" },
      "geometry": { "type": "Point", "coordinates": [137.16504, -30.45358] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5723" },
      "geometry": { "type": "Point", "coordinates": [136.2483, -28.99377] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5724" },
      "geometry": { "type": "Point", "coordinates": [134.41244, -27.00536] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5725" },
      "geometry": { "type": "Point", "coordinates": [136.88415, -30.48423] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5730" },
      "geometry": { "type": "Point", "coordinates": [138.54284, -30.95375] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5731" },
      "geometry": { "type": "Point", "coordinates": [139.53588, -28.30575] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5732" },
      "geometry": { "type": "Point", "coordinates": [139.47657, -30.25263] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5733" },
      "geometry": { "type": "Point", "coordinates": [138.1571, -28.52487] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5734" },
      "geometry": { "type": "Point", "coordinates": [137.01231, -27.03969] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "5950" },
      "geometry": { "type": "Point", "coordinates": [138.53373, -34.94847] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6000" },
      "geometry": { "type": "Point", "coordinates": [115.86094, -31.94754] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6003" },
      "geometry": { "type": "Point", "coordinates": [115.86359, -31.9422] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6004" },
      "geometry": { "type": "Point", "coordinates": [115.87685, -31.95638] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6005" },
      "geometry": { "type": "Point", "coordinates": [115.8323, -31.96162] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6006" },
      "geometry": { "type": "Point", "coordinates": [115.85072, -31.92569] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6007" },
      "geometry": { "type": "Point", "coordinates": [115.83616, -31.9343] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6008" },
      "geometry": { "type": "Point", "coordinates": [115.80982, -31.95164] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6009" },
      "geometry": { "type": "Point", "coordinates": [115.80691, -31.98675] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6010" },
      "geometry": { "type": "Point", "coordinates": [115.78108, -31.97172] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6011" },
      "geometry": { "type": "Point", "coordinates": [115.7602, -31.99522] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6012" },
      "geometry": { "type": "Point", "coordinates": [115.76557, -32.01667] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6014" },
      "geometry": { "type": "Point", "coordinates": [115.80955, -31.93373] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6015" },
      "geometry": { "type": "Point", "coordinates": [115.76936, -31.94173] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6016" },
      "geometry": { "type": "Point", "coordinates": [115.83014, -31.92088] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6017" },
      "geometry": { "type": "Point", "coordinates": [115.80996, -31.9134] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6018" },
      "geometry": { "type": "Point", "coordinates": [115.78755, -31.89663] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6019" },
      "geometry": { "type": "Point", "coordinates": [115.77253, -31.91132] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6020" },
      "geometry": { "type": "Point", "coordinates": [115.76557, -31.84001] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6021" },
      "geometry": { "type": "Point", "coordinates": [115.8105, -31.87845] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6022" },
      "geometry": { "type": "Point", "coordinates": [115.81407, -31.85004] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6023" },
      "geometry": { "type": "Point", "coordinates": [115.77482, -31.83246] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6024" },
      "geometry": { "type": "Point", "coordinates": [115.8026, -31.83571] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6025" },
      "geometry": { "type": "Point", "coordinates": [115.75875, -31.80266] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6026" },
      "geometry": { "type": "Point", "coordinates": [115.8004, -31.79786] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6027" },
      "geometry": { "type": "Point", "coordinates": [115.76344, -31.75203] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6028" },
      "geometry": { "type": "Point", "coordinates": [115.73394, -31.72746] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6029" },
      "geometry": { "type": "Point", "coordinates": [115.75833, -31.87696] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6030" },
      "geometry": { "type": "Point", "coordinates": [115.71287, -31.6689] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6031" },
      "geometry": { "type": "Point", "coordinates": [115.77977, -31.68369] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6032" },
      "geometry": { "type": "Point", "coordinates": [115.75192, -31.63386] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6033" },
      "geometry": { "type": "Point", "coordinates": [115.72039, -31.59352] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6034" },
      "geometry": { "type": "Point", "coordinates": [115.67108, -31.58689] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6035" },
      "geometry": { "type": "Point", "coordinates": [115.71351, -31.52131] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6036" },
      "geometry": { "type": "Point", "coordinates": [115.70103, -31.64561] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6037" },
      "geometry": { "type": "Point", "coordinates": [115.60802, -31.48699] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6038" },
      "geometry": { "type": "Point", "coordinates": [115.68647, -31.61092] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6041" },
      "geometry": { "type": "Point", "coordinates": [115.57979, -31.35927] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6042" },
      "geometry": { "type": "Point", "coordinates": [115.45661, -31.26578] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6043" },
      "geometry": { "type": "Point", "coordinates": [115.46621, -31.15507] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6044" },
      "geometry": { "type": "Point", "coordinates": [115.35381, -30.92716] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6050" },
      "geometry": { "type": "Point", "coordinates": [115.87156, -31.92623] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6051" },
      "geometry": { "type": "Point", "coordinates": [115.89995, -31.94084] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6052" },
      "geometry": { "type": "Point", "coordinates": [115.8836, -31.91349] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6053" },
      "geometry": { "type": "Point", "coordinates": [115.92235, -31.91452] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6054" },
      "geometry": { "type": "Point", "coordinates": [115.94756, -31.90345] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6055" },
      "geometry": { "type": "Point", "coordinates": [116.00095, -31.87379] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6056" },
      "geometry": { "type": "Point", "coordinates": [116.04407, -31.85226] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6057" },
      "geometry": { "type": "Point", "coordinates": [116.01363, -31.95318] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6058" },
      "geometry": { "type": "Point", "coordinates": [116.0125, -31.98192] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6059" },
      "geometry": { "type": "Point", "coordinates": [115.87063, -31.88658] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6060" },
      "geometry": { "type": "Point", "coordinates": [115.84289, -31.89996] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6061" },
      "geometry": { "type": "Point", "coordinates": [115.85237, -31.86114] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6062" },
      "geometry": { "type": "Point", "coordinates": [115.90454, -31.88961] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6063" },
      "geometry": { "type": "Point", "coordinates": [115.94376, -31.86187] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6064" },
      "geometry": { "type": "Point", "coordinates": [115.84757, -31.83512] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6065" },
      "geometry": { "type": "Point", "coordinates": [115.82774, -31.77112] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6066" },
      "geometry": { "type": "Point", "coordinates": [115.89699, -31.83987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6067" },
      "geometry": { "type": "Point", "coordinates": [115.90182, -31.81991] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6068" },
      "geometry": { "type": "Point", "coordinates": [115.94241, -31.83141] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6069" },
      "geometry": { "type": "Point", "coordinates": [116.01646, -31.77223] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6070" },
      "geometry": { "type": "Point", "coordinates": [116.07965, -31.92744] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6071" },
      "geometry": { "type": "Point", "coordinates": [116.10109, -31.89517] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6072" },
      "geometry": { "type": "Point", "coordinates": [116.13349, -31.9206] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6073" },
      "geometry": { "type": "Point", "coordinates": [116.15949, -31.92299] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6074" },
      "geometry": { "type": "Point", "coordinates": [116.25669, -31.96419] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6076" },
      "geometry": { "type": "Point", "coordinates": [116.14755, -31.99821] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6077" },
      "geometry": { "type": "Point", "coordinates": [115.85475, -31.75318] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6078" },
      "geometry": { "type": "Point", "coordinates": [115.8247, -31.63655] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6079" },
      "geometry": { "type": "Point", "coordinates": [115.92466, -31.72318] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6081" },
      "geometry": { "type": "Point", "coordinates": [116.15828, -31.86929] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6082" },
      "geometry": { "type": "Point", "coordinates": [116.2604, -31.79667] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6083" },
      "geometry": { "type": "Point", "coordinates": [116.24218, -31.7189] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6084" },
      "geometry": { "type": "Point", "coordinates": [116.05183, -31.57696] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6090" },
      "geometry": { "type": "Point", "coordinates": [115.89711, -31.85758] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6100" },
      "geometry": { "type": "Point", "coordinates": [115.89179, -31.9544] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6101" },
      "geometry": { "type": "Point", "coordinates": [115.91087, -31.98408] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6102" },
      "geometry": { "type": "Point", "coordinates": [115.90306, -32.00244] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6103" },
      "geometry": { "type": "Point", "coordinates": [115.91375, -31.96106] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6104" },
      "geometry": { "type": "Point", "coordinates": [115.93562, -31.93855] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6105" },
      "geometry": { "type": "Point", "coordinates": [115.96543, -31.9509] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6106" },
      "geometry": { "type": "Point", "coordinates": [115.95047, -31.99448] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6107" },
      "geometry": { "type": "Point", "coordinates": [115.96369, -32.01584] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6108" },
      "geometry": { "type": "Point", "coordinates": [115.96131, -32.05801] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6109" },
      "geometry": { "type": "Point", "coordinates": [116.01424, -32.04846] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6110" },
      "geometry": { "type": "Point", "coordinates": [116.00732, -32.07962] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6111" },
      "geometry": { "type": "Point", "coordinates": [116.12606, -32.12691] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6112" },
      "geometry": { "type": "Point", "coordinates": [116.00571, -32.16709] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6121" },
      "geometry": { "type": "Point", "coordinates": [115.91454, -32.24286] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6122" },
      "geometry": { "type": "Point", "coordinates": [116.03608, -32.23421] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6123" },
      "geometry": { "type": "Point", "coordinates": [115.99742, -32.277] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6124" },
      "geometry": { "type": "Point", "coordinates": [116.14261, -32.36388] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6125" },
      "geometry": { "type": "Point", "coordinates": [116.00345, -32.37444] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6126" },
      "geometry": { "type": "Point", "coordinates": [116.04213, -32.4423] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6147" },
      "geometry": { "type": "Point", "coordinates": [115.93418, -32.0422] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6148" },
      "geometry": { "type": "Point", "coordinates": [115.89892, -32.0321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6149" },
      "geometry": { "type": "Point", "coordinates": [115.86374, -32.06616] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6150" },
      "geometry": { "type": "Point", "coordinates": [115.83563, -32.06174] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6151" },
      "geometry": { "type": "Point", "coordinates": [115.86482, -31.97961] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6152" },
      "geometry": { "type": "Point", "coordinates": [115.8715, -32.01429] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6153" },
      "geometry": { "type": "Point", "coordinates": [115.84176, -32.02223] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6154" },
      "geometry": { "type": "Point", "coordinates": [115.82566, -32.03684] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6155" },
      "geometry": { "type": "Point", "coordinates": [115.91001, -32.07496] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6156" },
      "geometry": { "type": "Point", "coordinates": [115.80459, -32.03141] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6157" },
      "geometry": { "type": "Point", "coordinates": [115.78666, -32.03329] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6158" },
      "geometry": { "type": "Point", "coordinates": [115.76649, -32.0348] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6159" },
      "geometry": { "type": "Point", "coordinates": [115.74544, -32.03863] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6160" },
      "geometry": { "type": "Point", "coordinates": [115.75534, -32.05391] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6161" },
      "geometry": { "type": "Point", "coordinates": [115.51597, -32.00446] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6162" },
      "geometry": { "type": "Point", "coordinates": [115.7611, -32.07012] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6163" },
      "geometry": { "type": "Point", "coordinates": [115.79145, -32.08887] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6164" },
      "geometry": { "type": "Point", "coordinates": [115.84573, -32.1252] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6165" },
      "geometry": { "type": "Point", "coordinates": [115.80905, -32.19808] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6166" },
      "geometry": { "type": "Point", "coordinates": [115.79588, -32.14361] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6167" },
      "geometry": { "type": "Point", "coordinates": [115.82153, -32.21991] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6168" },
      "geometry": { "type": "Point", "coordinates": [115.73941, -32.25616] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6169" },
      "geometry": { "type": "Point", "coordinates": [115.74867, -32.32585] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6170" },
      "geometry": { "type": "Point", "coordinates": [115.82985, -32.26981] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6171" },
      "geometry": { "type": "Point", "coordinates": [115.83371, -32.3316] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6172" },
      "geometry": { "type": "Point", "coordinates": [115.75181, -32.37095] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6173" },
      "geometry": { "type": "Point", "coordinates": [115.76327, -32.4068] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6174" },
      "geometry": { "type": "Point", "coordinates": [115.76227, -32.42572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6175" },
      "geometry": { "type": "Point", "coordinates": [115.7583, -32.44688] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6176" },
      "geometry": { "type": "Point", "coordinates": [115.79903, -32.40805] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6180" },
      "geometry": { "type": "Point", "coordinates": [115.77378, -32.47867] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6181" },
      "geometry": { "type": "Point", "coordinates": [115.79542, -32.48348] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6182" },
      "geometry": { "type": "Point", "coordinates": [115.82404, -32.4325] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6207" },
      "geometry": { "type": "Point", "coordinates": [115.98677, -32.52626] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6208" },
      "geometry": { "type": "Point", "coordinates": [115.83851, -32.64792] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6209" },
      "geometry": { "type": "Point", "coordinates": [115.7867, -32.545] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6210" },
      "geometry": { "type": "Point", "coordinates": [115.72881, -32.54888] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6211" },
      "geometry": { "type": "Point", "coordinates": [115.64453, -32.70169] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6213" },
      "geometry": { "type": "Point", "coordinates": [116.1059, -32.67194] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6214" },
      "geometry": { "type": "Point", "coordinates": [115.83144, -32.75776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6215" },
      "geometry": { "type": "Point", "coordinates": [115.86792, -32.83383] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6218" },
      "geometry": { "type": "Point", "coordinates": [115.88023, -32.95957] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6219" },
      "geometry": { "type": "Point", "coordinates": [115.87933, -33.00658] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6220" },
      "geometry": { "type": "Point", "coordinates": [115.9645, -32.9892] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6221" },
      "geometry": { "type": "Point", "coordinates": [115.99349, -33.14927] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6223" },
      "geometry": { "type": "Point", "coordinates": [115.84401, -33.17469] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6224" },
      "geometry": { "type": "Point", "coordinates": [115.85966, -33.22509] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6225" },
      "geometry": { "type": "Point", "coordinates": [116.28748, -33.43953] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6226" },
      "geometry": { "type": "Point", "coordinates": [115.8652, -33.29614] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6227" },
      "geometry": { "type": "Point", "coordinates": [115.8497, -33.33113] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6228" },
      "geometry": { "type": "Point", "coordinates": [115.75708, -33.31987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6229" },
      "geometry": { "type": "Point", "coordinates": [115.70771, -33.35094] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6230" },
      "geometry": { "type": "Point", "coordinates": [115.66182, -33.35795] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6232" },
      "geometry": { "type": "Point", "coordinates": [115.71694, -33.31244] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6233" },
      "geometry": { "type": "Point", "coordinates": [115.73889, -33.21536] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6236" },
      "geometry": { "type": "Point", "coordinates": [115.85651, -33.43149] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6237" },
      "geometry": { "type": "Point", "coordinates": [115.65094, -33.50099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6239" },
      "geometry": { "type": "Point", "coordinates": [115.88367, -33.58767] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6240" },
      "geometry": { "type": "Point", "coordinates": [115.96344, -33.53579] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6243" },
      "geometry": { "type": "Point", "coordinates": [116.16124, -33.71219] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6244" },
      "geometry": { "type": "Point", "coordinates": [116.62231, -33.98317] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6251" },
      "geometry": { "type": "Point", "coordinates": [115.88143, -33.72737] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6252" },
      "geometry": { "type": "Point", "coordinates": [115.94949, -33.74988] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6253" },
      "geometry": { "type": "Point", "coordinates": [116.00206, -33.81839] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6254" },
      "geometry": { "type": "Point", "coordinates": [116.05087, -33.85944] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6255" },
      "geometry": { "type": "Point", "coordinates": [116.24669, -33.88199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6256" },
      "geometry": { "type": "Point", "coordinates": [116.22699, -34.05135] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6258" },
      "geometry": { "type": "Point", "coordinates": [116.40106, -34.34316] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6260" },
      "geometry": { "type": "Point", "coordinates": [115.87114, -34.37404] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6262" },
      "geometry": { "type": "Point", "coordinates": [116.32005, -34.71321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6271" },
      "geometry": { "type": "Point", "coordinates": [115.58355, -33.57656] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6275" },
      "geometry": { "type": "Point", "coordinates": [115.6311, -33.99311] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6280" },
      "geometry": { "type": "Point", "coordinates": [115.33256, -33.72099] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6281" },
      "geometry": { "type": "Point", "coordinates": [115.06706, -33.59473] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6282" },
      "geometry": { "type": "Point", "coordinates": [115.05169, -33.69079] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6284" },
      "geometry": { "type": "Point", "coordinates": [115.26933, -33.85815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6285" },
      "geometry": { "type": "Point", "coordinates": [115.19102, -34.01606] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6286" },
      "geometry": { "type": "Point", "coordinates": [115.11546, -34.08211] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6288" },
      "geometry": { "type": "Point", "coordinates": [115.20134, -34.16884] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6290" },
      "geometry": { "type": "Point", "coordinates": [115.15308, -34.27027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6302" },
      "geometry": { "type": "Point", "coordinates": [116.67063, -31.981] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6304" },
      "geometry": { "type": "Point", "coordinates": [116.94638, -32.1583] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6306" },
      "geometry": { "type": "Point", "coordinates": [117.30657, -32.31605] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6308" },
      "geometry": { "type": "Point", "coordinates": [117.00409, -32.58634] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6309" },
      "geometry": { "type": "Point", "coordinates": [117.13962, -32.65974] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6311" },
      "geometry": { "type": "Point", "coordinates": [117.18213, -32.78887] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6312" },
      "geometry": { "type": "Point", "coordinates": [117.3589, -32.96819] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6313" },
      "geometry": { "type": "Point", "coordinates": [117.21871, -33.07582] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6315" },
      "geometry": { "type": "Point", "coordinates": [117.36374, -33.3049] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6316" },
      "geometry": { "type": "Point", "coordinates": [117.371, -33.50293] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6317" },
      "geometry": { "type": "Point", "coordinates": [117.59472, -33.58452] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6318" },
      "geometry": { "type": "Point", "coordinates": [117.63174, -33.89187] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6320" },
      "geometry": { "type": "Point", "coordinates": [117.6007, -34.08344] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6321" },
      "geometry": { "type": "Point", "coordinates": [117.52024, -34.24417] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6322" },
      "geometry": { "type": "Point", "coordinates": [117.45306, -34.38939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6323" },
      "geometry": { "type": "Point", "coordinates": [117.60774, -34.46536] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6324" },
      "geometry": { "type": "Point", "coordinates": [117.74582, -34.61403] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6326" },
      "geometry": { "type": "Point", "coordinates": [117.72391, -34.775] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6327" },
      "geometry": { "type": "Point", "coordinates": [117.61175, -34.89448] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6328" },
      "geometry": { "type": "Point", "coordinates": [118.41936, -34.58847] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6330" },
      "geometry": { "type": "Point", "coordinates": [117.87463, -34.95344] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6333" },
      "geometry": { "type": "Point", "coordinates": [117.11745, -34.914] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6335" },
      "geometry": { "type": "Point", "coordinates": [118.08653, -33.93183] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6336" },
      "geometry": { "type": "Point", "coordinates": [118.57713, -33.98] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6337" },
      "geometry": { "type": "Point", "coordinates": [119.09876, -33.97811] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6338" },
      "geometry": { "type": "Point", "coordinates": [118.54388, -34.32737] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6341" },
      "geometry": { "type": "Point", "coordinates": [118.21026, -33.51442] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6343" },
      "geometry": { "type": "Point", "coordinates": [118.78487, -33.53457] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6346" },
      "geometry": { "type": "Point", "coordinates": [119.86957, -33.86916] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6348" },
      "geometry": { "type": "Point", "coordinates": [120.06628, -33.87973] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6350" },
      "geometry": { "type": "Point", "coordinates": [117.78431, -33.34147] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6351" },
      "geometry": { "type": "Point", "coordinates": [117.94072, -33.18592] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6352" },
      "geometry": { "type": "Point", "coordinates": [118.12279, -33.15556] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6353" },
      "geometry": { "type": "Point", "coordinates": [118.51502, -33.04754] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6355" },
      "geometry": { "type": "Point", "coordinates": [119.23346, -33.03965] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6356" },
      "geometry": { "type": "Point", "coordinates": [119.86204, -33.06051] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6357" },
      "geometry": { "type": "Point", "coordinates": [118.80225, -32.68258] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6358" },
      "geometry": { "type": "Point", "coordinates": [118.62799, -32.40722] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6359" },
      "geometry": { "type": "Point", "coordinates": [119.34312, -32.56596] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6361" },
      "geometry": { "type": "Point", "coordinates": [117.80386, -32.98468] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6363" },
      "geometry": { "type": "Point", "coordinates": [118.1421, -32.92519] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6365" },
      "geometry": { "type": "Point", "coordinates": [118.18861, -32.71834] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6367" },
      "geometry": { "type": "Point", "coordinates": [118.31106, -32.42255] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6368" },
      "geometry": { "type": "Point", "coordinates": [118.48812, -32.19934] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6369" },
      "geometry": { "type": "Point", "coordinates": [118.78112, -32.04842] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6370" },
      "geometry": { "type": "Point", "coordinates": [117.61175, -32.77661] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6372" },
      "geometry": { "type": "Point", "coordinates": [117.67297, -32.63405] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6373" },
      "geometry": { "type": "Point", "coordinates": [117.7117, -32.50501] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6375" },
      "geometry": { "type": "Point", "coordinates": [117.91261, -32.28742] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6383" },
      "geometry": { "type": "Point", "coordinates": [117.36971, -32.00809] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6384" },
      "geometry": { "type": "Point", "coordinates": [117.65147, -31.96246] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6385" },
      "geometry": { "type": "Point", "coordinates": [117.73785, -32.00766] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6386" },
      "geometry": { "type": "Point", "coordinates": [117.8457, -31.9592] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6390" },
      "geometry": { "type": "Point", "coordinates": [116.39175, -32.73466] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6391" },
      "geometry": { "type": "Point", "coordinates": [116.77282, -33.07724] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6392" },
      "geometry": { "type": "Point", "coordinates": [116.75315, -33.36628] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6393" },
      "geometry": { "type": "Point", "coordinates": [116.74341, -33.55569] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6394" },
      "geometry": { "type": "Point", "coordinates": [116.95088, -33.7869] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6395" },
      "geometry": { "type": "Point", "coordinates": [117.09122, -34.00134] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6396" },
      "geometry": { "type": "Point", "coordinates": [116.95581, -34.34314] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6397" },
      "geometry": { "type": "Point", "coordinates": [117.00182, -34.5853] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6398" },
      "geometry": { "type": "Point", "coordinates": [116.58264, -34.77809] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6401" },
      "geometry": { "type": "Point", "coordinates": [116.74677, -31.56294] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6403" },
      "geometry": { "type": "Point", "coordinates": [116.81028, -31.64291] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6405" },
      "geometry": { "type": "Point", "coordinates": [117.0426, -31.55838] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6407" },
      "geometry": { "type": "Point", "coordinates": [117.23288, -31.57189] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6409" },
      "geometry": { "type": "Point", "coordinates": [117.48125, -31.67767] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6410" },
      "geometry": { "type": "Point", "coordinates": [117.71483, -31.69619] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6411" },
      "geometry": { "type": "Point", "coordinates": [117.86263, -31.58483] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6412" },
      "geometry": { "type": "Point", "coordinates": [117.95184, -31.44541] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6413" },
      "geometry": { "type": "Point", "coordinates": [118.04028, -31.56029] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6414" },
      "geometry": { "type": "Point", "coordinates": [118.19189, -31.53232] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6415" },
      "geometry": { "type": "Point", "coordinates": [118.33123, -31.50072] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6418" },
      "geometry": { "type": "Point", "coordinates": [118.20287, -31.8344] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6419" },
      "geometry": { "type": "Point", "coordinates": [118.12831, -32.03175] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6420" },
      "geometry": { "type": "Point", "coordinates": [118.58164, -31.84701] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6421" },
      "geometry": { "type": "Point", "coordinates": [118.58874, -31.38346] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6422" },
      "geometry": { "type": "Point", "coordinates": [118.61039, -31.41449] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6423" },
      "geometry": { "type": "Point", "coordinates": [118.78049, -31.03305] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6424" },
      "geometry": { "type": "Point", "coordinates": [118.89111, -31.34018] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6425" },
      "geometry": { "type": "Point", "coordinates": [119.1576, -31.39335] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6426" },
      "geometry": { "type": "Point", "coordinates": [119.28316, -31.37893] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6427" },
      "geometry": { "type": "Point", "coordinates": [119.57604, -30.83892] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6428" },
      "geometry": { "type": "Point", "coordinates": [118.02628, -32.14029] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6429" },
      "geometry": { "type": "Point", "coordinates": [120.52754, -31.41114] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6430" },
      "geometry": { "type": "Point", "coordinates": [121.43973, -30.74008] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6431" },
      "geometry": { "type": "Point", "coordinates": [124.72115, -29.21289] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6432" },
      "geometry": { "type": "Point", "coordinates": [121.49242, -30.7816] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6434" },
      "geometry": { "type": "Point", "coordinates": [124.69764, -30.72195] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6436" },
      "geometry": { "type": "Point", "coordinates": [119.99567, -29.54012] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6437" },
      "geometry": { "type": "Point", "coordinates": [120.62866, -28.1263] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6438" },
      "geometry": { "type": "Point", "coordinates": [121.52021, -28.60783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6440" },
      "geometry": { "type": "Point", "coordinates": [123.39231, -27.74529] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6442" },
      "geometry": { "type": "Point", "coordinates": [121.65484, -31.19691] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6443" },
      "geometry": { "type": "Point", "coordinates": [125.63759, -31.80254] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6445" },
      "geometry": { "type": "Point", "coordinates": [120.93943, -32.97553] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6446" },
      "geometry": { "type": "Point", "coordinates": [121.82216, -33.25467] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6447" },
      "geometry": { "type": "Point", "coordinates": [122.09047, -33.32872] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6448" },
      "geometry": { "type": "Point", "coordinates": [121.80514, -33.65231] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6450" },
      "geometry": { "type": "Point", "coordinates": [121.79613, -33.63137] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6452" },
      "geometry": { "type": "Point", "coordinates": [123.20867, -33.41326] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6460" },
      "geometry": { "type": "Point", "coordinates": [116.86314, -31.24185] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6461" },
      "geometry": { "type": "Point", "coordinates": [117.03612, -31.11602] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6462" },
      "geometry": { "type": "Point", "coordinates": [117.14044, -31.21936] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6463" },
      "geometry": { "type": "Point", "coordinates": [117.29271, -31.13692] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6465" },
      "geometry": { "type": "Point", "coordinates": [117.13866, -30.89251] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6466" },
      "geometry": { "type": "Point", "coordinates": [117.1273, -30.72954] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6467" },
      "geometry": { "type": "Point", "coordinates": [117.15159, -30.55197] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6468" },
      "geometry": { "type": "Point", "coordinates": [117.29788, -30.08261] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6470" },
      "geometry": { "type": "Point", "coordinates": [117.33956, -30.46297] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6472" },
      "geometry": { "type": "Point", "coordinates": [117.80051, -29.99664] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6473" },
      "geometry": { "type": "Point", "coordinates": [118.14346, -30.45238] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6475" },
      "geometry": { "type": "Point", "coordinates": [117.45462, -30.59522] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6476" },
      "geometry": { "type": "Point", "coordinates": [117.68281, -30.70654] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6477" },
      "geometry": { "type": "Point", "coordinates": [117.94317, -30.78433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6479" },
      "geometry": { "type": "Point", "coordinates": [118.40007, -30.74515] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6480" },
      "geometry": { "type": "Point", "coordinates": [118.22814, -31.31491] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6484" },
      "geometry": { "type": "Point", "coordinates": [119.37282, -30.63525] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6485" },
      "geometry": { "type": "Point", "coordinates": [117.43563, -31.20046] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6487" },
      "geometry": { "type": "Point", "coordinates": [117.67239, -31.19128] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6488" },
      "geometry": { "type": "Point", "coordinates": [117.80297, -31.13859] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6489" },
      "geometry": { "type": "Point", "coordinates": [117.92961, -31.09899] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6490" },
      "geometry": { "type": "Point", "coordinates": [118.11983, -31.15462] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6501" },
      "geometry": { "type": "Point", "coordinates": [115.94158, -31.55902] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6502" },
      "geometry": { "type": "Point", "coordinates": [116.13189, -31.34939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6503" },
      "geometry": { "type": "Point", "coordinates": [115.84082, -31.15205] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6504" },
      "geometry": { "type": "Point", "coordinates": [116.06969, -31.31137] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6505" },
      "geometry": { "type": "Point", "coordinates": [116.16945, -31.1619] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6506" },
      "geometry": { "type": "Point", "coordinates": [116.06931, -31.01667] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6507" },
      "geometry": { "type": "Point", "coordinates": [115.63028, -30.72212] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6509" },
      "geometry": { "type": "Point", "coordinates": [116.24716, -30.95356] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6510" },
      "geometry": { "type": "Point", "coordinates": [116.14178, -30.69496] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6511" },
      "geometry": { "type": "Point", "coordinates": [115.07292, -30.50306] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6512" },
      "geometry": { "type": "Point", "coordinates": [116.0545, -30.42199] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6513" },
      "geometry": { "type": "Point", "coordinates": [116.14371, -30.2059] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6514" },
      "geometry": { "type": "Point", "coordinates": [115.01866, -30.0346] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6515" },
      "geometry": { "type": "Point", "coordinates": [115.99355, -30.00042] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6516" },
      "geometry": { "type": "Point", "coordinates": [115.07427, -30.25144] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6517" },
      "geometry": { "type": "Point", "coordinates": [115.93095, -29.67294] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6518" },
      "geometry": { "type": "Point", "coordinates": [115.25479, -29.89611] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6519" },
      "geometry": { "type": "Point", "coordinates": [115.62274, -29.53974] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6521" },
      "geometry": { "type": "Point", "coordinates": [115.44603, -30.41939] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6522" },
      "geometry": { "type": "Point", "coordinates": [115.51355, -29.18991] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6525" },
      "geometry": { "type": "Point", "coordinates": [115.10248, -29.37397] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6528" },
      "geometry": { "type": "Point", "coordinates": [114.84026, -28.98417] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6530" },
      "geometry": { "type": "Point", "coordinates": [114.06541, -28.66723] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6532" },
      "geometry": { "type": "Point", "coordinates": [114.73676, -27.97135] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6535" },
      "geometry": { "type": "Point", "coordinates": [114.43981, -28.10035] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6536" },
      "geometry": { "type": "Point", "coordinates": [114.34124, -27.61634] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6537" },
      "geometry": { "type": "Point", "coordinates": [113.35171, -26.00433] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6556" },
      "geometry": { "type": "Point", "coordinates": [116.30957, -31.88693] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6558" },
      "geometry": { "type": "Point", "coordinates": [116.33137, -31.81188] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6560" },
      "geometry": { "type": "Point", "coordinates": [116.3754, -31.76319] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6562" },
      "geometry": { "type": "Point", "coordinates": [116.4578, -31.78993] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6564" },
      "geometry": { "type": "Point", "coordinates": [116.52714, -31.7146] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6566" },
      "geometry": { "type": "Point", "coordinates": [116.47705, -31.53248] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6567" },
      "geometry": { "type": "Point", "coordinates": [116.29941, -31.43852] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6568" },
      "geometry": { "type": "Point", "coordinates": [116.48485, -31.23683] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6569" },
      "geometry": { "type": "Point", "coordinates": [116.43229, -31.0864] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6571" },
      "geometry": { "type": "Point", "coordinates": [116.45953, -30.93436] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6572" },
      "geometry": { "type": "Point", "coordinates": [116.40075, -30.80876] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6574" },
      "geometry": { "type": "Point", "coordinates": [116.35271, -30.61966] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6575" },
      "geometry": { "type": "Point", "coordinates": [116.35413, -30.42247] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6603" },
      "geometry": { "type": "Point", "coordinates": [116.65942, -30.85355] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6605" },
      "geometry": { "type": "Point", "coordinates": [116.85993, -30.7025] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6606" },
      "geometry": { "type": "Point", "coordinates": [116.78716, -30.56209] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6608" },
      "geometry": { "type": "Point", "coordinates": [116.70338, -30.43806] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6609" },
      "geometry": { "type": "Point", "coordinates": [116.59959, -30.24316] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6612" },
      "geometry": { "type": "Point", "coordinates": [117.08188, -29.54342] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6613" },
      "geometry": { "type": "Point", "coordinates": [116.52814, -29.98215] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6614" },
      "geometry": { "type": "Point", "coordinates": [116.51985, -29.85039] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6616" },
      "geometry": { "type": "Point", "coordinates": [116.50168, -29.74637] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6620" },
      "geometry": { "type": "Point", "coordinates": [116.70293, -29.33746] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6623" },
      "geometry": { "type": "Point", "coordinates": [116.14549, -29.14956] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6625" },
      "geometry": { "type": "Point", "coordinates": [115.86164, -29.22173] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6627" },
      "geometry": { "type": "Point", "coordinates": [115.88529, -28.89415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6628" },
      "geometry": { "type": "Point", "coordinates": [115.75586, -28.75175] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6630" },
      "geometry": { "type": "Point", "coordinates": [115.85262, -27.21396] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6631" },
      "geometry": { "type": "Point", "coordinates": [115.97542, -28.53612] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6632" },
      "geometry": { "type": "Point", "coordinates": [115.2422, -28.59027] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6635" },
      "geometry": { "type": "Point", "coordinates": [116.72879, -27.77764] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6638" },
      "geometry": { "type": "Point", "coordinates": [117.86841, -28.18799] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6639" },
      "geometry": { "type": "Point", "coordinates": [118.76072, -28.67907] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6640" },
      "geometry": { "type": "Point", "coordinates": [117.59486, -26.9167] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6642" },
      "geometry": { "type": "Point", "coordinates": [118.8055, -25.80228] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6646" },
      "geometry": { "type": "Point", "coordinates": [121.07851, -25.93346] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6701" },
      "geometry": { "type": "Point", "coordinates": [114.09315, -24.37321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6705" },
      "geometry": { "type": "Point", "coordinates": [116.42085, -24.64125] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6707" },
      "geometry": { "type": "Point", "coordinates": [114.19929, -22.17239] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6710" },
      "geometry": { "type": "Point", "coordinates": [115.195, -22.46667] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6712" },
      "geometry": { "type": "Point", "coordinates": [115.44126, -20.65007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6713" },
      "geometry": { "type": "Point", "coordinates": [116.80178, -20.51648] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6714" },
      "geometry": { "type": "Point", "coordinates": [117.01589, -21.07225] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6716" },
      "geometry": { "type": "Point", "coordinates": [116.83701, -21.90152] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6718" },
      "geometry": { "type": "Point", "coordinates": [117.42316, -20.79275] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6720" },
      "geometry": { "type": "Point", "coordinates": [117.18807, -20.65558] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6721" },
      "geometry": { "type": "Point", "coordinates": [118.79257, -20.42769] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6722" },
      "geometry": { "type": "Point", "coordinates": [118.96485, -20.22775] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6725" },
      "geometry": { "type": "Point", "coordinates": [122.29523, -18.28689] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6726" },
      "geometry": { "type": "Point", "coordinates": [122.21031, -17.94695] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6728" },
      "geometry": { "type": "Point", "coordinates": [124.69008, -17.8745] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6740" },
      "geometry": { "type": "Point", "coordinates": [126.11722, -15.24692] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6743" },
      "geometry": { "type": "Point", "coordinates": [127.42084, -15.92705] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6751" },
      "geometry": { "type": "Point", "coordinates": [117.1349, -22.82941] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6753" },
      "geometry": { "type": "Point", "coordinates": [120.5451, -23.01513] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6754" },
      "geometry": { "type": "Point", "coordinates": [117.69713, -23.19864] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6758" },
      "geometry": { "type": "Point", "coordinates": [120.27935, -22.01564] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6760" },
      "geometry": { "type": "Point", "coordinates": [119.48351, -21.38382] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6762" },
      "geometry": { "type": "Point", "coordinates": [122.6555, -21.28528] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6765" },
      "geometry": { "type": "Point", "coordinates": [124.95256, -18.06094] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6770" },
      "geometry": { "type": "Point", "coordinates": [127.62629, -18.45689] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6798" },
      "geometry": { "type": "Point", "coordinates": [105.63375, -10.48649] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "6799" },
      "geometry": { "type": "Point", "coordinates": [96.86971, -12.09028] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7000" },
      "geometry": { "type": "Point", "coordinates": [147.31532, -42.87622] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7004" },
      "geometry": { "type": "Point", "coordinates": [147.29735, -42.89401] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7005" },
      "geometry": { "type": "Point", "coordinates": [147.34034, -42.91105] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7007" },
      "geometry": { "type": "Point", "coordinates": [147.32762, -42.9197] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7008" },
      "geometry": { "type": "Point", "coordinates": [147.29023, -42.86322] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7009" },
      "geometry": { "type": "Point", "coordinates": [147.29802, -42.8398] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7010" },
      "geometry": { "type": "Point", "coordinates": [147.26141, -42.83613] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7011" },
      "geometry": { "type": "Point", "coordinates": [147.22941, -42.79459] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7012" },
      "geometry": { "type": "Point", "coordinates": [147.18031, -42.83297] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7015" },
      "geometry": { "type": "Point", "coordinates": [147.3574, -42.83712] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7016" },
      "geometry": { "type": "Point", "coordinates": [147.37399, -42.8088] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7017" },
      "geometry": { "type": "Point", "coordinates": [147.32169, -42.72047] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7018" },
      "geometry": { "type": "Point", "coordinates": [147.39751, -42.8848] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7019" },
      "geometry": { "type": "Point", "coordinates": [147.43943, -42.89456] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7020" },
      "geometry": { "type": "Point", "coordinates": [147.49884, -42.95862] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7021" },
      "geometry": { "type": "Point", "coordinates": [147.49079, -42.90815] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7022" },
      "geometry": { "type": "Point", "coordinates": [147.44276, -43.03523] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7023" },
      "geometry": { "type": "Point", "coordinates": [147.40912, -42.98842] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7024" },
      "geometry": { "type": "Point", "coordinates": [147.52517, -42.95188] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7025" },
      "geometry": { "type": "Point", "coordinates": [147.40134, -42.74743] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7026" },
      "geometry": { "type": "Point", "coordinates": [147.43946, -42.61997] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7027" },
      "geometry": { "type": "Point", "coordinates": [147.38349, -42.53007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7030" },
      "geometry": { "type": "Point", "coordinates": [147.01375, -42.2697] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7050" },
      "geometry": { "type": "Point", "coordinates": [147.28963, -42.96618] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7052" },
      "geometry": { "type": "Point", "coordinates": [147.31817, -43.00415] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7053" },
      "geometry": { "type": "Point", "coordinates": [147.34077, -42.95392] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7054" },
      "geometry": { "type": "Point", "coordinates": [147.20012, -42.97787] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7055" },
      "geometry": { "type": "Point", "coordinates": [147.29758, -43.00144] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7109" },
      "geometry": { "type": "Point", "coordinates": [146.92036, -43.13024] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7112" },
      "geometry": { "type": "Point", "coordinates": [147.1228, -43.17311] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7113" },
      "geometry": { "type": "Point", "coordinates": [146.98203, -43.08542] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7116" },
      "geometry": { "type": "Point", "coordinates": [146.19362, -42.70467] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7117" },
      "geometry": { "type": "Point", "coordinates": [147.01797, -43.30588] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7119" },
      "geometry": { "type": "Point", "coordinates": [147.38721, -42.40471] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7120" },
      "geometry": { "type": "Point", "coordinates": [147.48824, -42.36065] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7139" },
      "geometry": { "type": "Point", "coordinates": [146.08805, -42.7338] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7140" },
      "geometry": { "type": "Point", "coordinates": [146.37282, -42.29783] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7150" },
      "geometry": { "type": "Point", "coordinates": [147.27434, -43.23584] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7155" },
      "geometry": { "type": "Point", "coordinates": [147.23228, -43.12612] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7162" },
      "geometry": { "type": "Point", "coordinates": [147.22415, -43.16883] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7163" },
      "geometry": { "type": "Point", "coordinates": [147.23642, -43.21956] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7170" },
      "geometry": { "type": "Point", "coordinates": [147.48831, -42.83697] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7171" },
      "geometry": { "type": "Point", "coordinates": [147.49859, -42.77104] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7172" },
      "geometry": { "type": "Point", "coordinates": [147.62433, -42.73677] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7173" },
      "geometry": { "type": "Point", "coordinates": [147.67452, -42.84344] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7174" },
      "geometry": { "type": "Point", "coordinates": [147.76935, -42.82887] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7175" },
      "geometry": { "type": "Point", "coordinates": [147.85675, -42.79078] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7176" },
      "geometry": { "type": "Point", "coordinates": [147.79288, -42.76927] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7177" },
      "geometry": { "type": "Point", "coordinates": [147.88634, -42.8833] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7178" },
      "geometry": { "type": "Point", "coordinates": [147.88837, -42.94676] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7179" },
      "geometry": { "type": "Point", "coordinates": [147.92047, -42.99987] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7180" },
      "geometry": { "type": "Point", "coordinates": [147.86067, -43.0613] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7182" },
      "geometry": { "type": "Point", "coordinates": [147.91205, -43.14685] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7183" },
      "geometry": { "type": "Point", "coordinates": [147.77353, -43.15213] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7184" },
      "geometry": { "type": "Point", "coordinates": [147.72079, -43.13377] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7185" },
      "geometry": { "type": "Point", "coordinates": [147.76062, -43.05669] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7186" },
      "geometry": { "type": "Point", "coordinates": [147.68558, -43.00366] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7187" },
      "geometry": { "type": "Point", "coordinates": [147.81421, -43.08384] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7190" },
      "geometry": { "type": "Point", "coordinates": [147.97821, -42.35901] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7209" },
      "geometry": { "type": "Point", "coordinates": [147.56864, -42.12572] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7210" },
      "geometry": { "type": "Point", "coordinates": [147.56696, -41.96052] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7211" },
      "geometry": { "type": "Point", "coordinates": [147.35737, -41.76073] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7212" },
      "geometry": { "type": "Point", "coordinates": [147.44912, -41.57737] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7213" },
      "geometry": { "type": "Point", "coordinates": [147.90318, -41.76728] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7214" },
      "geometry": { "type": "Point", "coordinates": [147.89835, -41.53843] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7215" },
      "geometry": { "type": "Point", "coordinates": [148.22775, -41.80519] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7216" },
      "geometry": { "type": "Point", "coordinates": [148.1248, -41.27956] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7248" },
      "geometry": { "type": "Point", "coordinates": [147.13975, -41.40245] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7249" },
      "geometry": { "type": "Point", "coordinates": [147.16448, -41.47115] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7250" },
      "geometry": { "type": "Point", "coordinates": [147.14027, -41.44365] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7252" },
      "geometry": { "type": "Point", "coordinates": [147.04958, -41.16241] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7253" },
      "geometry": { "type": "Point", "coordinates": [146.90575, -41.11272] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7254" },
      "geometry": { "type": "Point", "coordinates": [147.21865, -41.10254] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7255" },
      "geometry": { "type": "Point", "coordinates": [147.50093, -39.74344] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7256" },
      "geometry": { "type": "Point", "coordinates": [143.98847, -39.86321] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7257" },
      "geometry": { "type": "Point", "coordinates": [148.15107, -40.40007] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7258" },
      "geometry": { "type": "Point", "coordinates": [147.27263, -41.50178] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7259" },
      "geometry": { "type": "Point", "coordinates": [147.35119, -41.38022] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7260" },
      "geometry": { "type": "Point", "coordinates": [147.51202, -41.13776] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7261" },
      "geometry": { "type": "Point", "coordinates": [147.72957, -41.13982] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7262" },
      "geometry": { "type": "Point", "coordinates": [147.57421, -40.98778] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7263" },
      "geometry": { "type": "Point", "coordinates": [147.71801, -41.26915] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7264" },
      "geometry": { "type": "Point", "coordinates": [147.98557, -41.0518] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7265" },
      "geometry": { "type": "Point", "coordinates": [147.81446, -41.04897] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7267" },
      "geometry": { "type": "Point", "coordinates": [147.13368, -41.25764] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7268" },
      "geometry": { "type": "Point", "coordinates": [147.21472, -41.30604] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7270" },
      "geometry": { "type": "Point", "coordinates": [146.80616, -41.17171] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7275" },
      "geometry": { "type": "Point", "coordinates": [146.79022, -41.33346] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7276" },
      "geometry": { "type": "Point", "coordinates": [146.9644, -41.28429] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7277" },
      "geometry": { "type": "Point", "coordinates": [147.00452, -41.36586] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7290" },
      "geometry": { "type": "Point", "coordinates": [147.05937, -41.5126] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7291" },
      "geometry": { "type": "Point", "coordinates": [147.02144, -41.53853] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7292" },
      "geometry": { "type": "Point", "coordinates": [146.96043, -41.46703] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7300" },
      "geometry": { "type": "Point", "coordinates": [147.21278, -41.61839] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7301" },
      "geometry": { "type": "Point", "coordinates": [146.93681, -41.65907] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7302" },
      "geometry": { "type": "Point", "coordinates": [147.02652, -41.74787] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7303" },
      "geometry": { "type": "Point", "coordinates": [146.85352, -41.52091] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7304" },
      "geometry": { "type": "Point", "coordinates": [146.41032, -41.78481] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7305" },
      "geometry": { "type": "Point", "coordinates": [146.4296, -41.36219] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7306" },
      "geometry": { "type": "Point", "coordinates": [146.01453, -41.64049] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7307" },
      "geometry": { "type": "Point", "coordinates": [146.54135, -41.22684] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7310" },
      "geometry": { "type": "Point", "coordinates": [146.20561, -41.34799] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7315" },
      "geometry": { "type": "Point", "coordinates": [146.09527, -41.30337] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7316" },
      "geometry": { "type": "Point", "coordinates": [145.96059, -41.23893] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7320" },
      "geometry": { "type": "Point", "coordinates": [145.88953, -41.0721] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7321" },
      "geometry": { "type": "Point", "coordinates": [145.48118, -41.27681] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7322" },
      "geometry": { "type": "Point", "coordinates": [145.79819, -41.05975] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7325" },
      "geometry": { "type": "Point", "coordinates": [145.62254, -41.10666] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7330" },
      "geometry": { "type": "Point", "coordinates": [144.90764, -40.95979] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7331" },
      "geometry": { "type": "Point", "coordinates": [145.27085, -40.75621] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7466" },
      "geometry": { "type": "Point", "coordinates": [145.61684, -42.08285] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7467" },
      "geometry": { "type": "Point", "coordinates": [145.54157, -42.06931] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7468" },
      "geometry": { "type": "Point", "coordinates": [145.37791, -42.16541] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7469" },
      "geometry": { "type": "Point", "coordinates": [145.22315, -41.60481] }
    },
    {
      "type": "Feature",
      "properties": { "POA_CODE21": "7470" },
      "geometry": { "type": "Point", "coordinates": [145.53977, -41.79531] }
    }
  ]
}
